import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import Dropdown from 'react-bootstrap/Dropdown';
import Header from '../../components/Header';
import { ventrisConfig } from '../../ventris.config';

type TestDELVProps = {
};

const subtests: any = {
  'Syntax Domain': {
    maxScore: 38
  },
  'Pragmatics Domain': {
    maxScore: 24
  },
  'Semantics Domain': {
    maxScore: 46
  },
  'Phonology Domain': {
    maxScore: 25
  }
}

const scaledScores: any = [
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "scaled_score": 19,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 38,
    "semantics_high": 46,
    "percentile_rank": 99.9
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "scaled_score": 18,
    "syntax_low": 38,
    "syntax_high": 38,
    "pragmatics_low": 24,
    "pragmatics_high": 24,
    "semantics_low": 37,
    "semantics_high": 37,
    "percentile_rank": 99.6
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "scaled_score": 17,
    "syntax_low": 36,
    "syntax_high": 37,
    "pragmatics_low": 23,
    "pragmatics_high": 23,
    "semantics_low": 36,
    "semantics_high": 36,
    "percentile_rank": 99
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "scaled_score": 16,
    "syntax_low": 34,
    "syntax_high": 35,
    "pragmatics_low": 21,
    "pragmatics_high": 22,
    "semantics_low": 34,
    "semantics_high": 35,
    "percentile_rank": 98
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "scaled_score": 15,
    "syntax_low": 32,
    "syntax_high": 33,
    "pragmatics_low": 19,
    "pragmatics_high": 20,
    "semantics_low": 32,
    "semantics_high": 33,
    "percentile_rank": 95
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "scaled_score": 14,
    "syntax_low": 29,
    "syntax_high": 31,
    "pragmatics_low": 17,
    "pragmatics_high": 18,
    "semantics_low": 31,
    "semantics_high": 31,
    "percentile_rank": 91
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "scaled_score": 13,
    "syntax_low": 27,
    "syntax_high": 28,
    "pragmatics_low": 15,
    "pragmatics_high": 16,
    "semantics_low": 29,
    "semantics_high": 30,
    "percentile_rank": 84
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "scaled_score": 12,
    "syntax_low": 25,
    "syntax_high": 26,
    "pragmatics_low": 13,
    "pragmatics_high": 14,
    "semantics_low": 27,
    "semantics_high": 28,
    "percentile_rank": 75
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "scaled_score": 11,
    "syntax_low": 22,
    "syntax_high": 24,
    "pragmatics_low": 11,
    "pragmatics_high": 12,
    "semantics_low": 24,
    "semantics_high": 26,
    "percentile_rank": 63
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "scaled_score": 10,
    "syntax_low": 20,
    "syntax_high": 21,
    "pragmatics_low": 9,
    "pragmatics_high": 10,
    "semantics_low": 22,
    "semantics_high": 23,
    "percentile_rank": 50
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "scaled_score": 9,
    "syntax_low": 17,
    "syntax_high": 19,
    "pragmatics_low": 7,
    "pragmatics_high": 8,
    "semantics_low": 20,
    "semantics_high": 21,
    "percentile_rank": 37
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "scaled_score": 8,
    "syntax_low": 15,
    "syntax_high": 16,
    "pragmatics_low": 5,
    "pragmatics_high": 6,
    "semantics_low": 18,
    "semantics_high": 19,
    "percentile_rank": 25
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "scaled_score": 7,
    "syntax_low": 12,
    "syntax_high": 14,
    "pragmatics_low": 3,
    "pragmatics_high": 4,
    "semantics_low": 15,
    "semantics_high": 17,
    "percentile_rank": 16
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "scaled_score": 6,
    "syntax_low": 10,
    "syntax_high": 11,
    "pragmatics_low": 2,
    "pragmatics_high": 2,
    "semantics_low": 13,
    "semantics_high": 14,
    "percentile_rank": 9
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "scaled_score": 5,
    "syntax_low": 7,
    "syntax_high": 9,
    "pragmatics_low": 1,
    "pragmatics_high": 1,
    "semantics_low": 10,
    "semantics_high": 12,
    "percentile_rank": 5
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "scaled_score": 4,
    "syntax_low": 5,
    "syntax_high": 6,
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 8,
    "semantics_high": 9,
    "percentile_rank": 2
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "scaled_score": 3,
    "syntax_low": 3,
    "syntax_high": 4,
    "pragmatics_low": 0,
    "pragmatics_high": 0,
    "semantics_low": 5,
    "semantics_high": 7,
    "percentile_rank": 1
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "scaled_score": 2,
    "syntax_low": 1,
    "syntax_high": 2,
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 2,
    "semantics_high": 4,
    "percentile_rank": 0.4
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "scaled_score": 1,
    "syntax_low": 0,
    "syntax_high": 0,
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 0,
    "semantics_high": 1,
    "percentile_rank": 0.1
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "scaled_score": 19,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 39,
    "semantics_high": 46,
    "percentile_rank": 99.9
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "scaled_score": 18,
    "syntax_low": 38,
    "syntax_high": 38,
    "pragmatics_low": 24,
    "pragmatics_high": 24,
    "semantics_low": 38,
    "semantics_high": 38,
    "percentile_rank": 99.6
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "scaled_score": 17,
    "syntax_low": 37,
    "syntax_high": 37,
    "pragmatics_low": 23,
    "pragmatics_high": 23,
    "semantics_low": 37,
    "semantics_high": 37,
    "percentile_rank": 99
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "scaled_score": 16,
    "syntax_low": 36,
    "syntax_high": 36,
    "pragmatics_low": 22,
    "pragmatics_high": 22,
    "semantics_low": 36,
    "semantics_high": 36,
    "percentile_rank": 98
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "scaled_score": 15,
    "syntax_low": 34,
    "syntax_high": 35,
    "pragmatics_low": 21,
    "pragmatics_high": 21,
    "semantics_low": 34,
    "semantics_high": 35,
    "percentile_rank": 95
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "scaled_score": 14,
    "syntax_low": 32,
    "syntax_high": 33,
    "pragmatics_low": 19,
    "pragmatics_high": 20,
    "semantics_low": 33,
    "semantics_high": 33,
    "percentile_rank": 91
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "scaled_score": 13,
    "syntax_low": 30,
    "syntax_high": 31,
    "pragmatics_low": 17,
    "pragmatics_high": 18,
    "semantics_low": 31,
    "semantics_high": 32,
    "percentile_rank": 84
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "scaled_score": 12,
    "syntax_low": 28,
    "syntax_high": 29,
    "pragmatics_low": 15,
    "pragmatics_high": 16,
    "semantics_low": 29,
    "semantics_high": 30,
    "percentile_rank": 75
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "scaled_score": 11,
    "syntax_low": 26,
    "syntax_high": 27,
    "pragmatics_low": 13,
    "pragmatics_high": 14,
    "semantics_low": 27,
    "semantics_high": 28,
    "percentile_rank": 63
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "scaled_score": 10,
    "syntax_low": 24,
    "syntax_high": 25,
    "pragmatics_low": 12,
    "pragmatics_high": 12,
    "semantics_low": 25,
    "semantics_high": 26,
    "percentile_rank": 50
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "scaled_score": 9,
    "syntax_low": 21,
    "syntax_high": 23,
    "pragmatics_low": 10,
    "pragmatics_high": 11,
    "semantics_low": 22,
    "semantics_high": 24,
    "percentile_rank": 37
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "scaled_score": 8,
    "syntax_low": 18,
    "syntax_high": 20,
    "pragmatics_low": 8,
    "pragmatics_high": 9,
    "semantics_low": 20,
    "semantics_high": 21,
    "percentile_rank": 25
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "scaled_score": 7,
    "syntax_low": 16,
    "syntax_high": 17,
    "pragmatics_low": 6,
    "pragmatics_high": 7,
    "semantics_low": 18,
    "semantics_high": 19,
    "percentile_rank": 16
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "scaled_score": 6,
    "syntax_low": 13,
    "syntax_high": 15,
    "pragmatics_low": 4,
    "pragmatics_high": 5,
    "semantics_low": 15,
    "semantics_high": 17,
    "percentile_rank": 9
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "scaled_score": 5,
    "syntax_low": 10,
    "syntax_high": 12,
    "pragmatics_low": 2,
    "pragmatics_high": 3,
    "semantics_low": 13,
    "semantics_high": 14,
    "percentile_rank": 5
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "scaled_score": 4,
    "syntax_low": 7,
    "syntax_high": 9,
    "pragmatics_low": 1,
    "pragmatics_high": 1,
    "semantics_low": 10,
    "semantics_high": 12,
    "percentile_rank": 2
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "scaled_score": 3,
    "syntax_low": 4,
    "syntax_high": 6,
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 8,
    "semantics_high": 9,
    "percentile_rank": 1
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "scaled_score": 2,
    "syntax_low": 2,
    "syntax_high": 3,
    "pragmatics_low": 0,
    "pragmatics_high": 0,
    "semantics_low": 5,
    "semantics_high": 7,
    "percentile_rank": 0.4
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "scaled_score": 1,
    "syntax_low": 0,
    "syntax_high": 1,
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 0,
    "semantics_high": 4,
    "percentile_rank": 0.1
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "scaled_score": 19,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 41,
    "semantics_high": 46,
    "percentile_rank": 99.9
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "scaled_score": 18,
    "syntax_low": 38,
    "syntax_high": 38,
    "pragmatics_low": 24,
    "pragmatics_high": 24,
    "semantics_low": 40,
    "semantics_high": 40,
    "percentile_rank": 99.6
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "scaled_score": 17,
    "syntax_low": 37,
    "syntax_high": 37,
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 39,
    "semantics_high": 39,
    "percentile_rank": 99
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "scaled_score": 16,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": 23,
    "pragmatics_high": 23,
    "semantics_low": 37,
    "semantics_high": 38,
    "percentile_rank": 98
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "scaled_score": 15,
    "syntax_low": 36,
    "syntax_high": 36,
    "pragmatics_low": 22,
    "pragmatics_high": 22,
    "semantics_low": 36,
    "semantics_high": 36,
    "percentile_rank": 95
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "scaled_score": 14,
    "syntax_low": 34,
    "syntax_high": 35,
    "pragmatics_low": 20,
    "pragmatics_high": 21,
    "semantics_low": 34,
    "semantics_high": 35,
    "percentile_rank": 91
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "scaled_score": 13,
    "syntax_low": 33,
    "syntax_high": 33,
    "pragmatics_low": 19,
    "pragmatics_high": 19,
    "semantics_low": 33,
    "semantics_high": 33,
    "percentile_rank": 84
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "scaled_score": 12,
    "syntax_low": 31,
    "syntax_high": 32,
    "pragmatics_low": 18,
    "pragmatics_high": 18,
    "semantics_low": 31,
    "semantics_high": 32,
    "percentile_rank": 75
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "scaled_score": 11,
    "syntax_low": 29,
    "syntax_high": 30,
    "pragmatics_low": 16,
    "pragmatics_high": 17,
    "semantics_low": 29,
    "semantics_high": 30,
    "percentile_rank": 63
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "scaled_score": 10,
    "syntax_low": 27,
    "syntax_high": 28,
    "pragmatics_low": 14,
    "pragmatics_high": 15,
    "semantics_low": 27,
    "semantics_high": 28,
    "percentile_rank": 50
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "scaled_score": 9,
    "syntax_low": 24,
    "syntax_high": 26,
    "pragmatics_low": 12,
    "pragmatics_high": 13,
    "semantics_low": 25,
    "semantics_high": 26,
    "percentile_rank": 37
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "scaled_score": 8,
    "syntax_low": 21,
    "syntax_high": 23,
    "pragmatics_low": 10,
    "pragmatics_high": 11,
    "semantics_low": 22,
    "semantics_high": 24,
    "percentile_rank": 25
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "scaled_score": 7,
    "syntax_low": 18,
    "syntax_high": 20,
    "pragmatics_low": 8,
    "pragmatics_high": 9,
    "semantics_low": 20,
    "semantics_high": 21,
    "percentile_rank": 16
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "scaled_score": 6,
    "syntax_low": 16,
    "syntax_high": 17,
    "pragmatics_low": 6,
    "pragmatics_high": 7,
    "semantics_low": 18,
    "semantics_high": 19,
    "percentile_rank": 9
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "scaled_score": 5,
    "syntax_low": 13,
    "syntax_high": 15,
    "pragmatics_low": 4,
    "pragmatics_high": 5,
    "semantics_low": 15,
    "semantics_high": 17,
    "percentile_rank": 5
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "scaled_score": 4,
    "syntax_low": 10,
    "syntax_high": 12,
    "pragmatics_low": 2,
    "pragmatics_high": 3,
    "semantics_low": 13,
    "semantics_high": 14,
    "percentile_rank": 2
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "scaled_score": 3,
    "syntax_low": 6,
    "syntax_high": 9,
    "pragmatics_low": 1,
    "pragmatics_high": 1,
    "semantics_low": 10,
    "semantics_high": 12,
    "percentile_rank": 1
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "scaled_score": 2,
    "syntax_low": 2,
    "syntax_high": 5,
    "pragmatics_low": 0,
    "pragmatics_high": 0,
    "semantics_low": 7,
    "semantics_high": 9,
    "percentile_rank": 0.4
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "scaled_score": 1,
    "syntax_low": 0,
    "syntax_high": 1,
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 0,
    "semantics_high": 6,
    "percentile_rank": 0.1
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "scaled_score": 19,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 41,
    "semantics_high": 46,
    "percentile_rank": 99.9
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "scaled_score": 18,
    "syntax_low": 38,
    "syntax_high": 38,
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 40,
    "semantics_high": 40,
    "percentile_rank": 99.6
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "scaled_score": 17,
    "syntax_low": 37,
    "syntax_high": 37,
    "pragmatics_low": 24,
    "pragmatics_high": 24,
    "semantics_low": 39,
    "semantics_high": 39,
    "percentile_rank": 99
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "scaled_score": 16,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": 23,
    "pragmatics_high": 23,
    "semantics_low": 38,
    "semantics_high": 38,
    "percentile_rank": 98
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "scaled_score": 15,
    "syntax_low": 36,
    "syntax_high": 36,
    "pragmatics_low": 22,
    "pragmatics_high": 22,
    "semantics_low": 37,
    "semantics_high": 37,
    "percentile_rank": 95
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "scaled_score": 14,
    "syntax_low": 35,
    "syntax_high": 35,
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 36,
    "semantics_high": 36,
    "percentile_rank": 91
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "scaled_score": 13,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": 21,
    "pragmatics_high": 21,
    "semantics_low": 34,
    "semantics_high": 35,
    "percentile_rank": 84
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "scaled_score": 12,
    "syntax_low": 34,
    "syntax_high": 34,
    "pragmatics_low": 19,
    "pragmatics_high": 20,
    "semantics_low": 32,
    "semantics_high": 33,
    "percentile_rank": 75
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "scaled_score": 11,
    "syntax_low": 32,
    "syntax_high": 33,
    "pragmatics_low": 18,
    "pragmatics_high": 18,
    "semantics_low": 31,
    "semantics_high": 31,
    "percentile_rank": 63
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "scaled_score": 10,
    "syntax_low": 29,
    "syntax_high": 31,
    "pragmatics_low": 16,
    "pragmatics_high": 17,
    "semantics_low": 29,
    "semantics_high": 30,
    "percentile_rank": 50
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "scaled_score": 9,
    "syntax_low": 26,
    "syntax_high": 28,
    "pragmatics_low": 14,
    "pragmatics_high": 15,
    "semantics_low": 27,
    "semantics_high": 28,
    "percentile_rank": 37
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "scaled_score": 8,
    "syntax_low": 23,
    "syntax_high": 25,
    "pragmatics_low": 12,
    "pragmatics_high": 13,
    "semantics_low": 24,
    "semantics_high": 26,
    "percentile_rank": 25
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "scaled_score": 7,
    "syntax_low": 21,
    "syntax_high": 22,
    "pragmatics_low": 10,
    "pragmatics_high": 11,
    "semantics_low": 22,
    "semantics_high": 23,
    "percentile_rank": 16
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "scaled_score": 6,
    "syntax_low": 19,
    "syntax_high": 20,
    "pragmatics_low": 8,
    "pragmatics_high": 9,
    "semantics_low": 20,
    "semantics_high": 21,
    "percentile_rank": 9
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "scaled_score": 5,
    "syntax_low": 16,
    "syntax_high": 18,
    "pragmatics_low": 6,
    "pragmatics_high": 7,
    "semantics_low": 17,
    "semantics_high": 19,
    "percentile_rank": 5
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "scaled_score": 4,
    "syntax_low": 12,
    "syntax_high": 15,
    "pragmatics_low": 4,
    "pragmatics_high": 5,
    "semantics_low": 15,
    "semantics_high": 16,
    "percentile_rank": 2
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "scaled_score": 3,
    "syntax_low": 8,
    "syntax_high": 11,
    "pragmatics_low": 2,
    "pragmatics_high": 3,
    "semantics_low": 12,
    "semantics_high": 14,
    "percentile_rank": 1
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "scaled_score": 2,
    "syntax_low": 4,
    "syntax_high": 7,
    "pragmatics_low": 1,
    "pragmatics_high": 1,
    "semantics_low": 9,
    "semantics_high": 11,
    "percentile_rank": 0.4
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "scaled_score": 1,
    "syntax_low": 0,
    "syntax_high": 3,
    "pragmatics_low": 0,
    "pragmatics_high": 0,
    "semantics_low": 0,
    "semantics_high": 8,
    "percentile_rank": 0.1
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "scaled_score": 19,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 42,
    "semantics_high": 46,
    "percentile_rank": 99.9
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "scaled_score": 18,
    "syntax_low": 38,
    "syntax_high": 38,
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 41,
    "semantics_high": 41,
    "percentile_rank": 99.6
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "scaled_score": 17,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": 24,
    "pragmatics_high": 24,
    "semantics_low": 40,
    "semantics_high": 40,
    "percentile_rank": 99
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "scaled_score": 16,
    "syntax_low": 37,
    "syntax_high": 37,
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 39,
    "semantics_high": 39,
    "percentile_rank": 98
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "scaled_score": 15,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": 23,
    "pragmatics_high": 23,
    "semantics_low": 38,
    "semantics_high": 38,
    "percentile_rank": 95
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "scaled_score": 14,
    "syntax_low": 36,
    "syntax_high": 36,
    "pragmatics_low": 22,
    "pragmatics_high": 22,
    "semantics_low": 37,
    "semantics_high": 37,
    "percentile_rank": 91
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "scaled_score": 13,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 36,
    "semantics_high": 36,
    "percentile_rank": 84
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "scaled_score": 12,
    "syntax_low": 35,
    "syntax_high": 35,
    "pragmatics_low": 21,
    "pragmatics_high": 21,
    "semantics_low": 34,
    "semantics_high": 35,
    "percentile_rank": 75
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "scaled_score": 11,
    "syntax_low": 33,
    "syntax_high": 34,
    "pragmatics_low": 20,
    "pragmatics_high": 20,
    "semantics_low": 32,
    "semantics_high": 33,
    "percentile_rank": 63
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "scaled_score": 10,
    "syntax_low": 31,
    "syntax_high": 32,
    "pragmatics_low": 18,
    "pragmatics_high": 19,
    "semantics_low": 30,
    "semantics_high": 31,
    "percentile_rank": 50
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "scaled_score": 9,
    "syntax_low": 28,
    "syntax_high": 30,
    "pragmatics_low": 16,
    "pragmatics_high": 17,
    "semantics_low": 28,
    "semantics_high": 29,
    "percentile_rank": 37
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "scaled_score": 8,
    "syntax_low": 26,
    "syntax_high": 27,
    "pragmatics_low": 14,
    "pragmatics_high": 15,
    "semantics_low": 26,
    "semantics_high": 27,
    "percentile_rank": 25
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "scaled_score": 7,
    "syntax_low": 23,
    "syntax_high": 25,
    "pragmatics_low": 12,
    "pragmatics_high": 13,
    "semantics_low": 24,
    "semantics_high": 25,
    "percentile_rank": 16
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "scaled_score": 6,
    "syntax_low": 21,
    "syntax_high": 22,
    "pragmatics_low": 10,
    "pragmatics_high": 11,
    "semantics_low": 22,
    "semantics_high": 23,
    "percentile_rank": 9
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "scaled_score": 5,
    "syntax_low": 18,
    "syntax_high": 20,
    "pragmatics_low": 8,
    "pragmatics_high": 9,
    "semantics_low": 19,
    "semantics_high": 21,
    "percentile_rank": 5
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "scaled_score": 4,
    "syntax_low": 14,
    "syntax_high": 17,
    "pragmatics_low": 6,
    "pragmatics_high": 7,
    "semantics_low": 17,
    "semantics_high": 18,
    "percentile_rank": 2
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "scaled_score": 3,
    "syntax_low": 10,
    "syntax_high": 13,
    "pragmatics_low": 4,
    "pragmatics_high": 5,
    "semantics_low": 14,
    "semantics_high": 16,
    "percentile_rank": 1
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "scaled_score": 2,
    "syntax_low": 6,
    "syntax_high": 9,
    "pragmatics_low": 2,
    "pragmatics_high": 3,
    "semantics_low": 11,
    "semantics_high": 13,
    "percentile_rank": 0.4
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "scaled_score": 1,
    "syntax_low": 0,
    "syntax_high": 5,
    "pragmatics_low": 0,
    "pragmatics_high": 1,
    "semantics_low": 0,
    "semantics_high": 10,
    "percentile_rank": 0.1
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "scaled_score": 19,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 42,
    "semantics_high": 46,
    "percentile_rank": 99.9
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "scaled_score": 18,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 41,
    "semantics_high": 41,
    "percentile_rank": 99.6
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "scaled_score": 17,
    "syntax_low": 38,
    "syntax_high": 38,
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": "—",
    "semantics_high": "—",
    "percentile_rank": 99
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "scaled_score": 16,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": 24,
    "pragmatics_high": 24,
    "semantics_low": 40,
    "semantics_high": 40,
    "percentile_rank": 98
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "scaled_score": 15,
    "syntax_low": 37,
    "syntax_high": 37,
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 39,
    "semantics_high": 39,
    "percentile_rank": 95
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "scaled_score": 14,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": 23,
    "pragmatics_high": 23,
    "semantics_low": 38,
    "semantics_high": 38,
    "percentile_rank": 91
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "scaled_score": 13,
    "syntax_low": 36,
    "syntax_high": 36,
    "pragmatics_low": 22,
    "pragmatics_high": 22,
    "semantics_low": 37,
    "semantics_high": 37,
    "percentile_rank": 84
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "scaled_score": 12,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 35,
    "semantics_high": 36,
    "percentile_rank": 75
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "scaled_score": 11,
    "syntax_low": 35,
    "syntax_high": 35,
    "pragmatics_low": 21,
    "pragmatics_high": 21,
    "semantics_low": 34,
    "semantics_high": 34,
    "percentile_rank": 63
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "scaled_score": 10,
    "syntax_low": 33,
    "syntax_high": 34,
    "pragmatics_low": 19,
    "pragmatics_high": 20,
    "semantics_low": 32,
    "semantics_high": 33,
    "percentile_rank": 50
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "scaled_score": 9,
    "syntax_low": 30,
    "syntax_high": 32,
    "pragmatics_low": 17,
    "pragmatics_high": 18,
    "semantics_low": 30,
    "semantics_high": 31,
    "percentile_rank": 37
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "scaled_score": 8,
    "syntax_low": 28,
    "syntax_high": 29,
    "pragmatics_low": 15,
    "pragmatics_high": 16,
    "semantics_low": 27,
    "semantics_high": 29,
    "percentile_rank": 25
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "scaled_score": 7,
    "syntax_low": 25,
    "syntax_high": 27,
    "pragmatics_low": 14,
    "pragmatics_high": 14,
    "semantics_low": 25,
    "semantics_high": 26,
    "percentile_rank": 16
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "scaled_score": 6,
    "syntax_low": 23,
    "syntax_high": 24,
    "pragmatics_low": 12,
    "pragmatics_high": 13,
    "semantics_low": 23,
    "semantics_high": 24,
    "percentile_rank": 9
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "scaled_score": 5,
    "syntax_low": 20,
    "syntax_high": 22,
    "pragmatics_low": 10,
    "pragmatics_high": 11,
    "semantics_low": 21,
    "semantics_high": 22,
    "percentile_rank": 5
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "scaled_score": 4,
    "syntax_low": 17,
    "syntax_high": 19,
    "pragmatics_low": 8,
    "pragmatics_high": 9,
    "semantics_low": 18,
    "semantics_high": 20,
    "percentile_rank": 2
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "scaled_score": 3,
    "syntax_low": 13,
    "syntax_high": 16,
    "pragmatics_low": 5,
    "pragmatics_high": 7,
    "semantics_low": 16,
    "semantics_high": 17,
    "percentile_rank": 1
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "scaled_score": 2,
    "syntax_low": 8,
    "syntax_high": 12,
    "pragmatics_low": 2,
    "pragmatics_high": 4,
    "semantics_low": 13,
    "semantics_high": 15,
    "percentile_rank": 0.4
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "scaled_score": 1,
    "syntax_low": 0,
    "syntax_high": 7,
    "pragmatics_low": 0,
    "pragmatics_high": 1,
    "semantics_low": 0,
    "semantics_high": 12,
    "percentile_rank": 0.1
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "scaled_score": 19,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 43,
    "semantics_high": 46,
    "percentile_rank": 99.9
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "scaled_score": 18,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 42,
    "semantics_high": 42,
    "percentile_rank": 99.6
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "scaled_score": 17,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": "—",
    "semantics_high": "—",
    "percentile_rank": 99
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "scaled_score": 16,
    "syntax_low": 38,
    "syntax_high": 38,
    "pragmatics_low": 24,
    "pragmatics_high": 24,
    "semantics_low": 41,
    "semantics_high": 41,
    "percentile_rank": 98
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "scaled_score": 15,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 40,
    "semantics_high": 40,
    "percentile_rank": 95
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "scaled_score": 14,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 39,
    "semantics_high": 39,
    "percentile_rank": 91
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "scaled_score": 13,
    "syntax_low": 37,
    "syntax_high": 37,
    "pragmatics_low": 23,
    "pragmatics_high": 23,
    "semantics_low": 38,
    "semantics_high": 38,
    "percentile_rank": 84
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "scaled_score": 12,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 37,
    "semantics_high": 37,
    "percentile_rank": 75
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "scaled_score": 11,
    "syntax_low": 36,
    "syntax_high": 36,
    "pragmatics_low": 22,
    "pragmatics_high": 22,
    "semantics_low": 35,
    "semantics_high": 36,
    "percentile_rank": 63
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "scaled_score": 10,
    "syntax_low": 35,
    "syntax_high": 35,
    "pragmatics_low": 21,
    "pragmatics_high": 21,
    "semantics_low": 33,
    "semantics_high": 34,
    "percentile_rank": 50
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "scaled_score": 9,
    "syntax_low": 33,
    "syntax_high": 34,
    "pragmatics_low": 19,
    "pragmatics_high": 20,
    "semantics_low": 31,
    "semantics_high": 32,
    "percentile_rank": 37
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "scaled_score": 8,
    "syntax_low": 30,
    "syntax_high": 32,
    "pragmatics_low": 17,
    "pragmatics_high": 18,
    "semantics_low": 29,
    "semantics_high": 30,
    "percentile_rank": 25
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "scaled_score": 7,
    "syntax_low": 28,
    "syntax_high": 29,
    "pragmatics_low": 15,
    "pragmatics_high": 16,
    "semantics_low": 27,
    "semantics_high": 28,
    "percentile_rank": 16
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "scaled_score": 6,
    "syntax_low": 25,
    "syntax_high": 27,
    "pragmatics_low": 14,
    "pragmatics_high": 14,
    "semantics_low": 25,
    "semantics_high": 26,
    "percentile_rank": 9
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "scaled_score": 5,
    "syntax_low": 23,
    "syntax_high": 24,
    "pragmatics_low": 13,
    "pragmatics_high": 13,
    "semantics_low": 23,
    "semantics_high": 24,
    "percentile_rank": 5
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "scaled_score": 4,
    "syntax_low": 20,
    "syntax_high": 22,
    "pragmatics_low": 11,
    "pragmatics_high": 12,
    "semantics_low": 20,
    "semantics_high": 22,
    "percentile_rank": 2
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "scaled_score": 3,
    "syntax_low": 16,
    "syntax_high": 19,
    "pragmatics_low": 8,
    "pragmatics_high": 10,
    "semantics_low": 18,
    "semantics_high": 19,
    "percentile_rank": 1
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "scaled_score": 2,
    "syntax_low": 12,
    "syntax_high": 15,
    "pragmatics_low": 5,
    "pragmatics_high": 7,
    "semantics_low": 15,
    "semantics_high": 17,
    "percentile_rank": 0.4
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "scaled_score": 1,
    "syntax_low": 0,
    "syntax_high": 11,
    "pragmatics_low": 0,
    "pragmatics_high": 4,
    "semantics_low": 0,
    "semantics_high": 14,
    "percentile_rank": 0.1
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "scaled_score": 19,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 44,
    "semantics_high": 46,
    "percentile_rank": 99.9
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "scaled_score": 18,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 43,
    "semantics_high": 43,
    "percentile_rank": 99.6
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "scaled_score": 17,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": "—",
    "semantics_high": "—",
    "percentile_rank": 99
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "scaled_score": 16,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 42,
    "semantics_high": 42,
    "percentile_rank": 98
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "scaled_score": 15,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": 24,
    "pragmatics_high": 24,
    "semantics_low": 41,
    "semantics_high": 41,
    "percentile_rank": 95
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "scaled_score": 14,
    "syntax_low": 38,
    "syntax_high": 38,
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": "—",
    "semantics_high": "—",
    "percentile_rank": 91
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "scaled_score": 13,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": 23,
    "pragmatics_high": 23,
    "semantics_low": 40,
    "semantics_high": 40,
    "percentile_rank": 84
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "scaled_score": 12,
    "syntax_low": 37,
    "syntax_high": 37,
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 39,
    "semantics_high": 39,
    "percentile_rank": 75
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "scaled_score": 11,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 37,
    "semantics_high": 38,
    "percentile_rank": 63
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "scaled_score": 10,
    "syntax_low": 36,
    "syntax_high": 36,
    "pragmatics_low": 22,
    "pragmatics_high": 22,
    "semantics_low": 35,
    "semantics_high": 36,
    "percentile_rank": 50
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "scaled_score": 9,
    "syntax_low": 34,
    "syntax_high": 35,
    "pragmatics_low": 21,
    "pragmatics_high": 21,
    "semantics_low": 33,
    "semantics_high": 34,
    "percentile_rank": 37
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "scaled_score": 8,
    "syntax_low": 32,
    "syntax_high": 33,
    "pragmatics_low": 19,
    "pragmatics_high": 20,
    "semantics_low": 31,
    "semantics_high": 32,
    "percentile_rank": 25
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "scaled_score": 7,
    "syntax_low": 30,
    "syntax_high": 31,
    "pragmatics_low": 18,
    "pragmatics_high": 18,
    "semantics_low": 29,
    "semantics_high": 30,
    "percentile_rank": 16
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "scaled_score": 6,
    "syntax_low": 27,
    "syntax_high": 29,
    "pragmatics_low": 16,
    "pragmatics_high": 17,
    "semantics_low": 27,
    "semantics_high": 28,
    "percentile_rank": 9
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "scaled_score": 5,
    "syntax_low": 25,
    "syntax_high": 26,
    "pragmatics_low": 15,
    "pragmatics_high": 15,
    "semantics_low": 25,
    "semantics_high": 26,
    "percentile_rank": 5
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "scaled_score": 4,
    "syntax_low": 22,
    "syntax_high": 24,
    "pragmatics_low": 13,
    "pragmatics_high": 14,
    "semantics_low": 23,
    "semantics_high": 24,
    "percentile_rank": 2
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "scaled_score": 3,
    "syntax_low": 19,
    "syntax_high": 21,
    "pragmatics_low": 11,
    "pragmatics_high": 12,
    "semantics_low": 20,
    "semantics_high": 22,
    "percentile_rank": 1
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "scaled_score": 2,
    "syntax_low": 15,
    "syntax_high": 18,
    "pragmatics_low": 9,
    "pragmatics_high": 10,
    "semantics_low": 17,
    "semantics_high": 19,
    "percentile_rank": 0.4
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "scaled_score": 1,
    "syntax_low": 0,
    "syntax_high": 14,
    "pragmatics_low": 0,
    "pragmatics_high": 8,
    "semantics_low": 0,
    "semantics_high": 16,
    "percentile_rank": 0.1
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "scaled_score": 19,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 46,
    "semantics_high": 46,
    "percentile_rank": 99.9
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "scaled_score": 18,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 45,
    "semantics_high": 45,
    "percentile_rank": 99.6
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "scaled_score": 17,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 44,
    "semantics_high": 44,
    "percentile_rank": 99
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "scaled_score": 16,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": "—",
    "semantics_high": "—",
    "percentile_rank": 98
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "scaled_score": 15,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": 24,
    "pragmatics_high": 24,
    "semantics_low": 43,
    "semantics_high": 43,
    "percentile_rank": 95
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "scaled_score": 14,
    "syntax_low": 38,
    "syntax_high": 38,
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 42,
    "semantics_high": 42,
    "percentile_rank": 91
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "scaled_score": 13,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": 23,
    "pragmatics_high": 23,
    "semantics_low": 41,
    "semantics_high": 41,
    "percentile_rank": 84
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "scaled_score": 12,
    "syntax_low": 37,
    "syntax_high": 37,
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 40,
    "semantics_high": 40,
    "percentile_rank": 75
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "scaled_score": 11,
    "syntax_low": "—",
    "syntax_high": "—",
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 39,
    "semantics_high": 39,
    "percentile_rank": 63
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "scaled_score": 10,
    "syntax_low": 36,
    "syntax_high": 36,
    "pragmatics_low": 22,
    "pragmatics_high": 22,
    "semantics_low": 37,
    "semantics_high": 38,
    "percentile_rank": 50
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "scaled_score": 9,
    "syntax_low": 35,
    "syntax_high": 35,
    "pragmatics_low": 21,
    "pragmatics_high": 21,
    "semantics_low": 35,
    "semantics_high": 36,
    "percentile_rank": 37
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "scaled_score": 8,
    "syntax_low": 34,
    "syntax_high": 34,
    "pragmatics_low": 20,
    "pragmatics_high": 20,
    "semantics_low": 33,
    "semantics_high": 34,
    "percentile_rank": 25
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "scaled_score": 7,
    "syntax_low": 33,
    "syntax_high": 33,
    "pragmatics_low": "—",
    "pragmatics_high": "—",
    "semantics_low": 31,
    "semantics_high": 32,
    "percentile_rank": 16
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "scaled_score": 6,
    "syntax_low": 32,
    "syntax_high": 32,
    "pragmatics_low": 19,
    "pragmatics_high": 19,
    "semantics_low": 29,
    "semantics_high": 30,
    "percentile_rank": 9
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "scaled_score": 5,
    "syntax_low": 30,
    "syntax_high": 31,
    "pragmatics_low": 18,
    "pragmatics_high": 18,
    "semantics_low": 27,
    "semantics_high": 28,
    "percentile_rank": 5
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "scaled_score": 4,
    "syntax_low": 27,
    "syntax_high": 29,
    "pragmatics_low": 17,
    "pragmatics_high": 17,
    "semantics_low": 25,
    "semantics_high": 26,
    "percentile_rank": 2
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "scaled_score": 3,
    "syntax_low": 23,
    "syntax_high": 26,
    "pragmatics_low": 15,
    "pragmatics_high": 16,
    "semantics_low": 22,
    "semantics_high": 24,
    "percentile_rank": 1
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "scaled_score": 2,
    "syntax_low": 19,
    "syntax_high": 22,
    "pragmatics_low": 13,
    "pragmatics_high": 14,
    "semantics_low": 19,
    "semantics_high": 21,
    "percentile_rank": 0.4
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "scaled_score": 1,
    "syntax_low": 0,
    "syntax_high": 18,
    "pragmatics_low": 0,
    "pragmatics_high": 12,
    "semantics_low": 0,
    "semantics_high": 18,
    "percentile_rank": 0.1
  }
];

const phonologyScores: any = [
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 0,
    "percentile_rank": 1
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 1,
    "percentile_rank": 2
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 2,
    "percentile_rank": 3
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 3,
    "percentile_rank": 4
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 4,
    "percentile_rank": 5
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 5,
    "percentile_rank": "6–7"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 6,
    "percentile_rank": 8
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 7,
    "percentile_rank": "9–10"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 8,
    "percentile_rank": "11–12"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 9,
    "percentile_rank": "13–14"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 10,
    "percentile_rank": "15–16"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 11,
    "percentile_rank": "17–18"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 12,
    "percentile_rank": "19–21"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 13,
    "percentile_rank": "22–24"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 14,
    "percentile_rank": "25–27"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 15,
    "percentile_rank": "28–30"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 16,
    "percentile_rank": "31–33"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 17,
    "percentile_rank": "34–37"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 18,
    "percentile_rank": "38–40"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 19,
    "percentile_rank": "41–43"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 20,
    "percentile_rank": "44–46"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 21,
    "percentile_rank": "47–49"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 22,
    "percentile_rank": "50–52"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 23,
    "percentile_rank": "53–55"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 24,
    "percentile_rank": "56–58"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "raw_score": 25,
    "percentile_rank": "59–100"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 0,
    "percentile_rank": "<1"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 1,
    "percentile_rank": 1
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 2,
    "percentile_rank": 1
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 3,
    "percentile_rank": 2
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 4,
    "percentile_rank": 3
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 5,
    "percentile_rank": 3
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 6,
    "percentile_rank": 4
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 7,
    "percentile_rank": "5–6"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 8,
    "percentile_rank": 7
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 9,
    "percentile_rank": "8–10"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 10,
    "percentile_rank": "11–12"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 11,
    "percentile_rank": "13–15"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 12,
    "percentile_rank": "16–17"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 13,
    "percentile_rank": "18–20"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 14,
    "percentile_rank": "21–22"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 15,
    "percentile_rank": "23–25"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 16,
    "percentile_rank": "26–28"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 17,
    "percentile_rank": "29–31"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 18,
    "percentile_rank": "32–33"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 19,
    "percentile_rank": "34–36"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 20,
    "percentile_rank": "37–39"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 21,
    "percentile_rank": "40–42"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 22,
    "percentile_rank": "43–45"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 23,
    "percentile_rank": "46–48"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 24,
    "percentile_rank": "49–50"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "raw_score": 25,
    "percentile_rank": "51–100"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 0,
    "percentile_rank": "<1"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 1,
    "percentile_rank": "<1"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 2,
    "percentile_rank": 1
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 3,
    "percentile_rank": 1
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 4,
    "percentile_rank": 1
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 5,
    "percentile_rank": 2
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 6,
    "percentile_rank": 3
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 7,
    "percentile_rank": 4
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 8,
    "percentile_rank": 5
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 9,
    "percentile_rank": 6
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 10,
    "percentile_rank": "7–8"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 11,
    "percentile_rank": "9–10"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 12,
    "percentile_rank": "11–12"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 13,
    "percentile_rank": "13–14"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 14,
    "percentile_rank": "15–16"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 15,
    "percentile_rank": "17–19"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 16,
    "percentile_rank": "20–22"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 17,
    "percentile_rank": "23–25"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 18,
    "percentile_rank": "26–28"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 19,
    "percentile_rank": "29–31"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 20,
    "percentile_rank": "32–34"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 21,
    "percentile_rank": "35–36"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 22,
    "percentile_rank": "37–39"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 23,
    "percentile_rank": "40–42"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 24,
    "percentile_rank": "43–47"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "raw_score": 25,
    "percentile_rank": "48–100"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 0,
    "percentile_rank": "<1"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 1,
    "percentile_rank": "<1"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 2,
    "percentile_rank": 1
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 3,
    "percentile_rank": 1
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 4,
    "percentile_rank": 1
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 5,
    "percentile_rank": 1
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 6,
    "percentile_rank": 1
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 7,
    "percentile_rank": 1
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 8,
    "percentile_rank": "2–3"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 9,
    "percentile_rank": 4
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 10,
    "percentile_rank": "5–6"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 11,
    "percentile_rank": 7
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 12,
    "percentile_rank": "8–9"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 13,
    "percentile_rank": "10–11"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 14,
    "percentile_rank": 12
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 15,
    "percentile_rank": "13–14"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 16,
    "percentile_rank": "15–16"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 17,
    "percentile_rank": "17–19"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 18,
    "percentile_rank": "20–22"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 19,
    "percentile_rank": "23–25"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 20,
    "percentile_rank": "26–28"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 21,
    "percentile_rank": "29–31"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 22,
    "percentile_rank": "32–34"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 23,
    "percentile_rank": "35–37"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 24,
    "percentile_rank": "38–40"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "raw_score": 25,
    "percentile_rank": "41–100"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 0,
    "percentile_rank": "<1"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 1,
    "percentile_rank": "<1"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 2,
    "percentile_rank": "<1"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 3,
    "percentile_rank": "<1"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 4,
    "percentile_rank": "<1"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 5,
    "percentile_rank": "<1"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 6,
    "percentile_rank": 1
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 7,
    "percentile_rank": 1
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 8,
    "percentile_rank": 1
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 9,
    "percentile_rank": 1
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 10,
    "percentile_rank": 1
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 11,
    "percentile_rank": 2
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 12,
    "percentile_rank": 3
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 13,
    "percentile_rank": 4
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 14,
    "percentile_rank": "5–6"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 15,
    "percentile_rank": "7–8"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 16,
    "percentile_rank": "9–11"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 17,
    "percentile_rank": "12–13"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 18,
    "percentile_rank": "14–16"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 19,
    "percentile_rank": "17–20"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 20,
    "percentile_rank": "21–24"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 21,
    "percentile_rank": "25–27"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 22,
    "percentile_rank": "28–31"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 23,
    "percentile_rank": "32–35"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 24,
    "percentile_rank": "36–39"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "raw_score": 25,
    "percentile_rank": "40–100"
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 0,
    "percentile_rank": "<1"
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 1,
    "percentile_rank": "<1"
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 2,
    "percentile_rank": "<1"
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 3,
    "percentile_rank": "<1"
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 4,
    "percentile_rank": "<1"
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 5,
    "percentile_rank": "<1"
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 6,
    "percentile_rank": 1
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 7,
    "percentile_rank": 1
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 8,
    "percentile_rank": 1
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 9,
    "percentile_rank": 1
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 10,
    "percentile_rank": 1
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 11,
    "percentile_rank": 2
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 12,
    "percentile_rank": 2
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 13,
    "percentile_rank": 2
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 14,
    "percentile_rank": 3
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 15,
    "percentile_rank": 3
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 16,
    "percentile_rank": 4
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 17,
    "percentile_rank": "5–7"
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 18,
    "percentile_rank": "8–9"
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 19,
    "percentile_rank": "10–13"
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 20,
    "percentile_rank": "14–17"
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 21,
    "percentile_rank": "18–21"
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 22,
    "percentile_rank": "22–24"
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 23,
    "percentile_rank": "25–28"
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 24,
    "percentile_rank": "29–32"
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "raw_score": 25,
    "percentile_rank": "33–100"
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 0,
    "percentile_rank": "<1"
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 1,
    "percentile_rank": "<1"
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 2,
    "percentile_rank": "<1"
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 3,
    "percentile_rank": "<1"
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 4,
    "percentile_rank": "<1"
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 5,
    "percentile_rank": "<1"
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 6,
    "percentile_rank": 1
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 7,
    "percentile_rank": 1
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 8,
    "percentile_rank": 1
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 9,
    "percentile_rank": 1
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 10,
    "percentile_rank": 1
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 11,
    "percentile_rank": 1
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 12,
    "percentile_rank": 1
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 13,
    "percentile_rank": 2
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 14,
    "percentile_rank": 2
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 15,
    "percentile_rank": 2
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 16,
    "percentile_rank": 2
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 17,
    "percentile_rank": 2
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 18,
    "percentile_rank": 2
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 19,
    "percentile_rank": "3–6"
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 20,
    "percentile_rank": "7–10"
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 21,
    "percentile_rank": "11–14"
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 22,
    "percentile_rank": "15–18"
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 23,
    "percentile_rank": "19–22"
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 24,
    "percentile_rank": "23–26"
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "raw_score": 25,
    "percentile_rank": "27–100"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 0,
    "percentile_rank": "<1"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 1,
    "percentile_rank": "<1"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 2,
    "percentile_rank": "<1"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 3,
    "percentile_rank": "<1"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 4,
    "percentile_rank": "<1"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 5,
    "percentile_rank": "<1"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 6,
    "percentile_rank": "<1"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 7,
    "percentile_rank": "<1"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 8,
    "percentile_rank": "<1"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 9,
    "percentile_rank": "<1"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 10,
    "percentile_rank": "<1"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 11,
    "percentile_rank": "<1"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 12,
    "percentile_rank": "<1"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 13,
    "percentile_rank": "<1"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 14,
    "percentile_rank": "<1"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 15,
    "percentile_rank": "<1"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 16,
    "percentile_rank": "<1"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 17,
    "percentile_rank": "<1"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 18,
    "percentile_rank": "<1"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 19,
    "percentile_rank": 1
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 20,
    "percentile_rank": 2
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 21,
    "percentile_rank": "3–4"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 22,
    "percentile_rank": "5–6"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 23,
    "percentile_rank": "7–16"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 24,
    "percentile_rank": "17–25"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "raw_score": 25,
    "percentile_rank": "26–100"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 0,
    "percentile_rank": "<1"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 1,
    "percentile_rank": "<1"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 2,
    "percentile_rank": "<1"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 3,
    "percentile_rank": "<1"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 4,
    "percentile_rank": "<1"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 5,
    "percentile_rank": "<1"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 6,
    "percentile_rank": "<1"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 7,
    "percentile_rank": "<1"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 8,
    "percentile_rank": "<1"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 9,
    "percentile_rank": "<1"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 10,
    "percentile_rank": "<1"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 11,
    "percentile_rank": "<1"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 12,
    "percentile_rank": "<1"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 13,
    "percentile_rank": "<1"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 14,
    "percentile_rank": "<1"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 15,
    "percentile_rank": "<1"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 16,
    "percentile_rank": "<1"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 17,
    "percentile_rank": "<1"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 18,
    "percentile_rank": "<1"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 19,
    "percentile_rank": 1
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 20,
    "percentile_rank": 2
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 21,
    "percentile_rank": 3
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 22,
    "percentile_rank": "4–5"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 23,
    "percentile_rank": "6–15"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 24,
    "percentile_rank": "16–25"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "raw_score": 25,
    "percentile_rank": "26–100"
  }
];

const criticalValues: any = [
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "confidence_level": "90%",
    "syntax": 2,
    "pragmatics": 2,
    "semantics": 2
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "confidence_level": "95%",
    "syntax": 3,
    "pragmatics": 2,
    "semantics": 3
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "confidence_level": "90%",
    "syntax": 2,
    "pragmatics": 2,
    "semantics": 2
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "confidence_level": "95%",
    "syntax": 2,
    "pragmatics": 2,
    "semantics": 2
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "confidence_level": "90%",
    "syntax": 2,
    "pragmatics": 2,
    "semantics": 3
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "confidence_level": "95%",
    "syntax": 3,
    "pragmatics": 2,
    "semantics": 3
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "confidence_level": "90%",
    "syntax": 2,
    "pragmatics": 2,
    "semantics": 2
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "confidence_level": "95%",
    "syntax": 2,
    "pragmatics": 2,
    "semantics": 3
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "confidence_level": "90%",
    "syntax": 2,
    "pragmatics": 2,
    "semantics": 2
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "confidence_level": "95%",
    "syntax": 2,
    "pragmatics": 2,
    "semantics": 3
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "confidence_level": "90%",
    "syntax": 2,
    "pragmatics": 2,
    "semantics": 2
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "confidence_level": "95%",
    "syntax": 2,
    "pragmatics": 3,
    "semantics": 3
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "confidence_level": "90%",
    "syntax": 2,
    "pragmatics": 2,
    "semantics": 2
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "confidence_level": "95%",
    "syntax": 3,
    "pragmatics": 3,
    "semantics": 3
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "confidence_level": "90%",
    "syntax": 2,
    "pragmatics": 3,
    "semantics": 3
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "confidence_level": "95%",
    "syntax": 3,
    "pragmatics": 3,
    "semantics": 3
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "confidence_level": "90%",
    "syntax": 2,
    "pragmatics": 3,
    "semantics": 2
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "confidence_level": "95%",
    "syntax": 2,
    "pragmatics": 3,
    "semantics": 2
  }
];

const compositeScores: any = [
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 3,
    "composite_standard_score": 45,
    "confidence_interval_90": "43–56",
    "confidence_interval_95": "42–57",
    "ci_90_lower": 43,
    "ci_90_upper": 56,
    "ci_95_lower": 42,
    "ci_95_upper": 57,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 4,
    "composite_standard_score": 48,
    "confidence_interval_90": "46–59",
    "confidence_interval_95": "45–60",
    "ci_90_lower": 46,
    "ci_90_upper": 59,
    "ci_95_lower": 45,
    "ci_95_upper": 60,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 5,
    "composite_standard_score": 50,
    "confidence_interval_90": "48–60",
    "confidence_interval_95": "46–62",
    "ci_90_lower": 48,
    "ci_90_upper": 60,
    "ci_95_lower": 46,
    "ci_95_upper": 62,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 6,
    "composite_standard_score": 53,
    "confidence_interval_90": "50–63",
    "confidence_interval_95": "49–64",
    "ci_90_lower": 50,
    "ci_90_upper": 63,
    "ci_95_lower": 49,
    "ci_95_upper": 64,
    "percentile_rank": 0.1
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 7,
    "composite_standard_score": 55,
    "confidence_interval_90": "52–65",
    "confidence_interval_95": "51–66",
    "ci_90_lower": 52,
    "ci_90_upper": 65,
    "ci_95_lower": 51,
    "ci_95_upper": 66,
    "percentile_rank": 0.1
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 8,
    "composite_standard_score": 58,
    "confidence_interval_90": "55–68",
    "confidence_interval_95": "54–69",
    "ci_90_lower": 55,
    "ci_90_upper": 68,
    "ci_95_lower": 54,
    "ci_95_upper": 69,
    "percentile_rank": 0.3
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 9,
    "composite_standard_score": 60,
    "confidence_interval_90": "57–70",
    "confidence_interval_95": "56–71",
    "ci_90_lower": 57,
    "ci_90_upper": 70,
    "ci_95_lower": 56,
    "ci_95_upper": 71,
    "percentile_rank": 0.4
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 10,
    "composite_standard_score": 63,
    "confidence_interval_90": "60–72",
    "confidence_interval_95": "58–74",
    "ci_90_lower": 60,
    "ci_90_upper": 72,
    "ci_95_lower": 58,
    "ci_95_upper": 74,
    "percentile_rank": 1
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 11,
    "composite_standard_score": 65,
    "confidence_interval_90": "61–74",
    "confidence_interval_95": "60–75",
    "ci_90_lower": 61,
    "ci_90_upper": 74,
    "ci_95_lower": 60,
    "ci_95_upper": 75,
    "percentile_rank": 1
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 12,
    "composite_standard_score": 68,
    "confidence_interval_90": "64–77",
    "confidence_interval_95": "63–78",
    "ci_90_lower": 64,
    "ci_90_upper": 77,
    "ci_95_lower": 63,
    "ci_95_upper": 78,
    "percentile_rank": 2
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 13,
    "composite_standard_score": 70,
    "confidence_interval_90": "66–79",
    "confidence_interval_95": "65–80",
    "ci_90_lower": 66,
    "ci_90_upper": 79,
    "ci_95_lower": 65,
    "ci_95_upper": 80,
    "percentile_rank": 2
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 14,
    "composite_standard_score": 71,
    "confidence_interval_90": "67–80",
    "confidence_interval_95": "66–81",
    "ci_90_lower": 67,
    "ci_90_upper": 80,
    "ci_95_lower": 66,
    "ci_95_upper": 81,
    "percentile_rank": 3
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 15,
    "composite_standard_score": 73,
    "confidence_interval_90": "69–82",
    "confidence_interval_95": "68–83",
    "ci_90_lower": 69,
    "ci_90_upper": 82,
    "ci_95_lower": 68,
    "ci_95_upper": 83,
    "percentile_rank": 4
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 16,
    "composite_standard_score": 74,
    "confidence_interval_90": "70–83",
    "confidence_interval_95": "68–84",
    "ci_90_lower": 70,
    "ci_90_upper": 83,
    "ci_95_lower": 68,
    "ci_95_upper": 84,
    "percentile_rank": 4
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 17,
    "composite_standard_score": 76,
    "confidence_interval_90": "71–84",
    "confidence_interval_95": "70–86",
    "ci_90_lower": 71,
    "ci_90_upper": 84,
    "ci_95_lower": 70,
    "ci_95_upper": 86,
    "percentile_rank": 5
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 18,
    "composite_standard_score": 77,
    "confidence_interval_90": "72–85",
    "confidence_interval_95": "71–86",
    "ci_90_lower": 72,
    "ci_90_upper": 85,
    "ci_95_lower": 71,
    "ci_95_upper": 86,
    "percentile_rank": 6
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 19,
    "composite_standard_score": 79,
    "confidence_interval_90": "74–87",
    "confidence_interval_95": "73–88",
    "ci_90_lower": 74,
    "ci_90_upper": 87,
    "ci_95_lower": 73,
    "ci_95_upper": 88,
    "percentile_rank": 8
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 20,
    "composite_standard_score": 80,
    "confidence_interval_90": "75–88",
    "confidence_interval_95": "74–89",
    "ci_90_lower": 75,
    "ci_90_upper": 88,
    "ci_95_lower": 74,
    "ci_95_upper": 89,
    "percentile_rank": 9
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 21,
    "composite_standard_score": 82,
    "confidence_interval_90": "77–90",
    "confidence_interval_95": "76–91",
    "ci_90_lower": 77,
    "ci_90_upper": 90,
    "ci_95_lower": 76,
    "ci_95_upper": 91,
    "percentile_rank": 12
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 22,
    "composite_standard_score": 84,
    "confidence_interval_90": "79–92",
    "confidence_interval_95": "78–93",
    "ci_90_lower": 79,
    "ci_90_upper": 92,
    "ci_95_lower": 78,
    "ci_95_upper": 93,
    "percentile_rank": 14
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 23,
    "composite_standard_score": 86,
    "confidence_interval_90": "81–94",
    "confidence_interval_95": "79–95",
    "ci_90_lower": 81,
    "ci_90_upper": 94,
    "ci_95_lower": 79,
    "ci_95_upper": 95,
    "percentile_rank": 18
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 24,
    "composite_standard_score": 88,
    "confidence_interval_90": "83–95",
    "confidence_interval_95": "81–97",
    "ci_90_lower": 83,
    "ci_90_upper": 95,
    "ci_95_lower": 81,
    "ci_95_upper": 97,
    "percentile_rank": 21
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 25,
    "composite_standard_score": 89,
    "confidence_interval_90": "83–96",
    "confidence_interval_95": "82–98",
    "ci_90_lower": 83,
    "ci_90_upper": 96,
    "ci_95_lower": 82,
    "ci_95_upper": 98,
    "percentile_rank": 23
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 26,
    "composite_standard_score": 91,
    "confidence_interval_90": "85–98",
    "confidence_interval_95": "84–99",
    "ci_90_lower": 85,
    "ci_90_upper": 98,
    "ci_95_lower": 84,
    "ci_95_upper": 99,
    "percentile_rank": 27
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 27,
    "composite_standard_score": 93,
    "confidence_interval_90": "87–100",
    "confidence_interval_95": "86–101",
    "ci_90_lower": 87,
    "ci_90_upper": 100,
    "ci_95_lower": 86,
    "ci_95_upper": 101,
    "percentile_rank": 32
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 28,
    "composite_standard_score": 95,
    "confidence_interval_90": "89–102",
    "confidence_interval_95": "88–103",
    "ci_90_lower": 89,
    "ci_90_upper": 102,
    "ci_95_lower": 88,
    "ci_95_upper": 103,
    "percentile_rank": 37
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 29,
    "composite_standard_score": 98,
    "confidence_interval_90": "92–105",
    "confidence_interval_95": "91–106",
    "ci_90_lower": 92,
    "ci_90_upper": 105,
    "ci_95_lower": 91,
    "ci_95_upper": 106,
    "percentile_rank": 45
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 30,
    "composite_standard_score": 100,
    "confidence_interval_90": "94–106",
    "confidence_interval_95": "92–108",
    "ci_90_lower": 94,
    "ci_90_upper": 106,
    "ci_95_lower": 92,
    "ci_95_upper": 108,
    "percentile_rank": 50
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 31,
    "composite_standard_score": 102,
    "confidence_interval_90": "95–108",
    "confidence_interval_95": "94–109",
    "ci_90_lower": 95,
    "ci_90_upper": 108,
    "ci_95_lower": 94,
    "ci_95_upper": 109,
    "percentile_rank": 55
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 32,
    "composite_standard_score": 105,
    "confidence_interval_90": "98–111",
    "confidence_interval_95": "97–112",
    "ci_90_lower": 98,
    "ci_90_upper": 111,
    "ci_95_lower": 97,
    "ci_95_upper": 112,
    "percentile_rank": 63
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 33,
    "composite_standard_score": 107,
    "confidence_interval_90": "100–113",
    "confidence_interval_95": "99–114",
    "ci_90_lower": 100,
    "ci_90_upper": 113,
    "ci_95_lower": 99,
    "ci_95_upper": 114,
    "percentile_rank": 68
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 34,
    "composite_standard_score": 109,
    "confidence_interval_90": "102–115",
    "confidence_interval_95": "101–116",
    "ci_90_lower": 102,
    "ci_90_upper": 115,
    "ci_95_lower": 101,
    "ci_95_upper": 116,
    "percentile_rank": 73
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 35,
    "composite_standard_score": 111,
    "confidence_interval_90": "104–117",
    "confidence_interval_95": "102–118",
    "ci_90_lower": 104,
    "ci_90_upper": 117,
    "ci_95_lower": 102,
    "ci_95_upper": 118,
    "percentile_rank": 77
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 36,
    "composite_standard_score": 114,
    "confidence_interval_90": "106–119",
    "confidence_interval_95": "105–121",
    "ci_90_lower": 106,
    "ci_90_upper": 119,
    "ci_95_lower": 105,
    "ci_95_upper": 121,
    "percentile_rank": 82
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 37,
    "composite_standard_score": 116,
    "confidence_interval_90": "108–121",
    "confidence_interval_95": "107–122",
    "ci_90_lower": 108,
    "ci_90_upper": 121,
    "ci_95_lower": 107,
    "ci_95_upper": 122,
    "percentile_rank": 86
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 38,
    "composite_standard_score": 118,
    "confidence_interval_90": "110–123",
    "confidence_interval_95": "109–124",
    "ci_90_lower": 110,
    "ci_90_upper": 123,
    "ci_95_lower": 109,
    "ci_95_upper": 124,
    "percentile_rank": 88
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 39,
    "composite_standard_score": 120,
    "confidence_interval_90": "112–125",
    "confidence_interval_95": "111–126",
    "ci_90_lower": 112,
    "ci_90_upper": 125,
    "ci_95_lower": 111,
    "ci_95_upper": 126,
    "percentile_rank": 91
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 40,
    "composite_standard_score": 122,
    "confidence_interval_90": "114–127",
    "confidence_interval_95": "113–128",
    "ci_90_lower": 114,
    "ci_90_upper": 127,
    "ci_95_lower": 113,
    "ci_95_upper": 128,
    "percentile_rank": 93
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 41,
    "composite_standard_score": 124,
    "confidence_interval_90": "116–129",
    "confidence_interval_95": "114–130",
    "ci_90_lower": 116,
    "ci_90_upper": 129,
    "ci_95_lower": 114,
    "ci_95_upper": 130,
    "percentile_rank": 95
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 42,
    "composite_standard_score": 126,
    "confidence_interval_90": "117–130",
    "confidence_interval_95": "116–132",
    "ci_90_lower": 117,
    "ci_90_upper": 130,
    "ci_95_lower": 116,
    "ci_95_upper": 132,
    "percentile_rank": 96
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 43,
    "composite_standard_score": 128,
    "confidence_interval_90": "119–132",
    "confidence_interval_95": "118–133",
    "ci_90_lower": 119,
    "ci_90_upper": 132,
    "ci_95_lower": 118,
    "ci_95_upper": 133,
    "percentile_rank": 97
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 44,
    "composite_standard_score": 130,
    "confidence_interval_90": "121–134",
    "confidence_interval_95": "120–135",
    "ci_90_lower": 121,
    "ci_90_upper": 134,
    "ci_95_lower": 120,
    "ci_95_upper": 135,
    "percentile_rank": 98
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 45,
    "composite_standard_score": 132,
    "confidence_interval_90": "123–136",
    "confidence_interval_95": "122–137",
    "ci_90_lower": 123,
    "ci_90_upper": 136,
    "ci_95_lower": 122,
    "ci_95_upper": 137,
    "percentile_rank": 98
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 46,
    "composite_standard_score": 134,
    "confidence_interval_90": "125–138",
    "confidence_interval_95": "124–139",
    "ci_90_lower": 125,
    "ci_90_upper": 138,
    "ci_95_lower": 124,
    "ci_95_upper": 139,
    "percentile_rank": 99
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 47,
    "composite_standard_score": 136,
    "confidence_interval_90": "127–140",
    "confidence_interval_95": "125–141",
    "ci_90_lower": 127,
    "ci_90_upper": 140,
    "ci_95_lower": 125,
    "ci_95_upper": 141,
    "percentile_rank": 99
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 48,
    "composite_standard_score": 138,
    "confidence_interval_90": "129–141",
    "confidence_interval_95": "127–143",
    "ci_90_lower": 129,
    "ci_90_upper": 141,
    "ci_95_lower": 127,
    "ci_95_upper": 143,
    "percentile_rank": 99
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 49,
    "composite_standard_score": 140,
    "confidence_interval_90": "130–143",
    "confidence_interval_95": "129–144",
    "ci_90_lower": 130,
    "ci_90_upper": 143,
    "ci_95_lower": 129,
    "ci_95_upper": 144,
    "percentile_rank": 99.6
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 50,
    "composite_standard_score": 142,
    "confidence_interval_90": "132–145",
    "confidence_interval_95": "131–146",
    "ci_90_lower": 132,
    "ci_90_upper": 145,
    "ci_95_lower": 131,
    "ci_95_upper": 146,
    "percentile_rank": 99.7
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 51,
    "composite_standard_score": 144,
    "confidence_interval_90": "134–147",
    "confidence_interval_95": "133–148",
    "ci_90_lower": 134,
    "ci_90_upper": 147,
    "ci_95_lower": 133,
    "ci_95_upper": 148,
    "percentile_rank": 99.8
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 52,
    "composite_standard_score": 146,
    "confidence_interval_90": "136–149",
    "confidence_interval_95": "135–150",
    "ci_90_lower": 136,
    "ci_90_upper": 149,
    "ci_95_lower": 135,
    "ci_95_upper": 150,
    "percentile_rank": 99.9
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 53,
    "composite_standard_score": 148,
    "confidence_interval_90": "138–151",
    "confidence_interval_95": "137–152",
    "ci_90_lower": 138,
    "ci_90_upper": 151,
    "ci_95_lower": 137,
    "ci_95_upper": 152,
    "percentile_rank": 99.9
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 54,
    "composite_standard_score": 150,
    "confidence_interval_90": "140–152",
    "confidence_interval_95": "138–154",
    "ci_90_lower": 140,
    "ci_90_upper": 152,
    "ci_95_lower": 138,
    "ci_95_upper": 154,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 55,
    "composite_standard_score": 152,
    "confidence_interval_90": "141–154",
    "confidence_interval_95": "140–155",
    "ci_90_lower": 141,
    "ci_90_upper": 154,
    "ci_95_lower": 140,
    "ci_95_upper": 155,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 56,
    "composite_standard_score": 154,
    "confidence_interval_90": "143–156",
    "confidence_interval_95": "142–157",
    "ci_90_lower": 143,
    "ci_90_upper": 156,
    "ci_95_lower": 142,
    "ci_95_upper": 157,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "4:1",
    "high_age": "4:5",
    "sum_of_scaled_scores": 57,
    "composite_standard_score": 155,
    "confidence_interval_90": "144–157",
    "confidence_interval_95": "143–158",
    "ci_90_lower": 144,
    "ci_90_upper": 157,
    "ci_95_lower": 143,
    "ci_95_upper": 158,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 3,
    "composite_standard_score": 45,
    "confidence_interval_90": "43–56",
    "confidence_interval_95": "42–57",
    "ci_90_lower": 43,
    "ci_90_upper": 56,
    "ci_95_lower": 42,
    "ci_95_upper": 57,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 4,
    "composite_standard_score": 48,
    "confidence_interval_90": "46–59",
    "confidence_interval_95": "45–60",
    "ci_90_lower": 46,
    "ci_90_upper": 59,
    "ci_95_lower": 45,
    "ci_95_upper": 60,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 5,
    "composite_standard_score": 50,
    "confidence_interval_90": "48–60",
    "confidence_interval_95": "46–62",
    "ci_90_lower": 48,
    "ci_90_upper": 60,
    "ci_95_lower": 46,
    "ci_95_upper": 62,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 6,
    "composite_standard_score": 53,
    "confidence_interval_90": "50–63",
    "confidence_interval_95": "49–64",
    "ci_90_lower": 50,
    "ci_90_upper": 63,
    "ci_95_lower": 49,
    "ci_95_upper": 64,
    "percentile_rank": 0.1
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 7,
    "composite_standard_score": 55,
    "confidence_interval_90": "52–65",
    "confidence_interval_95": "51–66",
    "ci_90_lower": 52,
    "ci_90_upper": 65,
    "ci_95_lower": 51,
    "ci_95_upper": 66,
    "percentile_rank": 0.1
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 8,
    "composite_standard_score": 58,
    "confidence_interval_90": "55–68",
    "confidence_interval_95": "54–69",
    "ci_90_lower": 55,
    "ci_90_upper": 68,
    "ci_95_lower": 54,
    "ci_95_upper": 69,
    "percentile_rank": 0.3
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 9,
    "composite_standard_score": 60,
    "confidence_interval_90": "57–70",
    "confidence_interval_95": "56–71",
    "ci_90_lower": 57,
    "ci_90_upper": 70,
    "ci_95_lower": 56,
    "ci_95_upper": 71,
    "percentile_rank": 0.4
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 10,
    "composite_standard_score": 63,
    "confidence_interval_90": "60–72",
    "confidence_interval_95": "58–74",
    "ci_90_lower": 60,
    "ci_90_upper": 72,
    "ci_95_lower": 58,
    "ci_95_upper": 74,
    "percentile_rank": 1
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 11,
    "composite_standard_score": 65,
    "confidence_interval_90": "61–74",
    "confidence_interval_95": "60–75",
    "ci_90_lower": 61,
    "ci_90_upper": 74,
    "ci_95_lower": 60,
    "ci_95_upper": 75,
    "percentile_rank": 1
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 12,
    "composite_standard_score": 68,
    "confidence_interval_90": "64–77",
    "confidence_interval_95": "63–78",
    "ci_90_lower": 64,
    "ci_90_upper": 77,
    "ci_95_lower": 63,
    "ci_95_upper": 78,
    "percentile_rank": 2
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 13,
    "composite_standard_score": 70,
    "confidence_interval_90": "66–79",
    "confidence_interval_95": "65–80",
    "ci_90_lower": 66,
    "ci_90_upper": 79,
    "ci_95_lower": 65,
    "ci_95_upper": 80,
    "percentile_rank": 2
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 14,
    "composite_standard_score": 71,
    "confidence_interval_90": "67–80",
    "confidence_interval_95": "66–81",
    "ci_90_lower": 67,
    "ci_90_upper": 80,
    "ci_95_lower": 66,
    "ci_95_upper": 81,
    "percentile_rank": 3
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 15,
    "composite_standard_score": 73,
    "confidence_interval_90": "69–82",
    "confidence_interval_95": "68–83",
    "ci_90_lower": 69,
    "ci_90_upper": 82,
    "ci_95_lower": 68,
    "ci_95_upper": 83,
    "percentile_rank": 4
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 16,
    "composite_standard_score": 74,
    "confidence_interval_90": "70–83",
    "confidence_interval_95": "68–84",
    "ci_90_lower": 70,
    "ci_90_upper": 83,
    "ci_95_lower": 68,
    "ci_95_upper": 84,
    "percentile_rank": 4
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 17,
    "composite_standard_score": 76,
    "confidence_interval_90": "71–84",
    "confidence_interval_95": "70–86",
    "ci_90_lower": 71,
    "ci_90_upper": 84,
    "ci_95_lower": 70,
    "ci_95_upper": 86,
    "percentile_rank": 5
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 18,
    "composite_standard_score": 77,
    "confidence_interval_90": "72–85",
    "confidence_interval_95": "71–86",
    "ci_90_lower": 72,
    "ci_90_upper": 85,
    "ci_95_lower": 71,
    "ci_95_upper": 86,
    "percentile_rank": 6
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 19,
    "composite_standard_score": 79,
    "confidence_interval_90": "74–87",
    "confidence_interval_95": "73–88",
    "ci_90_lower": 74,
    "ci_90_upper": 87,
    "ci_95_lower": 73,
    "ci_95_upper": 88,
    "percentile_rank": 8
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 20,
    "composite_standard_score": 80,
    "confidence_interval_90": "75–88",
    "confidence_interval_95": "74–89",
    "ci_90_lower": 75,
    "ci_90_upper": 88,
    "ci_95_lower": 74,
    "ci_95_upper": 89,
    "percentile_rank": 9
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 21,
    "composite_standard_score": 82,
    "confidence_interval_90": "77–90",
    "confidence_interval_95": "76–91",
    "ci_90_lower": 77,
    "ci_90_upper": 90,
    "ci_95_lower": 76,
    "ci_95_upper": 91,
    "percentile_rank": 12
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 22,
    "composite_standard_score": 84,
    "confidence_interval_90": "79–92",
    "confidence_interval_95": "78–93",
    "ci_90_lower": 79,
    "ci_90_upper": 92,
    "ci_95_lower": 78,
    "ci_95_upper": 93,
    "percentile_rank": 14
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 23,
    "composite_standard_score": 86,
    "confidence_interval_90": "81–94",
    "confidence_interval_95": "79–95",
    "ci_90_lower": 81,
    "ci_90_upper": 94,
    "ci_95_lower": 79,
    "ci_95_upper": 95,
    "percentile_rank": 18
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 24,
    "composite_standard_score": 88,
    "confidence_interval_90": "83–95",
    "confidence_interval_95": "81–97",
    "ci_90_lower": 83,
    "ci_90_upper": 95,
    "ci_95_lower": 81,
    "ci_95_upper": 97,
    "percentile_rank": 21
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 25,
    "composite_standard_score": 89,
    "confidence_interval_90": "83–96",
    "confidence_interval_95": "82–98",
    "ci_90_lower": 83,
    "ci_90_upper": 96,
    "ci_95_lower": 82,
    "ci_95_upper": 98,
    "percentile_rank": 23
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 26,
    "composite_standard_score": 91,
    "confidence_interval_90": "85–98",
    "confidence_interval_95": "84–99",
    "ci_90_lower": 85,
    "ci_90_upper": 98,
    "ci_95_lower": 84,
    "ci_95_upper": 99,
    "percentile_rank": 27
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 27,
    "composite_standard_score": 93,
    "confidence_interval_90": "87–100",
    "confidence_interval_95": "86–101",
    "ci_90_lower": 87,
    "ci_90_upper": 100,
    "ci_95_lower": 86,
    "ci_95_upper": 101,
    "percentile_rank": 32
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 28,
    "composite_standard_score": 95,
    "confidence_interval_90": "89–102",
    "confidence_interval_95": "88–103",
    "ci_90_lower": 89,
    "ci_90_upper": 102,
    "ci_95_lower": 88,
    "ci_95_upper": 103,
    "percentile_rank": 37
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 29,
    "composite_standard_score": 98,
    "confidence_interval_90": "92–105",
    "confidence_interval_95": "91–106",
    "ci_90_lower": 92,
    "ci_90_upper": 105,
    "ci_95_lower": 91,
    "ci_95_upper": 106,
    "percentile_rank": 45
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 30,
    "composite_standard_score": 100,
    "confidence_interval_90": "94–106",
    "confidence_interval_95": "92–108",
    "ci_90_lower": 94,
    "ci_90_upper": 106,
    "ci_95_lower": 92,
    "ci_95_upper": 108,
    "percentile_rank": 50
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 31,
    "composite_standard_score": 102,
    "confidence_interval_90": "95–108",
    "confidence_interval_95": "94–109",
    "ci_90_lower": 95,
    "ci_90_upper": 108,
    "ci_95_lower": 94,
    "ci_95_upper": 109,
    "percentile_rank": 55
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 32,
    "composite_standard_score": 105,
    "confidence_interval_90": "98–111",
    "confidence_interval_95": "97–112",
    "ci_90_lower": 98,
    "ci_90_upper": 111,
    "ci_95_lower": 97,
    "ci_95_upper": 112,
    "percentile_rank": 63
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 33,
    "composite_standard_score": 107,
    "confidence_interval_90": "100–113",
    "confidence_interval_95": "99–114",
    "ci_90_lower": 100,
    "ci_90_upper": 113,
    "ci_95_lower": 99,
    "ci_95_upper": 114,
    "percentile_rank": 68
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 34,
    "composite_standard_score": 109,
    "confidence_interval_90": "102–115",
    "confidence_interval_95": "101–116",
    "ci_90_lower": 102,
    "ci_90_upper": 115,
    "ci_95_lower": 101,
    "ci_95_upper": 116,
    "percentile_rank": 73
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 35,
    "composite_standard_score": 111,
    "confidence_interval_90": "104–117",
    "confidence_interval_95": "102–118",
    "ci_90_lower": 104,
    "ci_90_upper": 117,
    "ci_95_lower": 102,
    "ci_95_upper": 118,
    "percentile_rank": 77
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 36,
    "composite_standard_score": 114,
    "confidence_interval_90": "106–119",
    "confidence_interval_95": "105–121",
    "ci_90_lower": 106,
    "ci_90_upper": 119,
    "ci_95_lower": 105,
    "ci_95_upper": 121,
    "percentile_rank": 82
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 37,
    "composite_standard_score": 116,
    "confidence_interval_90": "108–121",
    "confidence_interval_95": "107–122",
    "ci_90_lower": 108,
    "ci_90_upper": 121,
    "ci_95_lower": 107,
    "ci_95_upper": 122,
    "percentile_rank": 86
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 38,
    "composite_standard_score": 118,
    "confidence_interval_90": "110–123",
    "confidence_interval_95": "109–124",
    "ci_90_lower": 110,
    "ci_90_upper": 123,
    "ci_95_lower": 109,
    "ci_95_upper": 124,
    "percentile_rank": 88
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 39,
    "composite_standard_score": 120,
    "confidence_interval_90": "112–125",
    "confidence_interval_95": "111–126",
    "ci_90_lower": 112,
    "ci_90_upper": 125,
    "ci_95_lower": 111,
    "ci_95_upper": 126,
    "percentile_rank": 91
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 40,
    "composite_standard_score": 122,
    "confidence_interval_90": "114–127",
    "confidence_interval_95": "113–128",
    "ci_90_lower": 114,
    "ci_90_upper": 127,
    "ci_95_lower": 113,
    "ci_95_upper": 128,
    "percentile_rank": 93
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 41,
    "composite_standard_score": 124,
    "confidence_interval_90": "116–129",
    "confidence_interval_95": "114–130",
    "ci_90_lower": 116,
    "ci_90_upper": 129,
    "ci_95_lower": 114,
    "ci_95_upper": 130,
    "percentile_rank": 95
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 42,
    "composite_standard_score": 126,
    "confidence_interval_90": "117–130",
    "confidence_interval_95": "116–132",
    "ci_90_lower": 117,
    "ci_90_upper": 130,
    "ci_95_lower": 116,
    "ci_95_upper": 132,
    "percentile_rank": 96
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 43,
    "composite_standard_score": 128,
    "confidence_interval_90": "119–132",
    "confidence_interval_95": "118–133",
    "ci_90_lower": 119,
    "ci_90_upper": 132,
    "ci_95_lower": 118,
    "ci_95_upper": 133,
    "percentile_rank": 97
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 44,
    "composite_standard_score": 130,
    "confidence_interval_90": "121–134",
    "confidence_interval_95": "120–135",
    "ci_90_lower": 121,
    "ci_90_upper": 134,
    "ci_95_lower": 120,
    "ci_95_upper": 135,
    "percentile_rank": 98
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 45,
    "composite_standard_score": 132,
    "confidence_interval_90": "123–136",
    "confidence_interval_95": "122–137",
    "ci_90_lower": 123,
    "ci_90_upper": 136,
    "ci_95_lower": 122,
    "ci_95_upper": 137,
    "percentile_rank": 98
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 46,
    "composite_standard_score": 134,
    "confidence_interval_90": "125–138",
    "confidence_interval_95": "124–139",
    "ci_90_lower": 125,
    "ci_90_upper": 138,
    "ci_95_lower": 124,
    "ci_95_upper": 139,
    "percentile_rank": 99
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 47,
    "composite_standard_score": 136,
    "confidence_interval_90": "127–140",
    "confidence_interval_95": "125–141",
    "ci_90_lower": 127,
    "ci_90_upper": 140,
    "ci_95_lower": 125,
    "ci_95_upper": 141,
    "percentile_rank": 99
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 48,
    "composite_standard_score": 138,
    "confidence_interval_90": "129–141",
    "confidence_interval_95": "127–143",
    "ci_90_lower": 129,
    "ci_90_upper": 141,
    "ci_95_lower": 127,
    "ci_95_upper": 143,
    "percentile_rank": 99
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 49,
    "composite_standard_score": 140,
    "confidence_interval_90": "130–143",
    "confidence_interval_95": "129–144",
    "ci_90_lower": 130,
    "ci_90_upper": 143,
    "ci_95_lower": 129,
    "ci_95_upper": 144,
    "percentile_rank": 99.6
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 50,
    "composite_standard_score": 142,
    "confidence_interval_90": "132–145",
    "confidence_interval_95": "131–146",
    "ci_90_lower": 132,
    "ci_90_upper": 145,
    "ci_95_lower": 131,
    "ci_95_upper": 146,
    "percentile_rank": 99.7
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 51,
    "composite_standard_score": 144,
    "confidence_interval_90": "134–147",
    "confidence_interval_95": "133–148",
    "ci_90_lower": 134,
    "ci_90_upper": 147,
    "ci_95_lower": 133,
    "ci_95_upper": 148,
    "percentile_rank": 99.8
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 52,
    "composite_standard_score": 146,
    "confidence_interval_90": "136–149",
    "confidence_interval_95": "135–150",
    "ci_90_lower": 136,
    "ci_90_upper": 149,
    "ci_95_lower": 135,
    "ci_95_upper": 150,
    "percentile_rank": 99.9
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 53,
    "composite_standard_score": 148,
    "confidence_interval_90": "138–151",
    "confidence_interval_95": "137–152",
    "ci_90_lower": 138,
    "ci_90_upper": 151,
    "ci_95_lower": 137,
    "ci_95_upper": 152,
    "percentile_rank": 99.9
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 54,
    "composite_standard_score": 150,
    "confidence_interval_90": "140–152",
    "confidence_interval_95": "138–154",
    "ci_90_lower": 140,
    "ci_90_upper": 152,
    "ci_95_lower": 138,
    "ci_95_upper": 154,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 55,
    "composite_standard_score": 152,
    "confidence_interval_90": "141–154",
    "confidence_interval_95": "140–155",
    "ci_90_lower": 141,
    "ci_90_upper": 154,
    "ci_95_lower": 140,
    "ci_95_upper": 155,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 56,
    "composite_standard_score": 154,
    "confidence_interval_90": "143–156",
    "confidence_interval_95": "142–157",
    "ci_90_lower": 143,
    "ci_90_upper": 156,
    "ci_95_lower": 142,
    "ci_95_upper": 157,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "4:6",
    "high_age": "4:11",
    "sum_of_scaled_scores": 57,
    "composite_standard_score": 155,
    "confidence_interval_90": "144–157",
    "confidence_interval_95": "143–158",
    "ci_90_lower": 144,
    "ci_90_upper": 157,
    "ci_95_lower": 143,
    "ci_95_upper": 158,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 3,
    "composite_standard_score": 45,
    "confidence_interval_90": "44–58",
    "confidence_interval_95": "42–60",
    "ci_90_lower": 44,
    "ci_90_upper": 58,
    "ci_95_lower": 42,
    "ci_95_upper": 60,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 4,
    "composite_standard_score": 48,
    "confidence_interval_90": "46–61",
    "confidence_interval_95": "45–62",
    "ci_90_lower": 46,
    "ci_90_upper": 61,
    "ci_95_lower": 45,
    "ci_95_upper": 62,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 5,
    "composite_standard_score": 50,
    "confidence_interval_90": "48–63",
    "confidence_interval_95": "47–64",
    "ci_90_lower": 48,
    "ci_90_upper": 63,
    "ci_95_lower": 47,
    "ci_95_upper": 64,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 6,
    "composite_standard_score": 53,
    "confidence_interval_90": "51–65",
    "confidence_interval_95": "49–67",
    "ci_90_lower": 51,
    "ci_90_upper": 65,
    "ci_95_lower": 49,
    "ci_95_upper": 67,
    "percentile_rank": 0.1
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 7,
    "composite_standard_score": 55,
    "confidence_interval_90": "53–67",
    "confidence_interval_95": "51–69",
    "ci_90_lower": 53,
    "ci_90_upper": 67,
    "ci_95_lower": 51,
    "ci_95_upper": 69,
    "percentile_rank": 0.1
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 8,
    "composite_standard_score": 58,
    "confidence_interval_90": "55–70",
    "confidence_interval_95": "54–71",
    "ci_90_lower": 55,
    "ci_90_upper": 70,
    "ci_95_lower": 54,
    "ci_95_upper": 71,
    "percentile_rank": 0.3
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 9,
    "composite_standard_score": 60,
    "confidence_interval_90": "57–72",
    "confidence_interval_95": "56–73",
    "ci_90_lower": 57,
    "ci_90_upper": 72,
    "ci_95_lower": 56,
    "ci_95_upper": 73,
    "percentile_rank": 0.4
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 10,
    "composite_standard_score": 63,
    "confidence_interval_90": "60–74",
    "confidence_interval_95": "58–76",
    "ci_90_lower": 60,
    "ci_90_upper": 74,
    "ci_95_lower": 58,
    "ci_95_upper": 76,
    "percentile_rank": 1
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 11,
    "composite_standard_score": 65,
    "confidence_interval_90": "62–76",
    "confidence_interval_95": "60–78",
    "ci_90_lower": 62,
    "ci_90_upper": 76,
    "ci_95_lower": 60,
    "ci_95_upper": 78,
    "percentile_rank": 1
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 12,
    "composite_standard_score": 68,
    "confidence_interval_90": "64–79",
    "confidence_interval_95": "63–80",
    "ci_90_lower": 64,
    "ci_90_upper": 79,
    "ci_95_lower": 63,
    "ci_95_upper": 80,
    "percentile_rank": 2
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 13,
    "composite_standard_score": 70,
    "confidence_interval_90": "66–81",
    "confidence_interval_95": "65–82",
    "ci_90_lower": 66,
    "ci_90_upper": 81,
    "ci_95_lower": 65,
    "ci_95_upper": 82,
    "percentile_rank": 2
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 14,
    "composite_standard_score": 71,
    "confidence_interval_90": "67–81",
    "confidence_interval_95": "66–83",
    "ci_90_lower": 67,
    "ci_90_upper": 81,
    "ci_95_lower": 66,
    "ci_95_upper": 83,
    "percentile_rank": 3
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 15,
    "composite_standard_score": 73,
    "confidence_interval_90": "69–83",
    "confidence_interval_95": "67–85",
    "ci_90_lower": 69,
    "ci_90_upper": 83,
    "ci_95_lower": 67,
    "ci_95_upper": 85,
    "percentile_rank": 4
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 16,
    "composite_standard_score": 74,
    "confidence_interval_90": "70–84",
    "confidence_interval_95": "68–86",
    "ci_90_lower": 70,
    "ci_90_upper": 84,
    "ci_95_lower": 68,
    "ci_95_upper": 86,
    "percentile_rank": 4
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 17,
    "composite_standard_score": 76,
    "confidence_interval_90": "71–86",
    "confidence_interval_95": "70–87",
    "ci_90_lower": 71,
    "ci_90_upper": 86,
    "ci_95_lower": 70,
    "ci_95_upper": 87,
    "percentile_rank": 5
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 18,
    "composite_standard_score": 77,
    "confidence_interval_90": "72–87",
    "confidence_interval_95": "71–88",
    "ci_90_lower": 72,
    "ci_90_upper": 87,
    "ci_95_lower": 71,
    "ci_95_upper": 88,
    "percentile_rank": 6
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 19,
    "composite_standard_score": 79,
    "confidence_interval_90": "74–89",
    "confidence_interval_95": "73–90",
    "ci_90_lower": 74,
    "ci_90_upper": 89,
    "ci_95_lower": 73,
    "ci_95_upper": 90,
    "percentile_rank": 8
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 20,
    "composite_standard_score": 80,
    "confidence_interval_90": "75–89",
    "confidence_interval_95": "74–91",
    "ci_90_lower": 75,
    "ci_90_upper": 89,
    "ci_95_lower": 74,
    "ci_95_upper": 91,
    "percentile_rank": 9
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 21,
    "composite_standard_score": 82,
    "confidence_interval_90": "77–91",
    "confidence_interval_95": "75–93",
    "ci_90_lower": 77,
    "ci_90_upper": 91,
    "ci_95_lower": 75,
    "ci_95_upper": 93,
    "percentile_rank": 12
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 22,
    "composite_standard_score": 84,
    "confidence_interval_90": "78–93",
    "confidence_interval_95": "77–94",
    "ci_90_lower": 78,
    "ci_90_upper": 93,
    "ci_95_lower": 77,
    "ci_95_upper": 94,
    "percentile_rank": 14
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 23,
    "composite_standard_score": 86,
    "confidence_interval_90": "80–95",
    "confidence_interval_95": "79–96",
    "ci_90_lower": 80,
    "ci_90_upper": 95,
    "ci_95_lower": 79,
    "ci_95_upper": 96,
    "percentile_rank": 18
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 24,
    "composite_standard_score": 88,
    "confidence_interval_90": "82–97",
    "confidence_interval_95": "81–98",
    "ci_90_lower": 82,
    "ci_90_upper": 97,
    "ci_95_lower": 81,
    "ci_95_upper": 98,
    "percentile_rank": 21
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 25,
    "composite_standard_score": 89,
    "confidence_interval_90": "83–97",
    "confidence_interval_95": "82–99",
    "ci_90_lower": 83,
    "ci_90_upper": 97,
    "ci_95_lower": 82,
    "ci_95_upper": 99,
    "percentile_rank": 23
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 26,
    "composite_standard_score": 91,
    "confidence_interval_90": "85–99",
    "confidence_interval_95": "83–101",
    "ci_90_lower": 85,
    "ci_90_upper": 99,
    "ci_95_lower": 83,
    "ci_95_upper": 101,
    "percentile_rank": 27
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 27,
    "composite_standard_score": 93,
    "confidence_interval_90": "86–101",
    "confidence_interval_95": "85–102",
    "ci_90_lower": 86,
    "ci_90_upper": 101,
    "ci_95_lower": 85,
    "ci_95_upper": 102,
    "percentile_rank": 32
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 28,
    "composite_standard_score": 95,
    "confidence_interval_90": "88–103",
    "confidence_interval_95": "87–104",
    "ci_90_lower": 88,
    "ci_90_upper": 103,
    "ci_95_lower": 87,
    "ci_95_upper": 104,
    "percentile_rank": 37
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 29,
    "composite_standard_score": 98,
    "confidence_interval_90": "91–106",
    "confidence_interval_95": "90–107",
    "ci_90_lower": 91,
    "ci_90_upper": 106,
    "ci_95_lower": 90,
    "ci_95_upper": 107,
    "percentile_rank": 45
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 30,
    "composite_standard_score": 100,
    "confidence_interval_90": "93–107",
    "confidence_interval_95": "91–109",
    "ci_90_lower": 93,
    "ci_90_upper": 107,
    "ci_95_lower": 91,
    "ci_95_upper": 109,
    "percentile_rank": 50
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 31,
    "composite_standard_score": 102,
    "confidence_interval_90": "94–109",
    "confidence_interval_95": "93–110",
    "ci_90_lower": 94,
    "ci_90_upper": 109,
    "ci_95_lower": 93,
    "ci_95_upper": 110,
    "percentile_rank": 55
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 32,
    "composite_standard_score": 105,
    "confidence_interval_90": "97–112",
    "confidence_interval_95": "96–113",
    "ci_90_lower": 97,
    "ci_90_upper": 112,
    "ci_95_lower": 96,
    "ci_95_upper": 113,
    "percentile_rank": 63
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 33,
    "composite_standard_score": 107,
    "confidence_interval_90": "99–114",
    "confidence_interval_95": "98–115",
    "ci_90_lower": 99,
    "ci_90_upper": 114,
    "ci_95_lower": 98,
    "ci_95_upper": 115,
    "percentile_rank": 68
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 34,
    "composite_standard_score": 109,
    "confidence_interval_90": "101–115",
    "confidence_interval_95": "99–117",
    "ci_90_lower": 101,
    "ci_90_upper": 115,
    "ci_95_lower": 99,
    "ci_95_upper": 117,
    "percentile_rank": 73
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 35,
    "composite_standard_score": 111,
    "confidence_interval_90": "103–117",
    "confidence_interval_95": "101–118",
    "ci_90_lower": 103,
    "ci_90_upper": 117,
    "ci_95_lower": 101,
    "ci_95_upper": 118,
    "percentile_rank": 77
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 36,
    "composite_standard_score": 114,
    "confidence_interval_90": "105–120",
    "confidence_interval_95": "104–121",
    "ci_90_lower": 105,
    "ci_90_upper": 120,
    "ci_95_lower": 104,
    "ci_95_upper": 121,
    "percentile_rank": 82
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 37,
    "composite_standard_score": 116,
    "confidence_interval_90": "107–122",
    "confidence_interval_95": "106–123",
    "ci_90_lower": 107,
    "ci_90_upper": 122,
    "ci_95_lower": 106,
    "ci_95_upper": 123,
    "percentile_rank": 86
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 38,
    "composite_standard_score": 118,
    "confidence_interval_90": "109–123",
    "confidence_interval_95": "107–125",
    "ci_90_lower": 109,
    "ci_90_upper": 123,
    "ci_95_lower": 107,
    "ci_95_upper": 125,
    "percentile_rank": 88
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 39,
    "composite_standard_score": 120,
    "confidence_interval_90": "111–125",
    "confidence_interval_95": "109–126",
    "ci_90_lower": 111,
    "ci_90_upper": 125,
    "ci_95_lower": 109,
    "ci_95_upper": 126,
    "percentile_rank": 91
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 40,
    "composite_standard_score": 122,
    "confidence_interval_90": "112–127",
    "confidence_interval_95": "111–128",
    "ci_90_lower": 112,
    "ci_90_upper": 127,
    "ci_95_lower": 111,
    "ci_95_upper": 128,
    "percentile_rank": 93
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 41,
    "composite_standard_score": 124,
    "confidence_interval_90": "114–129",
    "confidence_interval_95": "113–130",
    "ci_90_lower": 114,
    "ci_90_upper": 129,
    "ci_95_lower": 113,
    "ci_95_upper": 130,
    "percentile_rank": 95
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 42,
    "composite_standard_score": 126,
    "confidence_interval_90": "116–130",
    "confidence_interval_95": "114–132",
    "ci_90_lower": 116,
    "ci_90_upper": 130,
    "ci_95_lower": 114,
    "ci_95_upper": 132,
    "percentile_rank": 96
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 43,
    "composite_standard_score": 128,
    "confidence_interval_90": "118–132",
    "confidence_interval_95": "116–134",
    "ci_90_lower": 118,
    "ci_90_upper": 132,
    "ci_95_lower": 116,
    "ci_95_upper": 134,
    "percentile_rank": 97
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 44,
    "composite_standard_score": 130,
    "confidence_interval_90": "119–134",
    "confidence_interval_95": "118–135",
    "ci_90_lower": 119,
    "ci_90_upper": 134,
    "ci_95_lower": 118,
    "ci_95_upper": 135,
    "percentile_rank": 98
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 45,
    "composite_standard_score": 132,
    "confidence_interval_90": "121–136",
    "confidence_interval_95": "120–137",
    "ci_90_lower": 121,
    "ci_90_upper": 136,
    "ci_95_lower": 120,
    "ci_95_upper": 137,
    "percentile_rank": 98
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 46,
    "composite_standard_score": 134,
    "confidence_interval_90": "123–138",
    "confidence_interval_95": "122–139",
    "ci_90_lower": 123,
    "ci_90_upper": 138,
    "ci_95_lower": 122,
    "ci_95_upper": 139,
    "percentile_rank": 99
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 47,
    "composite_standard_score": 136,
    "confidence_interval_90": "125–139",
    "confidence_interval_95": "123–141",
    "ci_90_lower": 125,
    "ci_90_upper": 139,
    "ci_95_lower": 123,
    "ci_95_upper": 141,
    "percentile_rank": 99
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 48,
    "composite_standard_score": 138,
    "confidence_interval_90": "127–141",
    "confidence_interval_95": "125–142",
    "ci_90_lower": 127,
    "ci_90_upper": 141,
    "ci_95_lower": 125,
    "ci_95_upper": 142,
    "percentile_rank": 99
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 49,
    "composite_standard_score": 140,
    "confidence_interval_90": "128–143",
    "confidence_interval_95": "127–144",
    "ci_90_lower": 128,
    "ci_90_upper": 143,
    "ci_95_lower": 127,
    "ci_95_upper": 144,
    "percentile_rank": 99.6
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 50,
    "composite_standard_score": 142,
    "confidence_interval_90": "130–145",
    "confidence_interval_95": "129–146",
    "ci_90_lower": 130,
    "ci_90_upper": 145,
    "ci_95_lower": 129,
    "ci_95_upper": 146,
    "percentile_rank": 99.7
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 51,
    "composite_standard_score": 144,
    "confidence_interval_90": "132–146",
    "confidence_interval_95": "130–148",
    "ci_90_lower": 132,
    "ci_90_upper": 146,
    "ci_95_lower": 130,
    "ci_95_upper": 148,
    "percentile_rank": 99.8
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 52,
    "composite_standard_score": 146,
    "confidence_interval_90": "134–148",
    "confidence_interval_95": "132–150",
    "ci_90_lower": 134,
    "ci_90_upper": 148,
    "ci_95_lower": 132,
    "ci_95_upper": 150,
    "percentile_rank": 99.9
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 53,
    "composite_standard_score": 148,
    "confidence_interval_90": "135–150",
    "confidence_interval_95": "134–151",
    "ci_90_lower": 135,
    "ci_90_upper": 150,
    "ci_95_lower": 134,
    "ci_95_upper": 151,
    "percentile_rank": 99.9
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 54,
    "composite_standard_score": 150,
    "confidence_interval_90": "137–152",
    "confidence_interval_95": "136–153",
    "ci_90_lower": 137,
    "ci_90_upper": 152,
    "ci_95_lower": 136,
    "ci_95_upper": 153,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 55,
    "composite_standard_score": 152,
    "confidence_interval_90": "139–154",
    "confidence_interval_95": "138–155",
    "ci_90_lower": 139,
    "ci_90_upper": 154,
    "ci_95_lower": 138,
    "ci_95_upper": 155,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 56,
    "composite_standard_score": 154,
    "confidence_interval_90": "141–155",
    "confidence_interval_95": "139–157",
    "ci_90_lower": 141,
    "ci_90_upper": 155,
    "ci_95_lower": 139,
    "ci_95_upper": 157,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "5:0",
    "high_age": "5:5",
    "sum_of_scaled_scores": 57,
    "composite_standard_score": 155,
    "confidence_interval_90": "142–156",
    "confidence_interval_95": "140–158",
    "ci_90_lower": 142,
    "ci_90_upper": 156,
    "ci_95_lower": 140,
    "ci_95_upper": 158,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 3,
    "composite_standard_score": 45,
    "confidence_interval_90": "43–57",
    "confidence_interval_95": "42–58",
    "ci_90_lower": 43,
    "ci_90_upper": 57,
    "ci_95_lower": 42,
    "ci_95_upper": 58,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 4,
    "composite_standard_score": 48,
    "confidence_interval_90": "46–59",
    "confidence_interval_95": "45–61",
    "ci_90_lower": 46,
    "ci_90_upper": 59,
    "ci_95_lower": 45,
    "ci_95_upper": 61,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 5,
    "composite_standard_score": 50,
    "confidence_interval_90": "48–61",
    "confidence_interval_95": "46–63",
    "ci_90_lower": 48,
    "ci_90_upper": 61,
    "ci_95_lower": 46,
    "ci_95_upper": 63,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 6,
    "composite_standard_score": 53,
    "confidence_interval_90": "50–64",
    "confidence_interval_95": "49–65",
    "ci_90_lower": 50,
    "ci_90_upper": 64,
    "ci_95_lower": 49,
    "ci_95_upper": 65,
    "percentile_rank": 0.1
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 7,
    "composite_standard_score": 55,
    "confidence_interval_90": "52–66",
    "confidence_interval_95": "51–67",
    "ci_90_lower": 52,
    "ci_90_upper": 66,
    "ci_95_lower": 51,
    "ci_95_upper": 67,
    "percentile_rank": 0.1
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 8,
    "composite_standard_score": 58,
    "confidence_interval_90": "55–69",
    "confidence_interval_95": "54–70",
    "ci_90_lower": 55,
    "ci_90_upper": 69,
    "ci_95_lower": 54,
    "ci_95_upper": 70,
    "percentile_rank": 0.3
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 9,
    "composite_standard_score": 60,
    "confidence_interval_90": "57–70",
    "confidence_interval_95": "56–72",
    "ci_90_lower": 57,
    "ci_90_upper": 70,
    "ci_95_lower": 56,
    "ci_95_upper": 72,
    "percentile_rank": 0.4
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 10,
    "composite_standard_score": 63,
    "confidence_interval_90": "60–73",
    "confidence_interval_95": "58–74",
    "ci_90_lower": 60,
    "ci_90_upper": 73,
    "ci_95_lower": 58,
    "ci_95_upper": 74,
    "percentile_rank": 1
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 11,
    "composite_standard_score": 65,
    "confidence_interval_90": "61–75",
    "confidence_interval_95": "60–76",
    "ci_90_lower": 61,
    "ci_90_upper": 75,
    "ci_95_lower": 60,
    "ci_95_upper": 76,
    "percentile_rank": 1
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 12,
    "composite_standard_score": 68,
    "confidence_interval_90": "64–78",
    "confidence_interval_95": "63–79",
    "ci_90_lower": 64,
    "ci_90_upper": 78,
    "ci_95_lower": 63,
    "ci_95_upper": 79,
    "percentile_rank": 2
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 13,
    "composite_standard_score": 70,
    "confidence_interval_90": "66–79",
    "confidence_interval_95": "65–81",
    "ci_90_lower": 66,
    "ci_90_upper": 79,
    "ci_95_lower": 65,
    "ci_95_upper": 81,
    "percentile_rank": 2
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 14,
    "composite_standard_score": 71,
    "confidence_interval_90": "67–80",
    "confidence_interval_95": "66–82",
    "ci_90_lower": 67,
    "ci_90_upper": 80,
    "ci_95_lower": 66,
    "ci_95_upper": 82,
    "percentile_rank": 3
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 15,
    "composite_standard_score": 73,
    "confidence_interval_90": "69–82",
    "confidence_interval_95": "67–83",
    "ci_90_lower": 69,
    "ci_90_upper": 82,
    "ci_95_lower": 67,
    "ci_95_upper": 83,
    "percentile_rank": 4
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 16,
    "composite_standard_score": 74,
    "confidence_interval_90": "70–83",
    "confidence_interval_95": "68–84",
    "ci_90_lower": 70,
    "ci_90_upper": 83,
    "ci_95_lower": 68,
    "ci_95_upper": 84,
    "percentile_rank": 4
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 17,
    "composite_standard_score": 76,
    "confidence_interval_90": "71–85",
    "confidence_interval_95": "70–86",
    "ci_90_lower": 71,
    "ci_90_upper": 85,
    "ci_95_lower": 70,
    "ci_95_upper": 86,
    "percentile_rank": 5
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 18,
    "composite_standard_score": 77,
    "confidence_interval_90": "72–86",
    "confidence_interval_95": "71–87",
    "ci_90_lower": 72,
    "ci_90_upper": 86,
    "ci_95_lower": 71,
    "ci_95_upper": 87,
    "percentile_rank": 6
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 19,
    "composite_standard_score": 79,
    "confidence_interval_90": "74–88",
    "confidence_interval_95": "73–89",
    "ci_90_lower": 74,
    "ci_90_upper": 88,
    "ci_95_lower": 73,
    "ci_95_upper": 89,
    "percentile_rank": 8
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 20,
    "composite_standard_score": 80,
    "confidence_interval_90": "75–89",
    "confidence_interval_95": "74–90",
    "ci_90_lower": 75,
    "ci_90_upper": 89,
    "ci_95_lower": 74,
    "ci_95_upper": 90,
    "percentile_rank": 9
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 21,
    "composite_standard_score": 82,
    "confidence_interval_90": "77–90",
    "confidence_interval_95": "76–92",
    "ci_90_lower": 77,
    "ci_90_upper": 90,
    "ci_95_lower": 76,
    "ci_95_upper": 92,
    "percentile_rank": 12
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 22,
    "composite_standard_score": 84,
    "confidence_interval_90": "79–92",
    "confidence_interval_95": "77–93",
    "ci_90_lower": 79,
    "ci_90_upper": 92,
    "ci_95_lower": 77,
    "ci_95_upper": 93,
    "percentile_rank": 14
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 23,
    "composite_standard_score": 86,
    "confidence_interval_90": "81–94",
    "confidence_interval_95": "79–95",
    "ci_90_lower": 81,
    "ci_90_upper": 94,
    "ci_95_lower": 79,
    "ci_95_upper": 95,
    "percentile_rank": 18
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 24,
    "composite_standard_score": 88,
    "confidence_interval_90": "82–96",
    "confidence_interval_95": "81–97",
    "ci_90_lower": 82,
    "ci_90_upper": 96,
    "ci_95_lower": 81,
    "ci_95_upper": 97,
    "percentile_rank": 21
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 25,
    "composite_standard_score": 89,
    "confidence_interval_90": "83–97",
    "confidence_interval_95": "82–98",
    "ci_90_lower": 83,
    "ci_90_upper": 97,
    "ci_95_lower": 82,
    "ci_95_upper": 98,
    "percentile_rank": 23
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 26,
    "composite_standard_score": 91,
    "confidence_interval_90": "85–99",
    "confidence_interval_95": "84–100",
    "ci_90_lower": 85,
    "ci_90_upper": 99,
    "ci_95_lower": 84,
    "ci_95_upper": 100,
    "percentile_rank": 27
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 27,
    "composite_standard_score": 93,
    "confidence_interval_90": "87–100",
    "confidence_interval_95": "86–102",
    "ci_90_lower": 87,
    "ci_90_upper": 100,
    "ci_95_lower": 86,
    "ci_95_upper": 102,
    "percentile_rank": 32
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 28,
    "composite_standard_score": 95,
    "confidence_interval_90": "89–102",
    "confidence_interval_95": "87–103",
    "ci_90_lower": 89,
    "ci_90_upper": 102,
    "ci_95_lower": 87,
    "ci_95_upper": 103,
    "percentile_rank": 37
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 29,
    "composite_standard_score": 98,
    "confidence_interval_90": "91–105",
    "confidence_interval_95": "90–106",
    "ci_90_lower": 91,
    "ci_90_upper": 105,
    "ci_95_lower": 90,
    "ci_95_upper": 106,
    "percentile_rank": 45
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 30,
    "composite_standard_score": 100,
    "confidence_interval_90": "93–107",
    "confidence_interval_95": "92–108",
    "ci_90_lower": 93,
    "ci_90_upper": 107,
    "ci_95_lower": 92,
    "ci_95_upper": 108,
    "percentile_rank": 50
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 31,
    "composite_standard_score": 102,
    "confidence_interval_90": "95–109",
    "confidence_interval_95": "94–110",
    "ci_90_lower": 95,
    "ci_90_upper": 109,
    "ci_95_lower": 94,
    "ci_95_upper": 110,
    "percentile_rank": 55
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 32,
    "composite_standard_score": 105,
    "confidence_interval_90": "98–111",
    "confidence_interval_95": "97–113",
    "ci_90_lower": 98,
    "ci_90_upper": 111,
    "ci_95_lower": 97,
    "ci_95_upper": 113,
    "percentile_rank": 63
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 33,
    "composite_standard_score": 107,
    "confidence_interval_90": "100–113",
    "confidence_interval_95": "98–114",
    "ci_90_lower": 100,
    "ci_90_upper": 113,
    "ci_95_lower": 98,
    "ci_95_upper": 114,
    "percentile_rank": 68
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 34,
    "composite_standard_score": 109,
    "confidence_interval_90": "101–115",
    "confidence_interval_95": "100–116",
    "ci_90_lower": 101,
    "ci_90_upper": 115,
    "ci_95_lower": 100,
    "ci_95_upper": 116,
    "percentile_rank": 73
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 35,
    "composite_standard_score": 111,
    "confidence_interval_90": "103–117",
    "confidence_interval_95": "102–118",
    "ci_90_lower": 103,
    "ci_90_upper": 117,
    "ci_95_lower": 102,
    "ci_95_upper": 118,
    "percentile_rank": 77
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 36,
    "composite_standard_score": 114,
    "confidence_interval_90": "106–119",
    "confidence_interval_95": "105–121",
    "ci_90_lower": 106,
    "ci_90_upper": 119,
    "ci_95_lower": 105,
    "ci_95_upper": 121,
    "percentile_rank": 82
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 37,
    "composite_standard_score": 116,
    "confidence_interval_90": "108–121",
    "confidence_interval_95": "107–123",
    "ci_90_lower": 108,
    "ci_90_upper": 121,
    "ci_95_lower": 107,
    "ci_95_upper": 123,
    "percentile_rank": 86
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 38,
    "composite_standard_score": 118,
    "confidence_interval_90": "110–123",
    "confidence_interval_95": "108–124",
    "ci_90_lower": 110,
    "ci_90_upper": 123,
    "ci_95_lower": 108,
    "ci_95_upper": 124,
    "percentile_rank": 88
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 39,
    "composite_standard_score": 120,
    "confidence_interval_90": "111–125",
    "confidence_interval_95": "110–126",
    "ci_90_lower": 111,
    "ci_90_upper": 125,
    "ci_95_lower": 110,
    "ci_95_upper": 126,
    "percentile_rank": 91
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 40,
    "composite_standard_score": 122,
    "confidence_interval_90": "113–127",
    "confidence_interval_95": "112–128",
    "ci_90_lower": 113,
    "ci_90_upper": 127,
    "ci_95_lower": 112,
    "ci_95_upper": 128,
    "percentile_rank": 93
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 41,
    "composite_standard_score": 124,
    "confidence_interval_90": "115–129",
    "confidence_interval_95": "114–130",
    "ci_90_lower": 115,
    "ci_90_upper": 129,
    "ci_95_lower": 114,
    "ci_95_upper": 130,
    "percentile_rank": 95
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 42,
    "composite_standard_score": 126,
    "confidence_interval_90": "117–130",
    "confidence_interval_95": "116–132",
    "ci_90_lower": 117,
    "ci_90_upper": 130,
    "ci_95_lower": 116,
    "ci_95_upper": 132,
    "percentile_rank": 96
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 43,
    "composite_standard_score": 128,
    "confidence_interval_90": "119–132",
    "confidence_interval_95": "117–134",
    "ci_90_lower": 119,
    "ci_90_upper": 132,
    "ci_95_lower": 117,
    "ci_95_upper": 134,
    "percentile_rank": 97
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 44,
    "composite_standard_score": 130,
    "confidence_interval_90": "121–134",
    "confidence_interval_95": "119–135",
    "ci_90_lower": 121,
    "ci_90_upper": 134,
    "ci_95_lower": 119,
    "ci_95_upper": 135,
    "percentile_rank": 98
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 45,
    "composite_standard_score": 132,
    "confidence_interval_90": "122–136",
    "confidence_interval_95": "121–137",
    "ci_90_lower": 122,
    "ci_90_upper": 136,
    "ci_95_lower": 121,
    "ci_95_upper": 137,
    "percentile_rank": 98
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 46,
    "composite_standard_score": 134,
    "confidence_interval_90": "124–138",
    "confidence_interval_95": "123–139",
    "ci_90_lower": 124,
    "ci_90_upper": 138,
    "ci_95_lower": 123,
    "ci_95_upper": 139,
    "percentile_rank": 99
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 47,
    "composite_standard_score": 136,
    "confidence_interval_90": "126–139",
    "confidence_interval_95": "125–141",
    "ci_90_lower": 126,
    "ci_90_upper": 139,
    "ci_95_lower": 125,
    "ci_95_upper": 141,
    "percentile_rank": 99
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 48,
    "composite_standard_score": 138,
    "confidence_interval_90": "128–141",
    "confidence_interval_95": "127–143",
    "ci_90_lower": 128,
    "ci_90_upper": 141,
    "ci_95_lower": 127,
    "ci_95_upper": 143,
    "percentile_rank": 99
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 49,
    "composite_standard_score": 140,
    "confidence_interval_90": "130–143",
    "confidence_interval_95": "128–144",
    "ci_90_lower": 130,
    "ci_90_upper": 143,
    "ci_95_lower": 128,
    "ci_95_upper": 144,
    "percentile_rank": 99.6
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 50,
    "composite_standard_score": 142,
    "confidence_interval_90": "131–145",
    "confidence_interval_95": "130–146",
    "ci_90_lower": 131,
    "ci_90_upper": 145,
    "ci_95_lower": 130,
    "ci_95_upper": 146,
    "percentile_rank": 99.7
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 51,
    "composite_standard_score": 144,
    "confidence_interval_90": "133–147",
    "confidence_interval_95": "132–148",
    "ci_90_lower": 133,
    "ci_90_upper": 147,
    "ci_95_lower": 132,
    "ci_95_upper": 148,
    "percentile_rank": 99.8
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 52,
    "composite_standard_score": 146,
    "confidence_interval_90": "135–149",
    "confidence_interval_95": "134–150",
    "ci_90_lower": 135,
    "ci_90_upper": 149,
    "ci_95_lower": 134,
    "ci_95_upper": 150,
    "percentile_rank": 99.9
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 53,
    "composite_standard_score": 148,
    "confidence_interval_90": "137–150",
    "confidence_interval_95": "136–152",
    "ci_90_lower": 137,
    "ci_90_upper": 150,
    "ci_95_lower": 136,
    "ci_95_upper": 152,
    "percentile_rank": 99.9
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 54,
    "composite_standard_score": 150,
    "confidence_interval_90": "139–152",
    "confidence_interval_95": "137–154",
    "ci_90_lower": 139,
    "ci_90_upper": 152,
    "ci_95_lower": 137,
    "ci_95_upper": 154,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 55,
    "composite_standard_score": 152,
    "confidence_interval_90": "141–154",
    "confidence_interval_95": "139–155",
    "ci_90_lower": 141,
    "ci_90_upper": 154,
    "ci_95_lower": 139,
    "ci_95_upper": 155,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 56,
    "composite_standard_score": 154,
    "confidence_interval_90": "142–156",
    "confidence_interval_95": "141–157",
    "ci_90_lower": 142,
    "ci_90_upper": 156,
    "ci_95_lower": 141,
    "ci_95_upper": 157,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "5:6",
    "high_age": "5:11",
    "sum_of_scaled_scores": 57,
    "composite_standard_score": 155,
    "confidence_interval_90": "143–157",
    "confidence_interval_95": "142–158",
    "ci_90_lower": 143,
    "ci_90_upper": 157,
    "ci_95_lower": 142,
    "ci_95_upper": 158,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 3,
    "composite_standard_score": 45,
    "confidence_interval_90": "43–54",
    "confidence_interval_95": "42–55",
    "ci_90_lower": 43,
    "ci_90_upper": 54,
    "ci_95_lower": 42,
    "ci_95_upper": 55,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 4,
    "composite_standard_score": 48,
    "confidence_interval_90": "45–57",
    "confidence_interval_95": "44–58",
    "ci_90_lower": 45,
    "ci_90_upper": 57,
    "ci_95_lower": 44,
    "ci_95_upper": 58,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 5,
    "composite_standard_score": 50,
    "confidence_interval_90": "47–59",
    "confidence_interval_95": "46–60",
    "ci_90_lower": 47,
    "ci_90_upper": 59,
    "ci_95_lower": 46,
    "ci_95_upper": 60,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 6,
    "composite_standard_score": 53,
    "confidence_interval_90": "50–62",
    "confidence_interval_95": "49–63",
    "ci_90_lower": 50,
    "ci_90_upper": 62,
    "ci_95_lower": 49,
    "ci_95_upper": 63,
    "percentile_rank": 0.1
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 7,
    "composite_standard_score": 55,
    "confidence_interval_90": "52–63",
    "confidence_interval_95": "51–64",
    "ci_90_lower": 52,
    "ci_90_upper": 63,
    "ci_95_lower": 51,
    "ci_95_upper": 64,
    "percentile_rank": 0.1
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 8,
    "composite_standard_score": 58,
    "confidence_interval_90": "55–66",
    "confidence_interval_95": "54–67",
    "ci_90_lower": 55,
    "ci_90_upper": 66,
    "ci_95_lower": 54,
    "ci_95_upper": 67,
    "percentile_rank": 0.3
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 9,
    "composite_standard_score": 60,
    "confidence_interval_90": "57–68",
    "confidence_interval_95": "56–69",
    "ci_90_lower": 57,
    "ci_90_upper": 68,
    "ci_95_lower": 56,
    "ci_95_upper": 69,
    "percentile_rank": 0.4
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 10,
    "composite_standard_score": 63,
    "confidence_interval_90": "60–71",
    "confidence_interval_95": "58–72",
    "ci_90_lower": 60,
    "ci_90_upper": 71,
    "ci_95_lower": 58,
    "ci_95_upper": 72,
    "percentile_rank": 1
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 11,
    "composite_standard_score": 65,
    "confidence_interval_90": "61–73",
    "confidence_interval_95": "60–74",
    "ci_90_lower": 61,
    "ci_90_upper": 73,
    "ci_95_lower": 60,
    "ci_95_upper": 74,
    "percentile_rank": 1
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 12,
    "composite_standard_score": 68,
    "confidence_interval_90": "64–76",
    "confidence_interval_95": "63–77",
    "ci_90_lower": 64,
    "ci_90_upper": 76,
    "ci_95_lower": 63,
    "ci_95_upper": 77,
    "percentile_rank": 2
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 13,
    "composite_standard_score": 70,
    "confidence_interval_90": "66–77",
    "confidence_interval_95": "65–79",
    "ci_90_lower": 66,
    "ci_90_upper": 77,
    "ci_95_lower": 65,
    "ci_95_upper": 79,
    "percentile_rank": 2
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 14,
    "composite_standard_score": 71,
    "confidence_interval_90": "67–78",
    "confidence_interval_95": "66–80",
    "ci_90_lower": 67,
    "ci_90_upper": 78,
    "ci_95_lower": 66,
    "ci_95_upper": 80,
    "percentile_rank": 3
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 15,
    "composite_standard_score": 73,
    "confidence_interval_90": "69–80",
    "confidence_interval_95": "68–81",
    "ci_90_lower": 69,
    "ci_90_upper": 80,
    "ci_95_lower": 68,
    "ci_95_upper": 81,
    "percentile_rank": 4
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 16,
    "composite_standard_score": 74,
    "confidence_interval_90": "70–81",
    "confidence_interval_95": "69–82",
    "ci_90_lower": 70,
    "ci_90_upper": 81,
    "ci_95_lower": 69,
    "ci_95_upper": 82,
    "percentile_rank": 4
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 17,
    "composite_standard_score": 76,
    "confidence_interval_90": "72–83",
    "confidence_interval_95": "71–84",
    "ci_90_lower": 72,
    "ci_90_upper": 83,
    "ci_95_lower": 71,
    "ci_95_upper": 84,
    "percentile_rank": 5
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 18,
    "composite_standard_score": 77,
    "confidence_interval_90": "73–84",
    "confidence_interval_95": "72–85",
    "ci_90_lower": 73,
    "ci_90_upper": 84,
    "ci_95_lower": 72,
    "ci_95_upper": 85,
    "percentile_rank": 6
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 19,
    "composite_standard_score": 79,
    "confidence_interval_90": "75–86",
    "confidence_interval_95": "73–87",
    "ci_90_lower": 75,
    "ci_90_upper": 86,
    "ci_95_lower": 73,
    "ci_95_upper": 87,
    "percentile_rank": 8
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 20,
    "composite_standard_score": 80,
    "confidence_interval_90": "76–87",
    "confidence_interval_95": "74–88",
    "ci_90_lower": 76,
    "ci_90_upper": 87,
    "ci_95_lower": 74,
    "ci_95_upper": 88,
    "percentile_rank": 9
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 21,
    "composite_standard_score": 82,
    "confidence_interval_90": "77–89",
    "confidence_interval_95": "76–90",
    "ci_90_lower": 77,
    "ci_90_upper": 89,
    "ci_95_lower": 76,
    "ci_95_upper": 90,
    "percentile_rank": 12
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 22,
    "composite_standard_score": 84,
    "confidence_interval_90": "79–91",
    "confidence_interval_95": "78–92",
    "ci_90_lower": 79,
    "ci_90_upper": 91,
    "ci_95_lower": 78,
    "ci_95_upper": 92,
    "percentile_rank": 14
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 23,
    "composite_standard_score": 86,
    "confidence_interval_90": "81–93",
    "confidence_interval_95": "80–94",
    "ci_90_lower": 81,
    "ci_90_upper": 93,
    "ci_95_lower": 80,
    "ci_95_upper": 94,
    "percentile_rank": 18
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 24,
    "composite_standard_score": 88,
    "confidence_interval_90": "83–94",
    "confidence_interval_95": "82–95",
    "ci_90_lower": 83,
    "ci_90_upper": 94,
    "ci_95_lower": 82,
    "ci_95_upper": 95,
    "percentile_rank": 21
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 25,
    "composite_standard_score": 89,
    "confidence_interval_90": "84–95",
    "confidence_interval_95": "83–96",
    "ci_90_lower": 84,
    "ci_90_upper": 95,
    "ci_95_lower": 83,
    "ci_95_upper": 96,
    "percentile_rank": 23
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 26,
    "composite_standard_score": 91,
    "confidence_interval_90": "86–97",
    "confidence_interval_95": "85–98",
    "ci_90_lower": 86,
    "ci_90_upper": 97,
    "ci_95_lower": 85,
    "ci_95_upper": 98,
    "percentile_rank": 27
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 27,
    "composite_standard_score": 93,
    "confidence_interval_90": "88–99",
    "confidence_interval_95": "87–100",
    "ci_90_lower": 88,
    "ci_90_upper": 99,
    "ci_95_lower": 87,
    "ci_95_upper": 100,
    "percentile_rank": 32
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 28,
    "composite_standard_score": 95,
    "confidence_interval_90": "90–101",
    "confidence_interval_95": "89–102",
    "ci_90_lower": 90,
    "ci_90_upper": 101,
    "ci_95_lower": 89,
    "ci_95_upper": 102,
    "percentile_rank": 37
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 29,
    "composite_standard_score": 98,
    "confidence_interval_90": "92–104",
    "confidence_interval_95": "91–105",
    "ci_90_lower": 92,
    "ci_90_upper": 104,
    "ci_95_lower": 91,
    "ci_95_upper": 105,
    "percentile_rank": 45
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 30,
    "composite_standard_score": 100,
    "confidence_interval_90": "94–106",
    "confidence_interval_95": "93–107",
    "ci_90_lower": 94,
    "ci_90_upper": 106,
    "ci_95_lower": 93,
    "ci_95_upper": 107,
    "percentile_rank": 50
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 31,
    "composite_standard_score": 102,
    "confidence_interval_90": "96–108",
    "confidence_interval_95": "95–109",
    "ci_90_lower": 96,
    "ci_90_upper": 108,
    "ci_95_lower": 95,
    "ci_95_upper": 109,
    "percentile_rank": 55
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 32,
    "composite_standard_score": 105,
    "confidence_interval_90": "99–110",
    "confidence_interval_95": "98–111",
    "ci_90_lower": 99,
    "ci_90_upper": 110,
    "ci_95_lower": 98,
    "ci_95_upper": 111,
    "percentile_rank": 63
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 33,
    "composite_standard_score": 107,
    "confidence_interval_90": "101–112",
    "confidence_interval_95": "100–113",
    "ci_90_lower": 101,
    "ci_90_upper": 112,
    "ci_95_lower": 100,
    "ci_95_upper": 113,
    "percentile_rank": 68
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 34,
    "composite_standard_score": 109,
    "confidence_interval_90": "103–114",
    "confidence_interval_95": "102–115",
    "ci_90_lower": 103,
    "ci_90_upper": 114,
    "ci_95_lower": 102,
    "ci_95_upper": 115,
    "percentile_rank": 73
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 35,
    "composite_standard_score": 111,
    "confidence_interval_90": "105–116",
    "confidence_interval_95": "104–117",
    "ci_90_lower": 105,
    "ci_90_upper": 116,
    "ci_95_lower": 104,
    "ci_95_upper": 117,
    "percentile_rank": 77
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 36,
    "composite_standard_score": 114,
    "confidence_interval_90": "107–119",
    "confidence_interval_95": "106–120",
    "ci_90_lower": 107,
    "ci_90_upper": 119,
    "ci_95_lower": 106,
    "ci_95_upper": 120,
    "percentile_rank": 82
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 37,
    "composite_standard_score": 116,
    "confidence_interval_90": "109–121",
    "confidence_interval_95": "108–122",
    "ci_90_lower": 109,
    "ci_90_upper": 121,
    "ci_95_lower": 108,
    "ci_95_upper": 122,
    "percentile_rank": 86
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 38,
    "composite_standard_score": 118,
    "confidence_interval_90": "111–123",
    "confidence_interval_95": "110–124",
    "ci_90_lower": 111,
    "ci_90_upper": 123,
    "ci_95_lower": 110,
    "ci_95_upper": 124,
    "percentile_rank": 88
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 39,
    "composite_standard_score": 120,
    "confidence_interval_90": "113–124",
    "confidence_interval_95": "112–126",
    "ci_90_lower": 113,
    "ci_90_upper": 124,
    "ci_95_lower": 112,
    "ci_95_upper": 126,
    "percentile_rank": 91
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 40,
    "composite_standard_score": 122,
    "confidence_interval_90": "115–126",
    "confidence_interval_95": "114–127",
    "ci_90_lower": 115,
    "ci_90_upper": 126,
    "ci_95_lower": 114,
    "ci_95_upper": 127,
    "percentile_rank": 93
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 41,
    "composite_standard_score": 124,
    "confidence_interval_90": "117–128",
    "confidence_interval_95": "116–129",
    "ci_90_lower": 117,
    "ci_90_upper": 128,
    "ci_95_lower": 116,
    "ci_95_upper": 129,
    "percentile_rank": 95
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 42,
    "composite_standard_score": 126,
    "confidence_interval_90": "119–130",
    "confidence_interval_95": "118–131",
    "ci_90_lower": 119,
    "ci_90_upper": 130,
    "ci_95_lower": 118,
    "ci_95_upper": 131,
    "percentile_rank": 96
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 43,
    "composite_standard_score": 128,
    "confidence_interval_90": "121–132",
    "confidence_interval_95": "120–133",
    "ci_90_lower": 121,
    "ci_90_upper": 132,
    "ci_95_lower": 120,
    "ci_95_upper": 133,
    "percentile_rank": 97
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 44,
    "composite_standard_score": 130,
    "confidence_interval_90": "123–134",
    "confidence_interval_95": "121–135",
    "ci_90_lower": 123,
    "ci_90_upper": 134,
    "ci_95_lower": 121,
    "ci_95_upper": 135,
    "percentile_rank": 98
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 45,
    "composite_standard_score": 132,
    "confidence_interval_90": "124–136",
    "confidence_interval_95": "123–137",
    "ci_90_lower": 124,
    "ci_90_upper": 136,
    "ci_95_lower": 123,
    "ci_95_upper": 137,
    "percentile_rank": 98
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 46,
    "composite_standard_score": 134,
    "confidence_interval_90": "126–138",
    "confidence_interval_95": "125–139",
    "ci_90_lower": 126,
    "ci_90_upper": 138,
    "ci_95_lower": 125,
    "ci_95_upper": 139,
    "percentile_rank": 99
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 47,
    "composite_standard_score": 136,
    "confidence_interval_90": "128–140",
    "confidence_interval_95": "127–141",
    "ci_90_lower": 128,
    "ci_90_upper": 140,
    "ci_95_lower": 127,
    "ci_95_upper": 141,
    "percentile_rank": 99
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 48,
    "composite_standard_score": 138,
    "confidence_interval_90": "130–141",
    "confidence_interval_95": "129–142",
    "ci_90_lower": 130,
    "ci_90_upper": 141,
    "ci_95_lower": 129,
    "ci_95_upper": 142,
    "percentile_rank": 99
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 49,
    "composite_standard_score": 140,
    "confidence_interval_90": "132–143",
    "confidence_interval_95": "131–144",
    "ci_90_lower": 132,
    "ci_90_upper": 143,
    "ci_95_lower": 131,
    "ci_95_upper": 144,
    "percentile_rank": 99.6
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 50,
    "composite_standard_score": 142,
    "confidence_interval_90": "134–145",
    "confidence_interval_95": "133–146",
    "ci_90_lower": 134,
    "ci_90_upper": 145,
    "ci_95_lower": 133,
    "ci_95_upper": 146,
    "percentile_rank": 99.7
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 51,
    "composite_standard_score": 144,
    "confidence_interval_90": "136–147",
    "confidence_interval_95": "135–148",
    "ci_90_lower": 136,
    "ci_90_upper": 147,
    "ci_95_lower": 135,
    "ci_95_upper": 148,
    "percentile_rank": 99.8
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 52,
    "composite_standard_score": 146,
    "confidence_interval_90": "138–149",
    "confidence_interval_95": "136–150",
    "ci_90_lower": 138,
    "ci_90_upper": 149,
    "ci_95_lower": 136,
    "ci_95_upper": 150,
    "percentile_rank": 99.9
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 53,
    "composite_standard_score": 148,
    "confidence_interval_90": "139–151",
    "confidence_interval_95": "138–152",
    "ci_90_lower": 139,
    "ci_90_upper": 151,
    "ci_95_lower": 138,
    "ci_95_upper": 152,
    "percentile_rank": 99.9
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 54,
    "composite_standard_score": 150,
    "confidence_interval_90": "141–153",
    "confidence_interval_95": "140–154",
    "ci_90_lower": 141,
    "ci_90_upper": 153,
    "ci_95_lower": 140,
    "ci_95_upper": 154,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 55,
    "composite_standard_score": 152,
    "confidence_interval_90": "143–155",
    "confidence_interval_95": "142–156",
    "ci_90_lower": 143,
    "ci_90_upper": 155,
    "ci_95_lower": 142,
    "ci_95_upper": 156,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 56,
    "composite_standard_score": 154,
    "confidence_interval_90": "145–156",
    "confidence_interval_95": "144–158",
    "ci_90_lower": 145,
    "ci_90_upper": 156,
    "ci_95_lower": 144,
    "ci_95_upper": 158,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "6:0",
    "high_age": "6:5",
    "sum_of_scaled_scores": 57,
    "composite_standard_score": 155,
    "confidence_interval_90": "146–157",
    "confidence_interval_95": "145–158",
    "ci_90_lower": 146,
    "ci_90_upper": 157,
    "ci_95_lower": 145,
    "ci_95_upper": 158,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 3,
    "composite_standard_score": 45,
    "confidence_interval_90": "43–57",
    "confidence_interval_95": "42–58",
    "ci_90_lower": 43,
    "ci_90_upper": 57,
    "ci_95_lower": 42,
    "ci_95_upper": 58,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 4,
    "composite_standard_score": 48,
    "confidence_interval_90": "46–59",
    "confidence_interval_95": "45–61",
    "ci_90_lower": 46,
    "ci_90_upper": 59,
    "ci_95_lower": 45,
    "ci_95_upper": 61,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 5,
    "composite_standard_score": 50,
    "confidence_interval_90": "48–61",
    "confidence_interval_95": "46–63",
    "ci_90_lower": 48,
    "ci_90_upper": 61,
    "ci_95_lower": 46,
    "ci_95_upper": 63,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 6,
    "composite_standard_score": 53,
    "confidence_interval_90": "50–64",
    "confidence_interval_95": "49–65",
    "ci_90_lower": 50,
    "ci_90_upper": 64,
    "ci_95_lower": 49,
    "ci_95_upper": 65,
    "percentile_rank": 0.1
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 7,
    "composite_standard_score": 55,
    "confidence_interval_90": "52–66",
    "confidence_interval_95": "51–67",
    "ci_90_lower": 52,
    "ci_90_upper": 66,
    "ci_95_lower": 51,
    "ci_95_upper": 67,
    "percentile_rank": 0.1
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 8,
    "composite_standard_score": 58,
    "confidence_interval_90": "55–69",
    "confidence_interval_95": "54–70",
    "ci_90_lower": 55,
    "ci_90_upper": 69,
    "ci_95_lower": 54,
    "ci_95_upper": 70,
    "percentile_rank": 0.3
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 9,
    "composite_standard_score": 60,
    "confidence_interval_90": "57–70",
    "confidence_interval_95": "56–72",
    "ci_90_lower": 57,
    "ci_90_upper": 70,
    "ci_95_lower": 56,
    "ci_95_upper": 72,
    "percentile_rank": 0.4
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 10,
    "composite_standard_score": 63,
    "confidence_interval_90": "60–73",
    "confidence_interval_95": "58–74",
    "ci_90_lower": 60,
    "ci_90_upper": 73,
    "ci_95_lower": 58,
    "ci_95_upper": 74,
    "percentile_rank": 1
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 11,
    "composite_standard_score": 65,
    "confidence_interval_90": "61–75",
    "confidence_interval_95": "60–76",
    "ci_90_lower": 61,
    "ci_90_upper": 75,
    "ci_95_lower": 60,
    "ci_95_upper": 76,
    "percentile_rank": 1
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 12,
    "composite_standard_score": 68,
    "confidence_interval_90": "64–78",
    "confidence_interval_95": "63–79",
    "ci_90_lower": 64,
    "ci_90_upper": 78,
    "ci_95_lower": 63,
    "ci_95_upper": 79,
    "percentile_rank": 2
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 13,
    "composite_standard_score": 70,
    "confidence_interval_90": "66–79",
    "confidence_interval_95": "65–81",
    "ci_90_lower": 66,
    "ci_90_upper": 79,
    "ci_95_lower": 65,
    "ci_95_upper": 81,
    "percentile_rank": 2
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 14,
    "composite_standard_score": 71,
    "confidence_interval_90": "67–80",
    "confidence_interval_95": "66–82",
    "ci_90_lower": 67,
    "ci_90_upper": 80,
    "ci_95_lower": 66,
    "ci_95_upper": 82,
    "percentile_rank": 3
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 15,
    "composite_standard_score": 73,
    "confidence_interval_90": "69–82",
    "confidence_interval_95": "67–83",
    "ci_90_lower": 69,
    "ci_90_upper": 82,
    "ci_95_lower": 67,
    "ci_95_upper": 83,
    "percentile_rank": 4
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 16,
    "composite_standard_score": 74,
    "confidence_interval_90": "70–83",
    "confidence_interval_95": "68–84",
    "ci_90_lower": 70,
    "ci_90_upper": 83,
    "ci_95_lower": 68,
    "ci_95_upper": 84,
    "percentile_rank": 4
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 17,
    "composite_standard_score": 76,
    "confidence_interval_90": "71–85",
    "confidence_interval_95": "70–86",
    "ci_90_lower": 71,
    "ci_90_upper": 85,
    "ci_95_lower": 70,
    "ci_95_upper": 86,
    "percentile_rank": 5
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 18,
    "composite_standard_score": 77,
    "confidence_interval_90": "72–86",
    "confidence_interval_95": "71–87",
    "ci_90_lower": 72,
    "ci_90_upper": 86,
    "ci_95_lower": 71,
    "ci_95_upper": 87,
    "percentile_rank": 6
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 19,
    "composite_standard_score": 79,
    "confidence_interval_90": "74–88",
    "confidence_interval_95": "73–89",
    "ci_90_lower": 74,
    "ci_90_upper": 88,
    "ci_95_lower": 73,
    "ci_95_upper": 89,
    "percentile_rank": 8
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 20,
    "composite_standard_score": 80,
    "confidence_interval_90": "75–89",
    "confidence_interval_95": "74–90",
    "ci_90_lower": 75,
    "ci_90_upper": 89,
    "ci_95_lower": 74,
    "ci_95_upper": 90,
    "percentile_rank": 9
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 21,
    "composite_standard_score": 82,
    "confidence_interval_90": "77–90",
    "confidence_interval_95": "76–92",
    "ci_90_lower": 77,
    "ci_90_upper": 90,
    "ci_95_lower": 76,
    "ci_95_upper": 92,
    "percentile_rank": 12
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 22,
    "composite_standard_score": 84,
    "confidence_interval_90": "79–92",
    "confidence_interval_95": "77–93",
    "ci_90_lower": 79,
    "ci_90_upper": 92,
    "ci_95_lower": 77,
    "ci_95_upper": 93,
    "percentile_rank": 14
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 23,
    "composite_standard_score": 86,
    "confidence_interval_90": "81–94",
    "confidence_interval_95": "79–95",
    "ci_90_lower": 81,
    "ci_90_upper": 94,
    "ci_95_lower": 79,
    "ci_95_upper": 95,
    "percentile_rank": 18
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 24,
    "composite_standard_score": 88,
    "confidence_interval_90": "82–96",
    "confidence_interval_95": "81–97",
    "ci_90_lower": 82,
    "ci_90_upper": 96,
    "ci_95_lower": 81,
    "ci_95_upper": 97,
    "percentile_rank": 21
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 25,
    "composite_standard_score": 89,
    "confidence_interval_90": "83–97",
    "confidence_interval_95": "82–98",
    "ci_90_lower": 83,
    "ci_90_upper": 97,
    "ci_95_lower": 82,
    "ci_95_upper": 98,
    "percentile_rank": 23
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 26,
    "composite_standard_score": 91,
    "confidence_interval_90": "85–99",
    "confidence_interval_95": "84–100",
    "ci_90_lower": 85,
    "ci_90_upper": 99,
    "ci_95_lower": 84,
    "ci_95_upper": 100,
    "percentile_rank": 27
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 27,
    "composite_standard_score": 93,
    "confidence_interval_90": "87–100",
    "confidence_interval_95": "86–102",
    "ci_90_lower": 87,
    "ci_90_upper": 100,
    "ci_95_lower": 86,
    "ci_95_upper": 102,
    "percentile_rank": 32
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 28,
    "composite_standard_score": 95,
    "confidence_interval_90": "89–102",
    "confidence_interval_95": "87–103",
    "ci_90_lower": 89,
    "ci_90_upper": 102,
    "ci_95_lower": 87,
    "ci_95_upper": 103,
    "percentile_rank": 37
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 29,
    "composite_standard_score": 98,
    "confidence_interval_90": "91–105",
    "confidence_interval_95": "90–106",
    "ci_90_lower": 91,
    "ci_90_upper": 105,
    "ci_95_lower": 90,
    "ci_95_upper": 106,
    "percentile_rank": 45
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 30,
    "composite_standard_score": 100,
    "confidence_interval_90": "93–107",
    "confidence_interval_95": "92–108",
    "ci_90_lower": 93,
    "ci_90_upper": 107,
    "ci_95_lower": 92,
    "ci_95_upper": 108,
    "percentile_rank": 50
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 31,
    "composite_standard_score": 102,
    "confidence_interval_90": "95–109",
    "confidence_interval_95": "94–110",
    "ci_90_lower": 95,
    "ci_90_upper": 109,
    "ci_95_lower": 94,
    "ci_95_upper": 110,
    "percentile_rank": 55
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 32,
    "composite_standard_score": 105,
    "confidence_interval_90": "98–111",
    "confidence_interval_95": "97–113",
    "ci_90_lower": 98,
    "ci_90_upper": 111,
    "ci_95_lower": 97,
    "ci_95_upper": 113,
    "percentile_rank": 63
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 33,
    "composite_standard_score": 107,
    "confidence_interval_90": "100–113",
    "confidence_interval_95": "98–114",
    "ci_90_lower": 100,
    "ci_90_upper": 113,
    "ci_95_lower": 98,
    "ci_95_upper": 114,
    "percentile_rank": 68
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 34,
    "composite_standard_score": 109,
    "confidence_interval_90": "101–115",
    "confidence_interval_95": "100–116",
    "ci_90_lower": 101,
    "ci_90_upper": 115,
    "ci_95_lower": 100,
    "ci_95_upper": 116,
    "percentile_rank": 73
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 35,
    "composite_standard_score": 111,
    "confidence_interval_90": "103–117",
    "confidence_interval_95": "102–118",
    "ci_90_lower": 103,
    "ci_90_upper": 117,
    "ci_95_lower": 102,
    "ci_95_upper": 118,
    "percentile_rank": 77
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 36,
    "composite_standard_score": 114,
    "confidence_interval_90": "106–119",
    "confidence_interval_95": "105–121",
    "ci_90_lower": 106,
    "ci_90_upper": 119,
    "ci_95_lower": 105,
    "ci_95_upper": 121,
    "percentile_rank": 82
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 37,
    "composite_standard_score": 116,
    "confidence_interval_90": "108–121",
    "confidence_interval_95": "107–123",
    "ci_90_lower": 108,
    "ci_90_upper": 121,
    "ci_95_lower": 107,
    "ci_95_upper": 123,
    "percentile_rank": 86
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 38,
    "composite_standard_score": 118,
    "confidence_interval_90": "110–123",
    "confidence_interval_95": "108–124",
    "ci_90_lower": 110,
    "ci_90_upper": 123,
    "ci_95_lower": 108,
    "ci_95_upper": 124,
    "percentile_rank": 88
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 39,
    "composite_standard_score": 120,
    "confidence_interval_90": "111–125",
    "confidence_interval_95": "110–126",
    "ci_90_lower": 111,
    "ci_90_upper": 125,
    "ci_95_lower": 110,
    "ci_95_upper": 126,
    "percentile_rank": 91
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 40,
    "composite_standard_score": 122,
    "confidence_interval_90": "113–127",
    "confidence_interval_95": "112–128",
    "ci_90_lower": 113,
    "ci_90_upper": 127,
    "ci_95_lower": 112,
    "ci_95_upper": 128,
    "percentile_rank": 93
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 41,
    "composite_standard_score": 124,
    "confidence_interval_90": "115–129",
    "confidence_interval_95": "114–130",
    "ci_90_lower": 115,
    "ci_90_upper": 129,
    "ci_95_lower": 114,
    "ci_95_upper": 130,
    "percentile_rank": 95
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 42,
    "composite_standard_score": 126,
    "confidence_interval_90": "117–130",
    "confidence_interval_95": "116–132",
    "ci_90_lower": 117,
    "ci_90_upper": 130,
    "ci_95_lower": 116,
    "ci_95_upper": 132,
    "percentile_rank": 96
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 43,
    "composite_standard_score": 128,
    "confidence_interval_90": "119–132",
    "confidence_interval_95": "117–134",
    "ci_90_lower": 119,
    "ci_90_upper": 132,
    "ci_95_lower": 117,
    "ci_95_upper": 134,
    "percentile_rank": 97
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 44,
    "composite_standard_score": 130,
    "confidence_interval_90": "121–134",
    "confidence_interval_95": "119–135",
    "ci_90_lower": 121,
    "ci_90_upper": 134,
    "ci_95_lower": 119,
    "ci_95_upper": 135,
    "percentile_rank": 98
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 45,
    "composite_standard_score": 132,
    "confidence_interval_90": "122–136",
    "confidence_interval_95": "121–137",
    "ci_90_lower": 122,
    "ci_90_upper": 136,
    "ci_95_lower": 121,
    "ci_95_upper": 137,
    "percentile_rank": 98
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 46,
    "composite_standard_score": 134,
    "confidence_interval_90": "124–138",
    "confidence_interval_95": "123–139",
    "ci_90_lower": 124,
    "ci_90_upper": 138,
    "ci_95_lower": 123,
    "ci_95_upper": 139,
    "percentile_rank": 99
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 47,
    "composite_standard_score": 136,
    "confidence_interval_90": "126–139",
    "confidence_interval_95": "125–141",
    "ci_90_lower": 126,
    "ci_90_upper": 139,
    "ci_95_lower": 125,
    "ci_95_upper": 141,
    "percentile_rank": 99
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 48,
    "composite_standard_score": 138,
    "confidence_interval_90": "128–141",
    "confidence_interval_95": "127–143",
    "ci_90_lower": 128,
    "ci_90_upper": 141,
    "ci_95_lower": 127,
    "ci_95_upper": 143,
    "percentile_rank": 99
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 49,
    "composite_standard_score": 140,
    "confidence_interval_90": "130–143",
    "confidence_interval_95": "128–144",
    "ci_90_lower": 130,
    "ci_90_upper": 143,
    "ci_95_lower": 128,
    "ci_95_upper": 144,
    "percentile_rank": 99.6
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 50,
    "composite_standard_score": 142,
    "confidence_interval_90": "131–145",
    "confidence_interval_95": "130–146",
    "ci_90_lower": 131,
    "ci_90_upper": 145,
    "ci_95_lower": 130,
    "ci_95_upper": 146,
    "percentile_rank": 99.7
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 51,
    "composite_standard_score": 144,
    "confidence_interval_90": "133–147",
    "confidence_interval_95": "132–148",
    "ci_90_lower": 133,
    "ci_90_upper": 147,
    "ci_95_lower": 132,
    "ci_95_upper": 148,
    "percentile_rank": 99.8
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 52,
    "composite_standard_score": 146,
    "confidence_interval_90": "135–149",
    "confidence_interval_95": "134–150",
    "ci_90_lower": 135,
    "ci_90_upper": 149,
    "ci_95_lower": 134,
    "ci_95_upper": 150,
    "percentile_rank": 99.9
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 53,
    "composite_standard_score": 148,
    "confidence_interval_90": "137–150",
    "confidence_interval_95": "136–152",
    "ci_90_lower": 137,
    "ci_90_upper": 150,
    "ci_95_lower": 136,
    "ci_95_upper": 152,
    "percentile_rank": 99.9
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 54,
    "composite_standard_score": 150,
    "confidence_interval_90": "139–152",
    "confidence_interval_95": "137–154",
    "ci_90_lower": 139,
    "ci_90_upper": 152,
    "ci_95_lower": 137,
    "ci_95_upper": 154,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 55,
    "composite_standard_score": 152,
    "confidence_interval_90": "141–154",
    "confidence_interval_95": "139–155",
    "ci_90_lower": 141,
    "ci_90_upper": 154,
    "ci_95_lower": 139,
    "ci_95_upper": 155,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 56,
    "composite_standard_score": 154,
    "confidence_interval_90": "142–156",
    "confidence_interval_95": "141–157",
    "ci_90_lower": 142,
    "ci_90_upper": 156,
    "ci_95_lower": 141,
    "ci_95_upper": 157,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "6:6",
    "high_age": "6:11",
    "sum_of_scaled_scores": 57,
    "composite_standard_score": 155,
    "confidence_interval_90": "143–157",
    "confidence_interval_95": "142–158",
    "ci_90_lower": 143,
    "ci_90_upper": 157,
    "ci_95_lower": 142,
    "ci_95_upper": 158,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 3,
    "composite_standard_score": 45,
    "confidence_interval_90": "44–58",
    "confidence_interval_95": "42–60",
    "ci_90_lower": 44,
    "ci_90_upper": 58,
    "ci_95_lower": 42,
    "ci_95_upper": 60,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 4,
    "composite_standard_score": 48,
    "confidence_interval_90": "46–61",
    "confidence_interval_95": "45–62",
    "ci_90_lower": 46,
    "ci_90_upper": 61,
    "ci_95_lower": 45,
    "ci_95_upper": 62,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 5,
    "composite_standard_score": 50,
    "confidence_interval_90": "48–63",
    "confidence_interval_95": "47–64",
    "ci_90_lower": 48,
    "ci_90_upper": 63,
    "ci_95_lower": 47,
    "ci_95_upper": 64,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 6,
    "composite_standard_score": 53,
    "confidence_interval_90": "51–65",
    "confidence_interval_95": "49–67",
    "ci_90_lower": 51,
    "ci_90_upper": 65,
    "ci_95_lower": 49,
    "ci_95_upper": 67,
    "percentile_rank": 0.1
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 7,
    "composite_standard_score": 55,
    "confidence_interval_90": "53–67",
    "confidence_interval_95": "51–69",
    "ci_90_lower": 53,
    "ci_90_upper": 67,
    "ci_95_lower": 51,
    "ci_95_upper": 69,
    "percentile_rank": 0.1
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 8,
    "composite_standard_score": 58,
    "confidence_interval_90": "55–70",
    "confidence_interval_95": "54–71",
    "ci_90_lower": 55,
    "ci_90_upper": 70,
    "ci_95_lower": 54,
    "ci_95_upper": 71,
    "percentile_rank": 0.3
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 9,
    "composite_standard_score": 60,
    "confidence_interval_90": "57–72",
    "confidence_interval_95": "56–73",
    "ci_90_lower": 57,
    "ci_90_upper": 72,
    "ci_95_lower": 56,
    "ci_95_upper": 73,
    "percentile_rank": 0.4
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 10,
    "composite_standard_score": 63,
    "confidence_interval_90": "60–74",
    "confidence_interval_95": "58–76",
    "ci_90_lower": 60,
    "ci_90_upper": 74,
    "ci_95_lower": 58,
    "ci_95_upper": 76,
    "percentile_rank": 1
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 11,
    "composite_standard_score": 65,
    "confidence_interval_90": "62–76",
    "confidence_interval_95": "60–78",
    "ci_90_lower": 62,
    "ci_90_upper": 76,
    "ci_95_lower": 60,
    "ci_95_upper": 78,
    "percentile_rank": 1
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 12,
    "composite_standard_score": 68,
    "confidence_interval_90": "64–79",
    "confidence_interval_95": "63–80",
    "ci_90_lower": 64,
    "ci_90_upper": 79,
    "ci_95_lower": 63,
    "ci_95_upper": 80,
    "percentile_rank": 2
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 13,
    "composite_standard_score": 70,
    "confidence_interval_90": "66–81",
    "confidence_interval_95": "65–82",
    "ci_90_lower": 66,
    "ci_90_upper": 81,
    "ci_95_lower": 65,
    "ci_95_upper": 82,
    "percentile_rank": 2
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 14,
    "composite_standard_score": 71,
    "confidence_interval_90": "67–81",
    "confidence_interval_95": "66–83",
    "ci_90_lower": 67,
    "ci_90_upper": 81,
    "ci_95_lower": 66,
    "ci_95_upper": 83,
    "percentile_rank": 3
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 15,
    "composite_standard_score": 73,
    "confidence_interval_90": "69–83",
    "confidence_interval_95": "67–85",
    "ci_90_lower": 69,
    "ci_90_upper": 83,
    "ci_95_lower": 67,
    "ci_95_upper": 85,
    "percentile_rank": 4
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 16,
    "composite_standard_score": 74,
    "confidence_interval_90": "70–84",
    "confidence_interval_95": "68–86",
    "ci_90_lower": 70,
    "ci_90_upper": 84,
    "ci_95_lower": 68,
    "ci_95_upper": 86,
    "percentile_rank": 4
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 17,
    "composite_standard_score": 76,
    "confidence_interval_90": "71–86",
    "confidence_interval_95": "70–87",
    "ci_90_lower": 71,
    "ci_90_upper": 86,
    "ci_95_lower": 70,
    "ci_95_upper": 87,
    "percentile_rank": 5
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 18,
    "composite_standard_score": 77,
    "confidence_interval_90": "72–87",
    "confidence_interval_95": "71–88",
    "ci_90_lower": 72,
    "ci_90_upper": 87,
    "ci_95_lower": 71,
    "ci_95_upper": 88,
    "percentile_rank": 6
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 19,
    "composite_standard_score": 79,
    "confidence_interval_90": "74–89",
    "confidence_interval_95": "73–90",
    "ci_90_lower": 74,
    "ci_90_upper": 89,
    "ci_95_lower": 73,
    "ci_95_upper": 90,
    "percentile_rank": 8
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 20,
    "composite_standard_score": 80,
    "confidence_interval_90": "75–89",
    "confidence_interval_95": "74–91",
    "ci_90_lower": 75,
    "ci_90_upper": 89,
    "ci_95_lower": 74,
    "ci_95_upper": 91,
    "percentile_rank": 9
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 21,
    "composite_standard_score": 82,
    "confidence_interval_90": "77–91",
    "confidence_interval_95": "75–93",
    "ci_90_lower": 77,
    "ci_90_upper": 91,
    "ci_95_lower": 75,
    "ci_95_upper": 93,
    "percentile_rank": 12
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 22,
    "composite_standard_score": 84,
    "confidence_interval_90": "78–93",
    "confidence_interval_95": "77–94",
    "ci_90_lower": 78,
    "ci_90_upper": 93,
    "ci_95_lower": 77,
    "ci_95_upper": 94,
    "percentile_rank": 14
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 23,
    "composite_standard_score": 86,
    "confidence_interval_90": "80–95",
    "confidence_interval_95": "79–96",
    "ci_90_lower": 80,
    "ci_90_upper": 95,
    "ci_95_lower": 79,
    "ci_95_upper": 96,
    "percentile_rank": 18
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 24,
    "composite_standard_score": 88,
    "confidence_interval_90": "82–97",
    "confidence_interval_95": "81–98",
    "ci_90_lower": 82,
    "ci_90_upper": 97,
    "ci_95_lower": 81,
    "ci_95_upper": 98,
    "percentile_rank": 21
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 25,
    "composite_standard_score": 89,
    "confidence_interval_90": "83–97",
    "confidence_interval_95": "82–99",
    "ci_90_lower": 83,
    "ci_90_upper": 97,
    "ci_95_lower": 82,
    "ci_95_upper": 99,
    "percentile_rank": 23
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 26,
    "composite_standard_score": 91,
    "confidence_interval_90": "85–99",
    "confidence_interval_95": "83–101",
    "ci_90_lower": 85,
    "ci_90_upper": 99,
    "ci_95_lower": 83,
    "ci_95_upper": 101,
    "percentile_rank": 27
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 27,
    "composite_standard_score": 93,
    "confidence_interval_90": "86–101",
    "confidence_interval_95": "85–102",
    "ci_90_lower": 86,
    "ci_90_upper": 101,
    "ci_95_lower": 85,
    "ci_95_upper": 102,
    "percentile_rank": 32
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 28,
    "composite_standard_score": 95,
    "confidence_interval_90": "88–103",
    "confidence_interval_95": "87–104",
    "ci_90_lower": 88,
    "ci_90_upper": 103,
    "ci_95_lower": 87,
    "ci_95_upper": 104,
    "percentile_rank": 37
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 29,
    "composite_standard_score": 98,
    "confidence_interval_90": "91–106",
    "confidence_interval_95": "90–107",
    "ci_90_lower": 91,
    "ci_90_upper": 106,
    "ci_95_lower": 90,
    "ci_95_upper": 107,
    "percentile_rank": 45
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 30,
    "composite_standard_score": 100,
    "confidence_interval_90": "93–107",
    "confidence_interval_95": "91–109",
    "ci_90_lower": 93,
    "ci_90_upper": 107,
    "ci_95_lower": 91,
    "ci_95_upper": 109,
    "percentile_rank": 50
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 31,
    "composite_standard_score": 102,
    "confidence_interval_90": "94–109",
    "confidence_interval_95": "93–110",
    "ci_90_lower": 94,
    "ci_90_upper": 109,
    "ci_95_lower": 93,
    "ci_95_upper": 110,
    "percentile_rank": 55
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 32,
    "composite_standard_score": 105,
    "confidence_interval_90": "97–112",
    "confidence_interval_95": "96–113",
    "ci_90_lower": 97,
    "ci_90_upper": 112,
    "ci_95_lower": 96,
    "ci_95_upper": 113,
    "percentile_rank": 63
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 33,
    "composite_standard_score": 107,
    "confidence_interval_90": "99–114",
    "confidence_interval_95": "98–115",
    "ci_90_lower": 99,
    "ci_90_upper": 114,
    "ci_95_lower": 98,
    "ci_95_upper": 115,
    "percentile_rank": 68
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 34,
    "composite_standard_score": 109,
    "confidence_interval_90": "101–115",
    "confidence_interval_95": "99–117",
    "ci_90_lower": 101,
    "ci_90_upper": 115,
    "ci_95_lower": 99,
    "ci_95_upper": 117,
    "percentile_rank": 73
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 35,
    "composite_standard_score": 111,
    "confidence_interval_90": "103–117",
    "confidence_interval_95": "101–118",
    "ci_90_lower": 103,
    "ci_90_upper": 117,
    "ci_95_lower": 101,
    "ci_95_upper": 118,
    "percentile_rank": 77
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 36,
    "composite_standard_score": 114,
    "confidence_interval_90": "105–120",
    "confidence_interval_95": "104–121",
    "ci_90_lower": 105,
    "ci_90_upper": 120,
    "ci_95_lower": 104,
    "ci_95_upper": 121,
    "percentile_rank": 82
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 37,
    "composite_standard_score": 116,
    "confidence_interval_90": "107–122",
    "confidence_interval_95": "106–123",
    "ci_90_lower": 107,
    "ci_90_upper": 122,
    "ci_95_lower": 106,
    "ci_95_upper": 123,
    "percentile_rank": 86
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 38,
    "composite_standard_score": 118,
    "confidence_interval_90": "109–123",
    "confidence_interval_95": "107–125",
    "ci_90_lower": 109,
    "ci_90_upper": 123,
    "ci_95_lower": 107,
    "ci_95_upper": 125,
    "percentile_rank": 88
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 39,
    "composite_standard_score": 120,
    "confidence_interval_90": "111–125",
    "confidence_interval_95": "109–126",
    "ci_90_lower": 111,
    "ci_90_upper": 125,
    "ci_95_lower": 109,
    "ci_95_upper": 126,
    "percentile_rank": 91
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 40,
    "composite_standard_score": 122,
    "confidence_interval_90": "112–127",
    "confidence_interval_95": "111–128",
    "ci_90_lower": 112,
    "ci_90_upper": 127,
    "ci_95_lower": 111,
    "ci_95_upper": 128,
    "percentile_rank": 93
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 41,
    "composite_standard_score": 124,
    "confidence_interval_90": "114–129",
    "confidence_interval_95": "113–130",
    "ci_90_lower": 114,
    "ci_90_upper": 129,
    "ci_95_lower": 113,
    "ci_95_upper": 130,
    "percentile_rank": 95
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 42,
    "composite_standard_score": 126,
    "confidence_interval_90": "116–130",
    "confidence_interval_95": "114–132",
    "ci_90_lower": 116,
    "ci_90_upper": 130,
    "ci_95_lower": 114,
    "ci_95_upper": 132,
    "percentile_rank": 96
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 43,
    "composite_standard_score": 128,
    "confidence_interval_90": "118–132",
    "confidence_interval_95": "116–134",
    "ci_90_lower": 118,
    "ci_90_upper": 132,
    "ci_95_lower": 116,
    "ci_95_upper": 134,
    "percentile_rank": 97
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 44,
    "composite_standard_score": 130,
    "confidence_interval_90": "119–134",
    "confidence_interval_95": "118–135",
    "ci_90_lower": 119,
    "ci_90_upper": 134,
    "ci_95_lower": 118,
    "ci_95_upper": 135,
    "percentile_rank": 98
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 45,
    "composite_standard_score": 132,
    "confidence_interval_90": "121–136",
    "confidence_interval_95": "120–137",
    "ci_90_lower": 121,
    "ci_90_upper": 136,
    "ci_95_lower": 120,
    "ci_95_upper": 137,
    "percentile_rank": 98
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 46,
    "composite_standard_score": 134,
    "confidence_interval_90": "123–138",
    "confidence_interval_95": "122–139",
    "ci_90_lower": 123,
    "ci_90_upper": 138,
    "ci_95_lower": 122,
    "ci_95_upper": 139,
    "percentile_rank": 99
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 47,
    "composite_standard_score": 136,
    "confidence_interval_90": "125–139",
    "confidence_interval_95": "123–141",
    "ci_90_lower": 125,
    "ci_90_upper": 139,
    "ci_95_lower": 123,
    "ci_95_upper": 141,
    "percentile_rank": 99
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 48,
    "composite_standard_score": 138,
    "confidence_interval_90": "127–141",
    "confidence_interval_95": "125–142",
    "ci_90_lower": 127,
    "ci_90_upper": 141,
    "ci_95_lower": 125,
    "ci_95_upper": 142,
    "percentile_rank": 99
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 49,
    "composite_standard_score": 140,
    "confidence_interval_90": "128–143",
    "confidence_interval_95": "127–144",
    "ci_90_lower": 128,
    "ci_90_upper": 143,
    "ci_95_lower": 127,
    "ci_95_upper": 144,
    "percentile_rank": 99.6
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 50,
    "composite_standard_score": 142,
    "confidence_interval_90": "130–145",
    "confidence_interval_95": "129–146",
    "ci_90_lower": 130,
    "ci_90_upper": 145,
    "ci_95_lower": 129,
    "ci_95_upper": 146,
    "percentile_rank": 99.7
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 51,
    "composite_standard_score": 144,
    "confidence_interval_90": "132–146",
    "confidence_interval_95": "130–148",
    "ci_90_lower": 132,
    "ci_90_upper": 146,
    "ci_95_lower": 130,
    "ci_95_upper": 148,
    "percentile_rank": 99.8
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 52,
    "composite_standard_score": 146,
    "confidence_interval_90": "134–148",
    "confidence_interval_95": "132–150",
    "ci_90_lower": 134,
    "ci_90_upper": 148,
    "ci_95_lower": 132,
    "ci_95_upper": 150,
    "percentile_rank": 99.9
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 53,
    "composite_standard_score": 148,
    "confidence_interval_90": "135–150",
    "confidence_interval_95": "134–151",
    "ci_90_lower": 135,
    "ci_90_upper": 150,
    "ci_95_lower": 134,
    "ci_95_upper": 151,
    "percentile_rank": 99.9
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 54,
    "composite_standard_score": 150,
    "confidence_interval_90": "137–152",
    "confidence_interval_95": "136–153",
    "ci_90_lower": 137,
    "ci_90_upper": 152,
    "ci_95_lower": 136,
    "ci_95_upper": 153,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 55,
    "composite_standard_score": 152,
    "confidence_interval_90": "139–154",
    "confidence_interval_95": "138–155",
    "ci_90_lower": 139,
    "ci_90_upper": 154,
    "ci_95_lower": 138,
    "ci_95_upper": 155,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 56,
    "composite_standard_score": 154,
    "confidence_interval_90": "141–155",
    "confidence_interval_95": "139–157",
    "ci_90_lower": 141,
    "ci_90_upper": 155,
    "ci_95_lower": 139,
    "ci_95_upper": 157,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "7:0",
    "high_age": "7:11",
    "sum_of_scaled_scores": 57,
    "composite_standard_score": 155,
    "confidence_interval_90": "142–156",
    "confidence_interval_95": "140–158",
    "ci_90_lower": 142,
    "ci_90_upper": 156,
    "ci_95_lower": 140,
    "ci_95_upper": 158,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 3,
    "composite_standard_score": 45,
    "confidence_interval_90": "45–61",
    "confidence_interval_95": "44–63",
    "ci_90_lower": 45,
    "ci_90_upper": 61,
    "ci_95_lower": 44,
    "ci_95_upper": 63,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 4,
    "composite_standard_score": 48,
    "confidence_interval_90": "48–64",
    "confidence_interval_95": "46–65",
    "ci_90_lower": 48,
    "ci_90_upper": 64,
    "ci_95_lower": 46,
    "ci_95_upper": 65,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 5,
    "composite_standard_score": 50,
    "confidence_interval_90": "49–66",
    "confidence_interval_95": "48–67",
    "ci_90_lower": 49,
    "ci_90_upper": 66,
    "ci_95_lower": 48,
    "ci_95_upper": 67,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 6,
    "composite_standard_score": 53,
    "confidence_interval_90": "52–68",
    "confidence_interval_95": "50–70",
    "ci_90_lower": 52,
    "ci_90_upper": 68,
    "ci_95_lower": 50,
    "ci_95_upper": 70,
    "percentile_rank": 0.1
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 7,
    "composite_standard_score": 55,
    "confidence_interval_90": "54–70",
    "confidence_interval_95": "52–71",
    "ci_90_lower": 54,
    "ci_90_upper": 70,
    "ci_95_lower": 52,
    "ci_95_upper": 71,
    "percentile_rank": 0.1
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 8,
    "composite_standard_score": 58,
    "confidence_interval_90": "56–72",
    "confidence_interval_95": "55–74",
    "ci_90_lower": 56,
    "ci_90_upper": 72,
    "ci_95_lower": 55,
    "ci_95_upper": 74,
    "percentile_rank": 0.3
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 9,
    "composite_standard_score": 60,
    "confidence_interval_90": "58–74",
    "confidence_interval_95": "56–76",
    "ci_90_lower": 58,
    "ci_90_upper": 74,
    "ci_95_lower": 56,
    "ci_95_upper": 76,
    "percentile_rank": 0.4
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 10,
    "composite_standard_score": 63,
    "confidence_interval_90": "60–77",
    "confidence_interval_95": "59–78",
    "ci_90_lower": 60,
    "ci_90_upper": 77,
    "ci_95_lower": 59,
    "ci_95_upper": 78,
    "percentile_rank": 1
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 11,
    "composite_standard_score": 65,
    "confidence_interval_90": "62–78",
    "confidence_interval_95": "61–80",
    "ci_90_lower": 62,
    "ci_90_upper": 78,
    "ci_95_lower": 61,
    "ci_95_upper": 80,
    "percentile_rank": 1
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 12,
    "composite_standard_score": 68,
    "confidence_interval_90": "65–81",
    "confidence_interval_95": "63–82",
    "ci_90_lower": 65,
    "ci_90_upper": 81,
    "ci_95_lower": 63,
    "ci_95_upper": 82,
    "percentile_rank": 2
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 13,
    "composite_standard_score": 70,
    "confidence_interval_90": "66–83",
    "confidence_interval_95": "65–84",
    "ci_90_lower": 66,
    "ci_90_upper": 83,
    "ci_95_lower": 65,
    "ci_95_upper": 84,
    "percentile_rank": 2
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 14,
    "composite_standard_score": 71,
    "confidence_interval_90": "67–83",
    "confidence_interval_95": "66–85",
    "ci_90_lower": 67,
    "ci_90_upper": 83,
    "ci_95_lower": 66,
    "ci_95_upper": 85,
    "percentile_rank": 3
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 15,
    "composite_standard_score": 73,
    "confidence_interval_90": "69–85",
    "confidence_interval_95": "67–87",
    "ci_90_lower": 69,
    "ci_90_upper": 85,
    "ci_95_lower": 67,
    "ci_95_upper": 87,
    "percentile_rank": 4
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 16,
    "composite_standard_score": 74,
    "confidence_interval_90": "70–86",
    "confidence_interval_95": "68–88",
    "ci_90_lower": 70,
    "ci_90_upper": 86,
    "ci_95_lower": 68,
    "ci_95_upper": 88,
    "percentile_rank": 4
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 17,
    "composite_standard_score": 76,
    "confidence_interval_90": "71–88",
    "confidence_interval_95": "70–89",
    "ci_90_lower": 71,
    "ci_90_upper": 88,
    "ci_95_lower": 70,
    "ci_95_upper": 89,
    "percentile_rank": 5
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 18,
    "composite_standard_score": 77,
    "confidence_interval_90": "72–89",
    "confidence_interval_95": "71–90",
    "ci_90_lower": 72,
    "ci_90_upper": 89,
    "ci_95_lower": 71,
    "ci_95_upper": 90,
    "percentile_rank": 6
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 19,
    "composite_standard_score": 79,
    "confidence_interval_90": "74–90",
    "confidence_interval_95": "72–92",
    "ci_90_lower": 74,
    "ci_90_upper": 90,
    "ci_95_lower": 72,
    "ci_95_upper": 92,
    "percentile_rank": 8
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 20,
    "composite_standard_score": 80,
    "confidence_interval_90": "75–91",
    "confidence_interval_95": "73–93",
    "ci_90_lower": 75,
    "ci_90_upper": 91,
    "ci_95_lower": 73,
    "ci_95_upper": 93,
    "percentile_rank": 9
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 21,
    "composite_standard_score": 82,
    "confidence_interval_90": "77–93",
    "confidence_interval_95": "75–94",
    "ci_90_lower": 77,
    "ci_90_upper": 93,
    "ci_95_lower": 75,
    "ci_95_upper": 94,
    "percentile_rank": 12
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 22,
    "composite_standard_score": 84,
    "confidence_interval_90": "78–95",
    "confidence_interval_95": "77–96",
    "ci_90_lower": 78,
    "ci_90_upper": 95,
    "ci_95_lower": 77,
    "ci_95_upper": 96,
    "percentile_rank": 14
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 23,
    "composite_standard_score": 86,
    "confidence_interval_90": "80–96",
    "confidence_interval_95": "78–98",
    "ci_90_lower": 80,
    "ci_90_upper": 96,
    "ci_95_lower": 78,
    "ci_95_upper": 98,
    "percentile_rank": 18
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 24,
    "composite_standard_score": 88,
    "confidence_interval_90": "82–98",
    "confidence_interval_95": "80–99",
    "ci_90_lower": 82,
    "ci_90_upper": 98,
    "ci_95_lower": 80,
    "ci_95_upper": 99,
    "percentile_rank": 21
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 25,
    "composite_standard_score": 89,
    "confidence_interval_90": "83–99",
    "confidence_interval_95": "81–100",
    "ci_90_lower": 83,
    "ci_90_upper": 99,
    "ci_95_lower": 81,
    "ci_95_upper": 100,
    "percentile_rank": 23
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 26,
    "composite_standard_score": 91,
    "confidence_interval_90": "84–100",
    "confidence_interval_95": "83–102",
    "ci_90_lower": 84,
    "ci_90_upper": 100,
    "ci_95_lower": 83,
    "ci_95_upper": 102,
    "percentile_rank": 27
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 27,
    "composite_standard_score": 93,
    "confidence_interval_90": "86–102",
    "confidence_interval_95": "84–104",
    "ci_90_lower": 86,
    "ci_90_upper": 102,
    "ci_95_lower": 84,
    "ci_95_upper": 104,
    "percentile_rank": 32
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 28,
    "composite_standard_score": 95,
    "confidence_interval_90": "88–104",
    "confidence_interval_95": "86–105",
    "ci_90_lower": 88,
    "ci_90_upper": 104,
    "ci_95_lower": 86,
    "ci_95_upper": 105,
    "percentile_rank": 37
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 29,
    "composite_standard_score": 98,
    "confidence_interval_90": "90–106",
    "confidence_interval_95": "89–108",
    "ci_90_lower": 90,
    "ci_90_upper": 106,
    "ci_95_lower": 89,
    "ci_95_upper": 108,
    "percentile_rank": 45
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 30,
    "composite_standard_score": 100,
    "confidence_interval_90": "92–108",
    "confidence_interval_95": "90–110",
    "ci_90_lower": 92,
    "ci_90_upper": 108,
    "ci_95_lower": 90,
    "ci_95_upper": 110,
    "percentile_rank": 50
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 31,
    "composite_standard_score": 102,
    "confidence_interval_90": "94–110",
    "confidence_interval_95": "92–111",
    "ci_90_lower": 94,
    "ci_90_upper": 110,
    "ci_95_lower": 92,
    "ci_95_upper": 111,
    "percentile_rank": 55
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 32,
    "composite_standard_score": 105,
    "confidence_interval_90": "96–112",
    "confidence_interval_95": "95–114",
    "ci_90_lower": 96,
    "ci_90_upper": 112,
    "ci_95_lower": 95,
    "ci_95_upper": 114,
    "percentile_rank": 63
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 33,
    "composite_standard_score": 107,
    "confidence_interval_90": "98–114",
    "confidence_interval_95": "96–116",
    "ci_90_lower": 98,
    "ci_90_upper": 114,
    "ci_95_lower": 96,
    "ci_95_upper": 116,
    "percentile_rank": 68
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 34,
    "composite_standard_score": 109,
    "confidence_interval_90": "100–116",
    "confidence_interval_95": "98–117",
    "ci_90_lower": 100,
    "ci_90_upper": 116,
    "ci_95_lower": 98,
    "ci_95_upper": 117,
    "percentile_rank": 73
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 35,
    "composite_standard_score": 111,
    "confidence_interval_90": "101–117",
    "confidence_interval_95": "100–119",
    "ci_90_lower": 101,
    "ci_90_upper": 117,
    "ci_95_lower": 100,
    "ci_95_upper": 119,
    "percentile_rank": 77
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 36,
    "composite_standard_score": 114,
    "confidence_interval_90": "104–120",
    "confidence_interval_95": "102–122",
    "ci_90_lower": 104,
    "ci_90_upper": 120,
    "ci_95_lower": 102,
    "ci_95_upper": 122,
    "percentile_rank": 82
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 37,
    "composite_standard_score": 116,
    "confidence_interval_90": "105–122",
    "confidence_interval_95": "104–123",
    "ci_90_lower": 105,
    "ci_90_upper": 122,
    "ci_95_lower": 104,
    "ci_95_upper": 123,
    "percentile_rank": 86
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 38,
    "composite_standard_score": 118,
    "confidence_interval_90": "107–123",
    "confidence_interval_95": "106–125",
    "ci_90_lower": 107,
    "ci_90_upper": 123,
    "ci_95_lower": 106,
    "ci_95_upper": 125,
    "percentile_rank": 88
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 39,
    "composite_standard_score": 120,
    "confidence_interval_90": "109–125",
    "confidence_interval_95": "107–127",
    "ci_90_lower": 109,
    "ci_90_upper": 125,
    "ci_95_lower": 107,
    "ci_95_upper": 127,
    "percentile_rank": 91
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 40,
    "composite_standard_score": 122,
    "confidence_interval_90": "111–127",
    "confidence_interval_95": "109–128",
    "ci_90_lower": 111,
    "ci_90_upper": 127,
    "ci_95_lower": 109,
    "ci_95_upper": 128,
    "percentile_rank": 93
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 41,
    "composite_standard_score": 124,
    "confidence_interval_90": "112–129",
    "confidence_interval_95": "111–130",
    "ci_90_lower": 112,
    "ci_90_upper": 129,
    "ci_95_lower": 111,
    "ci_95_upper": 130,
    "percentile_rank": 95
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 42,
    "composite_standard_score": 126,
    "confidence_interval_90": "114–130",
    "confidence_interval_95": "112–132",
    "ci_90_lower": 114,
    "ci_90_upper": 130,
    "ci_95_lower": 112,
    "ci_95_upper": 132,
    "percentile_rank": 96
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 43,
    "composite_standard_score": 128,
    "confidence_interval_90": "116–132",
    "confidence_interval_95": "114–133",
    "ci_90_lower": 116,
    "ci_90_upper": 132,
    "ci_95_lower": 114,
    "ci_95_upper": 133,
    "percentile_rank": 97
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 44,
    "composite_standard_score": 130,
    "confidence_interval_90": "117–134",
    "confidence_interval_95": "116–135",
    "ci_90_lower": 117,
    "ci_90_upper": 134,
    "ci_95_lower": 116,
    "ci_95_upper": 135,
    "percentile_rank": 98
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 45,
    "composite_standard_score": 132,
    "confidence_interval_90": "119–135",
    "confidence_interval_95": "118–137",
    "ci_90_lower": 119,
    "ci_90_upper": 135,
    "ci_95_lower": 118,
    "ci_95_upper": 137,
    "percentile_rank": 98
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 46,
    "composite_standard_score": 134,
    "confidence_interval_90": "121–137",
    "confidence_interval_95": "119–139",
    "ci_90_lower": 121,
    "ci_90_upper": 137,
    "ci_95_lower": 119,
    "ci_95_upper": 139,
    "percentile_rank": 99
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 47,
    "composite_standard_score": 136,
    "confidence_interval_90": "122–139",
    "confidence_interval_95": "121–140",
    "ci_90_lower": 122,
    "ci_90_upper": 139,
    "ci_95_lower": 121,
    "ci_95_upper": 140,
    "percentile_rank": 99
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 48,
    "composite_standard_score": 138,
    "confidence_interval_90": "124–140",
    "confidence_interval_95": "123–142",
    "ci_90_lower": 124,
    "ci_90_upper": 140,
    "ci_95_lower": 123,
    "ci_95_upper": 142,
    "percentile_rank": 99
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 49,
    "composite_standard_score": 140,
    "confidence_interval_90": "126–142",
    "confidence_interval_95": "124–144",
    "ci_90_lower": 126,
    "ci_90_upper": 142,
    "ci_95_lower": 124,
    "ci_95_upper": 144,
    "percentile_rank": 99.6
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 50,
    "composite_standard_score": 142,
    "confidence_interval_90": "128–144",
    "confidence_interval_95": "126–145",
    "ci_90_lower": 128,
    "ci_90_upper": 144,
    "ci_95_lower": 126,
    "ci_95_upper": 145,
    "percentile_rank": 99.7
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 51,
    "composite_standard_score": 144,
    "confidence_interval_90": "129–146",
    "confidence_interval_95": "128–147",
    "ci_90_lower": 129,
    "ci_90_upper": 146,
    "ci_95_lower": 128,
    "ci_95_upper": 147,
    "percentile_rank": 99.8
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 52,
    "composite_standard_score": 146,
    "confidence_interval_90": "131–147",
    "confidence_interval_95": "129–149",
    "ci_90_lower": 131,
    "ci_90_upper": 147,
    "ci_95_lower": 129,
    "ci_95_upper": 149,
    "percentile_rank": 99.9
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 53,
    "composite_standard_score": 148,
    "confidence_interval_90": "133–149",
    "confidence_interval_95": "131–150",
    "ci_90_lower": 133,
    "ci_90_upper": 149,
    "ci_95_lower": 131,
    "ci_95_upper": 150,
    "percentile_rank": 99.9
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 54,
    "composite_standard_score": 150,
    "confidence_interval_90": "134–151",
    "confidence_interval_95": "133–152",
    "ci_90_lower": 134,
    "ci_90_upper": 151,
    "ci_95_lower": 133,
    "ci_95_upper": 152,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 55,
    "composite_standard_score": 152,
    "confidence_interval_90": "136–152",
    "confidence_interval_95": "135–154",
    "ci_90_lower": 136,
    "ci_90_upper": 152,
    "ci_95_lower": 135,
    "ci_95_upper": 154,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 56,
    "composite_standard_score": 154,
    "confidence_interval_90": "138–154",
    "confidence_interval_95": "136–156",
    "ci_90_lower": 138,
    "ci_90_upper": 154,
    "ci_95_lower": 136,
    "ci_95_upper": 156,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "8:0",
    "high_age": "8:11",
    "sum_of_scaled_scores": 57,
    "composite_standard_score": 155,
    "confidence_interval_90": "139–155",
    "confidence_interval_95": "137–156",
    "ci_90_lower": 139,
    "ci_90_upper": 155,
    "ci_95_lower": 137,
    "ci_95_upper": 156,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 3,
    "composite_standard_score": 45,
    "confidence_interval_90": "44–58",
    "confidence_interval_95": "42–60",
    "ci_90_lower": 44,
    "ci_90_upper": 58,
    "ci_95_lower": 42,
    "ci_95_upper": 60,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 4,
    "composite_standard_score": 48,
    "confidence_interval_90": "46–61",
    "confidence_interval_95": "45–62",
    "ci_90_lower": 46,
    "ci_90_upper": 61,
    "ci_95_lower": 45,
    "ci_95_upper": 62,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 5,
    "composite_standard_score": 50,
    "confidence_interval_90": "48–63",
    "confidence_interval_95": "47–64",
    "ci_90_lower": 48,
    "ci_90_upper": 63,
    "ci_95_lower": 47,
    "ci_95_upper": 64,
    "percentile_rank": "<0.1"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 6,
    "composite_standard_score": 53,
    "confidence_interval_90": "51–65",
    "confidence_interval_95": "49–67",
    "ci_90_lower": 51,
    "ci_90_upper": 65,
    "ci_95_lower": 49,
    "ci_95_upper": 67,
    "percentile_rank": 0.1
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 7,
    "composite_standard_score": 55,
    "confidence_interval_90": "53–67",
    "confidence_interval_95": "51–69",
    "ci_90_lower": 53,
    "ci_90_upper": 67,
    "ci_95_lower": 51,
    "ci_95_upper": 69,
    "percentile_rank": 0.1
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 8,
    "composite_standard_score": 58,
    "confidence_interval_90": "55–70",
    "confidence_interval_95": "54–71",
    "ci_90_lower": 55,
    "ci_90_upper": 70,
    "ci_95_lower": 54,
    "ci_95_upper": 71,
    "percentile_rank": 0.3
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 9,
    "composite_standard_score": 60,
    "confidence_interval_90": "57–72",
    "confidence_interval_95": "56–73",
    "ci_90_lower": 57,
    "ci_90_upper": 72,
    "ci_95_lower": 56,
    "ci_95_upper": 73,
    "percentile_rank": 0.4
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 10,
    "composite_standard_score": 63,
    "confidence_interval_90": "60–74",
    "confidence_interval_95": "58–76",
    "ci_90_lower": 60,
    "ci_90_upper": 74,
    "ci_95_lower": 58,
    "ci_95_upper": 76,
    "percentile_rank": 1
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 11,
    "composite_standard_score": 65,
    "confidence_interval_90": "62–76",
    "confidence_interval_95": "60–78",
    "ci_90_lower": 62,
    "ci_90_upper": 76,
    "ci_95_lower": 60,
    "ci_95_upper": 78,
    "percentile_rank": 1
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 12,
    "composite_standard_score": 68,
    "confidence_interval_90": "64–79",
    "confidence_interval_95": "63–80",
    "ci_90_lower": 64,
    "ci_90_upper": 79,
    "ci_95_lower": 63,
    "ci_95_upper": 80,
    "percentile_rank": 2
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 13,
    "composite_standard_score": 70,
    "confidence_interval_90": "66–81",
    "confidence_interval_95": "65–82",
    "ci_90_lower": 66,
    "ci_90_upper": 81,
    "ci_95_lower": 65,
    "ci_95_upper": 82,
    "percentile_rank": 2
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 14,
    "composite_standard_score": 71,
    "confidence_interval_90": "67–81",
    "confidence_interval_95": "66–83",
    "ci_90_lower": 67,
    "ci_90_upper": 81,
    "ci_95_lower": 66,
    "ci_95_upper": 83,
    "percentile_rank": 3
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 15,
    "composite_standard_score": 73,
    "confidence_interval_90": "69–83",
    "confidence_interval_95": "67–85",
    "ci_90_lower": 69,
    "ci_90_upper": 83,
    "ci_95_lower": 67,
    "ci_95_upper": 85,
    "percentile_rank": 4
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 16,
    "composite_standard_score": 74,
    "confidence_interval_90": "70–84",
    "confidence_interval_95": "68–86",
    "ci_90_lower": 70,
    "ci_90_upper": 84,
    "ci_95_lower": 68,
    "ci_95_upper": 86,
    "percentile_rank": 4
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 17,
    "composite_standard_score": 76,
    "confidence_interval_90": "71–86",
    "confidence_interval_95": "70–87",
    "ci_90_lower": 71,
    "ci_90_upper": 86,
    "ci_95_lower": 70,
    "ci_95_upper": 87,
    "percentile_rank": 5
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 18,
    "composite_standard_score": 77,
    "confidence_interval_90": "72–87",
    "confidence_interval_95": "71–88",
    "ci_90_lower": 72,
    "ci_90_upper": 87,
    "ci_95_lower": 71,
    "ci_95_upper": 88,
    "percentile_rank": 6
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 19,
    "composite_standard_score": 79,
    "confidence_interval_90": "74–89",
    "confidence_interval_95": "73–90",
    "ci_90_lower": 74,
    "ci_90_upper": 89,
    "ci_95_lower": 73,
    "ci_95_upper": 90,
    "percentile_rank": 8
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 20,
    "composite_standard_score": 80,
    "confidence_interval_90": "75–89",
    "confidence_interval_95": "74–91",
    "ci_90_lower": 75,
    "ci_90_upper": 89,
    "ci_95_lower": 74,
    "ci_95_upper": 91,
    "percentile_rank": 9
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 21,
    "composite_standard_score": 82,
    "confidence_interval_90": "77–91",
    "confidence_interval_95": "75–93",
    "ci_90_lower": 77,
    "ci_90_upper": 91,
    "ci_95_lower": 75,
    "ci_95_upper": 93,
    "percentile_rank": 12
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 22,
    "composite_standard_score": 84,
    "confidence_interval_90": "78–93",
    "confidence_interval_95": "77–94",
    "ci_90_lower": 78,
    "ci_90_upper": 93,
    "ci_95_lower": 77,
    "ci_95_upper": 94,
    "percentile_rank": 14
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 23,
    "composite_standard_score": 86,
    "confidence_interval_90": "80–95",
    "confidence_interval_95": "79–96",
    "ci_90_lower": 80,
    "ci_90_upper": 95,
    "ci_95_lower": 79,
    "ci_95_upper": 96,
    "percentile_rank": 18
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 24,
    "composite_standard_score": 88,
    "confidence_interval_90": "82–97",
    "confidence_interval_95": "81–98",
    "ci_90_lower": 82,
    "ci_90_upper": 97,
    "ci_95_lower": 81,
    "ci_95_upper": 98,
    "percentile_rank": 21
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 25,
    "composite_standard_score": 89,
    "confidence_interval_90": "83–97",
    "confidence_interval_95": "82–99",
    "ci_90_lower": 83,
    "ci_90_upper": 97,
    "ci_95_lower": 82,
    "ci_95_upper": 99,
    "percentile_rank": 23
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 26,
    "composite_standard_score": 91,
    "confidence_interval_90": "85–99",
    "confidence_interval_95": "83–101",
    "ci_90_lower": 85,
    "ci_90_upper": 99,
    "ci_95_lower": 83,
    "ci_95_upper": 101,
    "percentile_rank": 27
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 27,
    "composite_standard_score": 93,
    "confidence_interval_90": "86–101",
    "confidence_interval_95": "85–102",
    "ci_90_lower": 86,
    "ci_90_upper": 101,
    "ci_95_lower": 85,
    "ci_95_upper": 102,
    "percentile_rank": 32
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 28,
    "composite_standard_score": 95,
    "confidence_interval_90": "88–103",
    "confidence_interval_95": "87–104",
    "ci_90_lower": 88,
    "ci_90_upper": 103,
    "ci_95_lower": 87,
    "ci_95_upper": 104,
    "percentile_rank": 37
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 29,
    "composite_standard_score": 98,
    "confidence_interval_90": "91–106",
    "confidence_interval_95": "90–107",
    "ci_90_lower": 91,
    "ci_90_upper": 106,
    "ci_95_lower": 90,
    "ci_95_upper": 107,
    "percentile_rank": 45
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 30,
    "composite_standard_score": 100,
    "confidence_interval_90": "93–107",
    "confidence_interval_95": "91–109",
    "ci_90_lower": 93,
    "ci_90_upper": 107,
    "ci_95_lower": 91,
    "ci_95_upper": 109,
    "percentile_rank": 50
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 31,
    "composite_standard_score": 102,
    "confidence_interval_90": "94–109",
    "confidence_interval_95": "93–110",
    "ci_90_lower": 94,
    "ci_90_upper": 109,
    "ci_95_lower": 93,
    "ci_95_upper": 110,
    "percentile_rank": 55
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 32,
    "composite_standard_score": 105,
    "confidence_interval_90": "97–112",
    "confidence_interval_95": "96–113",
    "ci_90_lower": 97,
    "ci_90_upper": 112,
    "ci_95_lower": 96,
    "ci_95_upper": 113,
    "percentile_rank": 63
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 33,
    "composite_standard_score": 107,
    "confidence_interval_90": "99–114",
    "confidence_interval_95": "98–115",
    "ci_90_lower": 99,
    "ci_90_upper": 114,
    "ci_95_lower": 98,
    "ci_95_upper": 115,
    "percentile_rank": 68
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 34,
    "composite_standard_score": 109,
    "confidence_interval_90": "101–115",
    "confidence_interval_95": "99–117",
    "ci_90_lower": 101,
    "ci_90_upper": 115,
    "ci_95_lower": 99,
    "ci_95_upper": 117,
    "percentile_rank": 73
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 35,
    "composite_standard_score": 111,
    "confidence_interval_90": "103–117",
    "confidence_interval_95": "101–118",
    "ci_90_lower": 103,
    "ci_90_upper": 117,
    "ci_95_lower": 101,
    "ci_95_upper": 118,
    "percentile_rank": 77
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 36,
    "composite_standard_score": 114,
    "confidence_interval_90": "105–120",
    "confidence_interval_95": "104–121",
    "ci_90_lower": 105,
    "ci_90_upper": 120,
    "ci_95_lower": 104,
    "ci_95_upper": 121,
    "percentile_rank": 82
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 37,
    "composite_standard_score": 116,
    "confidence_interval_90": "107–122",
    "confidence_interval_95": "106–123",
    "ci_90_lower": 107,
    "ci_90_upper": 122,
    "ci_95_lower": 106,
    "ci_95_upper": 123,
    "percentile_rank": 86
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 38,
    "composite_standard_score": 118,
    "confidence_interval_90": "109–123",
    "confidence_interval_95": "107–125",
    "ci_90_lower": 109,
    "ci_90_upper": 123,
    "ci_95_lower": 107,
    "ci_95_upper": 125,
    "percentile_rank": 88
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 39,
    "composite_standard_score": 120,
    "confidence_interval_90": "111–125",
    "confidence_interval_95": "109–126",
    "ci_90_lower": 111,
    "ci_90_upper": 125,
    "ci_95_lower": 109,
    "ci_95_upper": 126,
    "percentile_rank": 91
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 40,
    "composite_standard_score": 122,
    "confidence_interval_90": "112–127",
    "confidence_interval_95": "111–128",
    "ci_90_lower": 112,
    "ci_90_upper": 127,
    "ci_95_lower": 111,
    "ci_95_upper": 128,
    "percentile_rank": 93
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 41,
    "composite_standard_score": 124,
    "confidence_interval_90": "114–129",
    "confidence_interval_95": "113–130",
    "ci_90_lower": 114,
    "ci_90_upper": 129,
    "ci_95_lower": 113,
    "ci_95_upper": 130,
    "percentile_rank": 95
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 42,
    "composite_standard_score": 126,
    "confidence_interval_90": "116–130",
    "confidence_interval_95": "114–132",
    "ci_90_lower": 116,
    "ci_90_upper": 130,
    "ci_95_lower": 114,
    "ci_95_upper": 132,
    "percentile_rank": 96
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 43,
    "composite_standard_score": 128,
    "confidence_interval_90": "118–132",
    "confidence_interval_95": "116–134",
    "ci_90_lower": 118,
    "ci_90_upper": 132,
    "ci_95_lower": 116,
    "ci_95_upper": 134,
    "percentile_rank": 97
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 44,
    "composite_standard_score": 130,
    "confidence_interval_90": "119–134",
    "confidence_interval_95": "118–135",
    "ci_90_lower": 119,
    "ci_90_upper": 134,
    "ci_95_lower": 118,
    "ci_95_upper": 135,
    "percentile_rank": 98
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 45,
    "composite_standard_score": 132,
    "confidence_interval_90": "121–136",
    "confidence_interval_95": "120–137",
    "ci_90_lower": 121,
    "ci_90_upper": 136,
    "ci_95_lower": 120,
    "ci_95_upper": 137,
    "percentile_rank": 98
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 46,
    "composite_standard_score": 134,
    "confidence_interval_90": "123–138",
    "confidence_interval_95": "122–139",
    "ci_90_lower": 123,
    "ci_90_upper": 138,
    "ci_95_lower": 122,
    "ci_95_upper": 139,
    "percentile_rank": 99
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 47,
    "composite_standard_score": 136,
    "confidence_interval_90": "125–139",
    "confidence_interval_95": "123–141",
    "ci_90_lower": 125,
    "ci_90_upper": 139,
    "ci_95_lower": 123,
    "ci_95_upper": 141,
    "percentile_rank": 99
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 48,
    "composite_standard_score": 138,
    "confidence_interval_90": "127–141",
    "confidence_interval_95": "125–142",
    "ci_90_lower": 127,
    "ci_90_upper": 141,
    "ci_95_lower": 125,
    "ci_95_upper": 142,
    "percentile_rank": 99
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 49,
    "composite_standard_score": 140,
    "confidence_interval_90": "128–143",
    "confidence_interval_95": "127–144",
    "ci_90_lower": 128,
    "ci_90_upper": 143,
    "ci_95_lower": 127,
    "ci_95_upper": 144,
    "percentile_rank": 99.6
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 50,
    "composite_standard_score": 142,
    "confidence_interval_90": "130–145",
    "confidence_interval_95": "129–146",
    "ci_90_lower": 130,
    "ci_90_upper": 145,
    "ci_95_lower": 129,
    "ci_95_upper": 146,
    "percentile_rank": 99.7
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 51,
    "composite_standard_score": 144,
    "confidence_interval_90": "132–146",
    "confidence_interval_95": "130–148",
    "ci_90_lower": 132,
    "ci_90_upper": 146,
    "ci_95_lower": 130,
    "ci_95_upper": 148,
    "percentile_rank": 99.8
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 52,
    "composite_standard_score": 146,
    "confidence_interval_90": "134–148",
    "confidence_interval_95": "132–150",
    "ci_90_lower": 134,
    "ci_90_upper": 148,
    "ci_95_lower": 132,
    "ci_95_upper": 150,
    "percentile_rank": 99.9
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 53,
    "composite_standard_score": 148,
    "confidence_interval_90": "135–150",
    "confidence_interval_95": "134–151",
    "ci_90_lower": 135,
    "ci_90_upper": 150,
    "ci_95_lower": 134,
    "ci_95_upper": 151,
    "percentile_rank": 99.9
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 54,
    "composite_standard_score": 150,
    "confidence_interval_90": "137–152",
    "confidence_interval_95": "136–153",
    "ci_90_lower": 137,
    "ci_90_upper": 152,
    "ci_95_lower": 136,
    "ci_95_upper": 153,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 55,
    "composite_standard_score": 152,
    "confidence_interval_90": "139–154",
    "confidence_interval_95": "138–155",
    "ci_90_lower": 139,
    "ci_90_upper": 154,
    "ci_95_lower": 138,
    "ci_95_upper": 155,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 56,
    "composite_standard_score": 154,
    "confidence_interval_90": "141–155",
    "confidence_interval_95": "139–157",
    "ci_90_lower": 141,
    "ci_90_upper": 155,
    "ci_95_lower": 139,
    "ci_95_upper": 157,
    "percentile_rank": ">99.9"
  },
  {
    "low_age": "9:0",
    "high_age": "9:11",
    "sum_of_scaled_scores": 57,
    "composite_standard_score": 155,
    "confidence_interval_90": "142–156",
    "confidence_interval_95": "140–158",
    "ci_90_lower": 142,
    "ci_90_upper": 156,
    "ci_95_lower": 140,
    "ci_95_upper": 158,
    "percentile_rank": ">99.9"
  }
];

function TestDELV({}: TestDELVProps) {
  const routeParams = useParams();
  const [test, setTest] = useState({} as any);
  const [schemas, setSchemas] = useState([] as any);
  const [schema, setSchema] = useState({} as any);
  const [categories, setCategories] = useState([] as any);
  const [answers, setAnswers] = useState({} as any);
  const [textAnswers, setTextAnswers] = useState({} as any);
  const [correctAnswers, setCorrectAnswers] = useState(0 as any);
  const [incorrectAnswers, setIncorrectAnswers] = useState(0 as any);
  const [blankAnswers, setBlankAnswers] = useState(0 as any);
  const [cardKey, setCardKey] = useState("" as any);
  const [showCalculations, setShowCalculations] = useState("" as any);
  const [domains, setDomains] = useState({} as any);
  const [compositeScore, setCompositeScore] = useState({} as any);
  const [subtestEntryMode, setSubtestEntryMode] = useState(true as any);
  const [subtestScores, setSubtestScores] = useState([] as any);
  const [errors, setErrors] = useState([]);
  const [testAdministrationDate, setTestAdministrationDate] = useState(null as any);

  const today = new Date();
  const currentMonth = today.getMonth();

  const [studentName, setStudentName] = useState("" as any);
  const [studentBirthdate, setStudentBirthdate] = useState("" as any);
  const [season, setSeason] = useState((currentMonth < 6 ? "Spring" : "Fall") as any);
  
  useEffect(() => {
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/schemas', {
      method: 'get',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setSchemas(data);

      for (let i = 0; i < data?.length; i++) {
        if (data[i].name == 'DELV') {
          setSchema(data[i]);
          
          let rawQuestions: any = data[i].questions;
          let groupedCategories: any = [];

          for (let j = 0; j < data[i].questions?.length; j++) {
            let categoryIndex: number = -1;
            for (let k = 0; k < groupedCategories.length; k++) {
              if (groupedCategories[k].name == data[i].questions[j].category) {
                categoryIndex = k;
                break;
              }
            }

            if (categoryIndex == -1) {
              categoryIndex = groupedCategories.length;
              groupedCategories.push({
                name: data[i].questions[j].category,
                subcategories: []
              });
            }

            let subcategoryIndex: number = -1;
            for (let k = 0; k < groupedCategories[categoryIndex].subcategories.length; k++) {
              if (groupedCategories[categoryIndex].subcategories[k].name == data[i].questions[j].subcategory) {
                subcategoryIndex = k;
                break;
              }
            }

            if (subcategoryIndex == -1) {
              subcategoryIndex = groupedCategories[categoryIndex].subcategories.length;
              groupedCategories[categoryIndex].subcategories.push({
                name: data[i].questions[j].subcategory,
                questions: []
              });
            }

            groupedCategories[categoryIndex].subcategories[subcategoryIndex].questions.push(data[i].questions[j]);
          }

          fetch(ventrisConfig.url + '/api/test/' + routeParams.testId, {
            method: 'get',
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
            }
          }).then(function (response) {
            return response.json();
          }).then(async function (data) {
            let answersUpdated: any = {};
            let textAnswersUpdated: any = {};
            let correctAnswersUpdated = 0;
            let incorrectAnswersUpdated = 0;
            let blankAnswersUpdated = 0;
            let domainsUpdated: any = {};
            let compositeScoreUpdated: any = {};

            if (data.test.subtest_entry_mode) {
              for (let i = 0; i < data.test.subtest_scores?.length; i++) {
                domainsUpdated[data.test.subtest_scores[i].subtest_name] = {
                    domain: data.test.subtest_scores[i].subtest_name,
                    score: data.test.subtest_scores[i].score
                  }
              }
            } else {
              for (let i = 0; i < data.test?.answers?.length; i++) {
                answersUpdated[data.test.answers[i].test_schema_question_id] = data.test.answers[i].test_schema_question_answer_id;
                textAnswersUpdated[data.test.answers[i].test_schema_question_id] = data.test.answers[i].text_answer;
                if (!domainsUpdated[data.test.answers[i].question?.category]) {
                  domainsUpdated[data.test.answers[i].question?.category] = {
                    domain: data.test.answers[i].question?.category,
                    score: 0
                  }
                }

                if (data.test.answers[i].test_schema_question_answer_id == 0 && data.test.answers[i].question?.answers?.length == 0) {
                  let score = parseInt(data.test.answers[i].text_answer);
                  if (!isNaN(score)) {
                    domainsUpdated[data.test.answers[i].question?.category].score += score;
                  }
                }

                for (let j = 0; j < rawQuestions?.length; j++) {
                  if (data.test.answers[i].test_schema_question_id == rawQuestions[j].id) {
                    for (let k = 0; k < rawQuestions[j].answers?.length; k++) {
                      if (rawQuestions[j].answers[k].id == data.test.answers[i].test_schema_question_answer_id) {
                        if (rawQuestions[j].answers[k].correct == 1) {
                          correctAnswersUpdated++;
                        } else {
                          incorrectAnswersUpdated++;
                        }
                        domainsUpdated[data.test.answers[i].question?.category].score += rawQuestions[j].answers[k].score;
                      }
                    }
                  }
                }
              }
            }

            blankAnswersUpdated = rawQuestions.length - correctAnswersUpdated - incorrectAnswersUpdated;

            const scaledScoreData: any = scaledScores;
            const phonologyScoreData: any = phonologyScores;
            const criticalValuesData: any = criticalValues;
            const age = ageInYearsAndMonths(data.test.student.birthdate, data.test.completed_timestamp);
            let sumOfScaledScores = 0;

            for (const i in domainsUpdated) {
              domainsUpdated[i].scaledScore = "";
              domainsUpdated[i].scaledScorePointsPlusMinus = "";
              domainsUpdated[i].confidenceIntervalLow = "";
              domainsUpdated[i].confidenceIntervalHigh = "";
              domainsUpdated[i].percentileRank = "";
              domainsUpdated[i].percentileRankConfidenceIntervalLow = "";
              domainsUpdated[i].percentileRankConfidenceIntervalHigh = "";

              if (domainsUpdated[i].domain == "Syntax Domain") {
                domainsUpdated[i].scaledScoreKey = "syntax";
              } else if (domainsUpdated[i].domain == "Pragmatics Domain") {
                domainsUpdated[i].scaledScoreKey = "pragmatics";
              } else if (domainsUpdated[i].domain == "Semantics Domain") {
                domainsUpdated[i].scaledScoreKey = "semantics";
              } else if (domainsUpdated[i].domain == "Phonology Domain") {
                domainsUpdated[i].scaledScoreKey = "phonology";
              }

              if (domainsUpdated[i].scaledScoreKey == 'phonology') {
                for (let j = 0; j < phonologyScoreData.length; j++) {
                  if (domainsUpdated[i].score == phonologyScoreData[j]['raw_score']) {
                      const lowAgeSplit = phonologyScoreData[j]['low_age'].split(":");
                      const highAgeSplit = phonologyScoreData[j]['high_age'].split(":");
                      if (age.years >= lowAgeSplit[0] &&
                          age.months >= lowAgeSplit[1] &&
                          age.years <= highAgeSplit[0] &&
                          age.months <= highAgeSplit[1]
                      ) {
                        domainsUpdated[i].scaledScore = "N/A";
                        domainsUpdated[i].scaledScorePointsPlusMinus = "N/A";
                        domainsUpdated[i].percentileRank = phonologyScoreData[j].percentile_rank;
                        break;
                      }
                  }
                }
              } else if (domainsUpdated[i].scaledScoreKey) {
                for (let j = 0; j < scaledScoreData.length; j++) {
                  if (isNumeric(scaledScoreData[j][domainsUpdated[i].scaledScoreKey + '_low']) &&
                    isNumeric(scaledScoreData[j][domainsUpdated[i].scaledScoreKey + '_high']) &&
                    domainsUpdated[i].score >= scaledScoreData[j][domainsUpdated[i].scaledScoreKey + '_low'] &&
                    domainsUpdated[i].score <= scaledScoreData[j][domainsUpdated[i].scaledScoreKey + '_high']) {
                      const lowAgeSplit = scaledScoreData[j]['low_age'].split(":");
                      const highAgeSplit = scaledScoreData[j]['high_age'].split(":");
                      if (age.years >= lowAgeSplit[0] &&
                          age.months >= lowAgeSplit[1] &&
                          age.years <= highAgeSplit[0] &&
                          age.months <= highAgeSplit[1]
                      ) {
                        domainsUpdated[i].scaledScore = scaledScoreData[j].scaled_score;
                        domainsUpdated[i].percentileRank = scaledScoreData[j].percentile_rank;
                        sumOfScaledScores += domainsUpdated[i].scaledScore;
                        break;
                      }
                  }
                }
                for (let j = 0; j < criticalValuesData.length; j++) {
                  if (criticalValuesData[j]['confidence_level'] == "95%") {
                    const lowAgeSplit = criticalValuesData[j]['low_age'].split(":");
                    const highAgeSplit = criticalValuesData[j]['high_age'].split(":");
                    if (age.years >= lowAgeSplit[0] &&
                        age.months >= lowAgeSplit[1] &&
                        age.years <= highAgeSplit[0] &&
                        age.months <= highAgeSplit[1]
                    ) {
                      domainsUpdated[i].scaledScorePointsPlusMinus = criticalValuesData[j][domainsUpdated[i].scaledScoreKey];
                      domainsUpdated[i].confidenceIntervalLow = Math.max(0, domainsUpdated[i].scaledScore - domainsUpdated[i].scaledScorePointsPlusMinus);
                      domainsUpdated[i].confidenceIntervalHigh = (domainsUpdated[i].scaledScore + domainsUpdated[i].scaledScorePointsPlusMinus);
                      domainsUpdated[i].percentileRankConfidenceIntervalLow = 0;

                      for (let k = 0; k < scaledScoreData.length; k++) {
                        if (scaledScoreData[k].scaled_score == domainsUpdated[i].confidenceIntervalLow) {
                          const lowAgeSplit = scaledScoreData[k]['low_age'].split(":");
                          const highAgeSplit = scaledScoreData[k]['high_age'].split(":");
                          if (age.years >= lowAgeSplit[0] &&
                              age.months >= lowAgeSplit[1] &&
                              age.years <= highAgeSplit[0] &&
                              age.months <= highAgeSplit[1]
                          ) {
                            domainsUpdated[i].percentileRankConfidenceIntervalLow = scaledScoreData[k].percentile_rank;
                          }
                        } else if (scaledScoreData[k].scaled_score == domainsUpdated[i].confidenceIntervalHigh) {
                          const lowAgeSplit = scaledScoreData[k]['low_age'].split(":");
                          const highAgeSplit = scaledScoreData[k]['high_age'].split(":");
                          if (age.years >= lowAgeSplit[0] &&
                              age.months >= lowAgeSplit[1] &&
                              age.years <= highAgeSplit[0] &&
                              age.months <= highAgeSplit[1]
                          ) {
                            domainsUpdated[i].percentileRankConfidenceIntervalHigh = scaledScoreData[k].percentile_rank;
                          }
                        }
                      }

                      break;
                    }
                  }
                }
              }
            }

            for (let i = 0; i < compositeScores.length; i++) {
              if (compositeScores[i]['sum_of_scaled_scores'] == sumOfScaledScores) {
                const lowAgeSplit = compositeScores[i]['low_age'].split(":");
                const highAgeSplit = compositeScores[i]['high_age'].split(":");
                if (age.years >= lowAgeSplit[0] &&
                    age.months >= lowAgeSplit[1] &&
                    age.years <= highAgeSplit[0] &&
                    age.months <= highAgeSplit[1]
                ) {
                  compositeScoreUpdated = compositeScores[i];
                  break;
                }
              }
            }

            setTest(data.test);
            setAnswers(answersUpdated);
            setTextAnswers(textAnswersUpdated);
            setCorrectAnswers(correctAnswersUpdated);
            setIncorrectAnswers(incorrectAnswersUpdated);
            setBlankAnswers(blankAnswersUpdated);
            setDomains(domainsUpdated);
            setCompositeScore(compositeScoreUpdated);
            setStudentName(data.test.student.student_code);
            setStudentBirthdate(data.test.student.birthdate);
            setSubtestEntryMode(data.test.subtest_entry_mode ?? false);
            setSubtestScores(data.test.subtest_scores ?? []);
            setCategories(groupedCategories);
            setTestAdministrationDate(data.test.completed_timestamp);
          });

          break;
        }
      }
    });
  }, []);

  const uuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  const isNumeric = (value: any) => {
    return typeof value === 'number' && !isNaN(value);
  }

  const ageInYearsAndMonths = (birthDateString: string, testCompletedDateString: string) => {
    const today = new Date(testCompletedDateString);
    const birthDate = new Date(birthDateString);

    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();

    if (today.getDate() < birthDate.getDate()) {
      months--;
    }

    if (months < 0) {
      years--;
      months += 12;
    }

    return { years, months };
  }

  const answerLetterForOrderNumber = (orderNum: number) => {
    if (orderNum == 1) {
      return "a";
    } else if (orderNum == 2) {
      return "b";
    } else if (orderNum == 3) {
      return "c";
    } else if (orderNum == 4) {
      return "d";
    } else if (orderNum == 5) {
      return "e";
    } else if (orderNum == 6) {
      return "f";
    } else if (orderNum == 7) {
      return "g";
    } else if (orderNum == 8) {
      return "h";
    } else if (orderNum == 9) {
      return "i";
    } else if (orderNum == 10) {
      return "j";
    }

    return "z";
  }

  const answerQuestion = (question: any, answer: any) => {
    let answersUpdated: any = answers;
    answersUpdated[question.id] = answer.id;
    setAnswers(answersUpdated);
    setCardKey(uuidv4());

    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/' + routeParams.testId + '/answer', {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        answers: JSON.stringify(answersUpdated),
        text_answers: JSON.stringify(textAnswers),
        subtest_scores: JSON.stringify(subtestScores)
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      console.log(data);
    });
  }

  const updateTextAnswer = (question: any, answer: any) => {
    let answersUpdated: any = textAnswers;
    answersUpdated[question.id] = answer;
    setTextAnswers(answersUpdated);

    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/' + routeParams.testId + '/answer', {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        answers: JSON.stringify(answers),
        text_answers: JSON.stringify(answersUpdated),
        subtest_scores: JSON.stringify(subtestScores)
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      console.log(data);
    });
  }

  const scoreForSubtest = (subtest: any) => {
    for (let i = 0; i < subtestScores?.length; i++) {
      if (subtestScores[i].subtest_name == subtest) {
        return subtestScores[i].score;
      }
    }
    
    return null;
  }

  const updateSubtestScore = (subtest: any, score: any) => {
    let found = false;
    for (let i = 0; i < subtestScores?.length; i++) {
      if (subtestScores[i].subtest_name == subtest) {
        found = true;
        subtestScores[i].score = score;
      }
    }
    if (!found) {
      subtestScores.push({
        subtest_name: subtest,
        score: score
      });
    }
    setSubtestScores(subtestScores);

    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/' + routeParams.testId + '/answer', {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        answers: JSON.stringify(answers),
        text_answers: JSON.stringify(textAnswers),
        subtest_scores: JSON.stringify(subtestScores)
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      console.log(data);
    });
  }

  const completeTest = () => {
    let errors: any = [];
    
    if (!testAdministrationDate || season == '') {
      errors.push("Test Administration Date and Season are both required before computing scores!");
    }

    if (subtestEntryMode) {
      for (let i = 0; i < subtestScores?.length; i++) {
        console.log(subtests[subtestScores[i].subtest_name]);
        if (subtestScores[i].score < 0) {
          errors.push("The minimum score for subtest " + subtestScores[i].subtest_name + " is 0.");
        } else if (subtests[subtestScores[i].subtest_name] && subtests[subtestScores[i].subtest_name].maxScore && subtestScores[i].score > subtests[subtestScores[i].subtest_name].maxScore) {
          errors.push("The maximum score for subtest " + subtestScores[i].subtest_name + " is " + subtests[subtestScores[i].subtest_name].maxScore + ".");
        }
      }
    }

    setErrors(errors);

    if (errors.length > 0) {
      return;
    }

    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/' + routeParams.testId, {
      method: 'put',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        name: test.name,
        code: test.code,
        status: "Complete",
        subtest_entry_mode: subtestEntryMode
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      console.log(data);
      document.location.href = "/tests";
    });
  }

  const saveSubtestEntryMode = (mode: boolean) => {
    setSubtestEntryMode(mode);

    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/' + routeParams.testId, {
      method: 'put',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        name: test.name,
        code: test.code,
        status: test.status,
        subtest_entry_mode: mode
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      console.log(data);
    });
  }

  const saveCompletedTimestamp = (date: string) => {
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/' + routeParams.testId, {
      method: 'put',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        name: test.name,
        code: test.code,
        status: test.status,
        subtest_entry_mode: subtestEntryMode,
        completed_timestamp: date
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      console.log(data);
      setTestAdministrationDate(date);
    });
  }

  const thetaValueForAnswer = (answer: any, theta: any) => {
    for (let i = 0; i < answer.theta?.length; i++) {
      if (answer.theta[i].theta == theta) {
        return answer.theta[i].p;
      }
    }
    return 0;
  }

  const likelihoodValueForTheta = (theta: any) => {
    for (let i = 0; i < test.likelihood?.length; i++) {
      if (test.likelihood[i].domain == showCalculations) {
        for (let j = 0; j < test.likelihood[i].thetas?.length; j++) {
          if (test.likelihood[i].thetas[j].theta == theta) {
            return test.likelihood[i].thetas[j].likelihood;
          }
        }
      }
    }
    return 0;
  }

  return (
    <Container fluid className="ventris-content-wrapper">
      <Header portal={sessionStorage.getItem("portal")!} page="tests" />
      <Container as="main" id="main-content" tabIndex={-1}>
        <Row>
          <Col>
            <h1 className="page-header">DELV Test {test.status == "Complete" ? "Results" : "Data Entry"}</h1>
            {test.status !== "Complete" ?
            <Card className="content-card" key={cardKey}>
              <div className="flex flex-row">
                <h5 className="flex-grow">Student: {studentName} (Birthdate: {studentBirthdate})</h5>
              </div>
              <br />
              <div className="flex flex-row">
                <div className="flex flex-row flex-grow">
                  <div className="test-date-caption">Test Administration Date:</div>
                  <Form.Control type="date" placeholder="Test Administration Date" className="test-answer-inline test-date-input" defaultValue={test?.completed_timestamp?.split(' ')[0]} onChange={(event) => saveCompletedTimestamp(event.target.value)} />
                </div>
                <Dropdown style={{display: 'none'}}>
                  <Dropdown.Toggle id="delv-score-entry-mode-menu">
                    Manually Enter Subtest Scores: {subtestEntryMode ? 'Yes' : 'No'}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item as="button" type="button" onClick={() => saveSubtestEntryMode(false)}>No</Dropdown.Item>
                    <Dropdown.Item as="button" type="button" onClick={() => saveSubtestEntryMode(true)}>Yes</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <p className="timestamp-instructions">Enter (or choose) the date the test was administered, not the date you are entering data.</p>
              {subtestEntryMode ?
              <div>
                <Table bordered>
                  <thead>
                    <tr>
                      <th>Subtest</th>
                      <th>Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    {categories.map((category: any) => 
                      <>
                        {category.name == 'Syntax Domain' || category.name == 'Pragmatics Domain' || category.name == 'Semantics Domain' || category.name == 'Phonology Domain' ?
                        <tr>
                          <td>{category.name}</td>
                          <td><Form.Control type="number" placeholder="Enter Score Here" className="test-answer-numeric-inline" defaultValue={scoreForSubtest(category.name)} onChange={(event) => updateSubtestScore(category.name, event.target.value)} /></td>
                        </tr> : null}
                      </>
                    )}
                  </tbody>
                </Table>
              </div> :
              <div>
                {categories.map((category: any) => 
                  <>
                    <h3 className="test-category">{category.name}</h3>
                    {category.subcategories?.map((subcategory: any) => 
                      <>
                        {subcategory.name != '' ? <h4 className="test-subcategory">{subcategory.name}</h4> : null }
                        {subcategory.questions?.map((question: any) => 
                          <>
                            <div className="test-question">{question.order_num}. <span dangerouslySetInnerHTML={{__html: question.question}}></span></div>
                            <Form.Control as="textarea" rows={1} className="test-answer-textarea" defaultValue={textAnswers[question.id]} onChange={(event) => updateTextAnswer(question, event.target.value)} />
                            {question.answers?.map((answer: any) => 
                              <button className={answers[question.id] == answer.id ? "test-answer-selected": "test-answer"} onClick={() => answerQuestion(question, answer)}>
                                {(answer.answer == "A" || answer.answer == "B" || answer.answer == "C" || answer.answer == "NR") ?
                                <>
                                  <div className={answer.correct ? 'test-answer-correct' : 'test-answer-incorrect'}><span dangerouslySetInnerHTML={{__html: answer.answer}}></span></div>
                                  <div className="test-answer-caption" dangerouslySetInnerHTML={{__html: answer.caption}}></div>
                                </> :
                                <>
                                  <div className={answer.correct ? 'test-answer-correct' : 'test-answer-incorrect'}>{answerLetterForOrderNumber(answer.order_num)}. <span dangerouslySetInnerHTML={{__html: answer.answer}}></span></div>
                                  <div className="test-answer-caption" dangerouslySetInnerHTML={{__html: answer.caption}}></div>
                                </> }
                              </button>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>}
              <br />
              { errors.length > 0 ?
              <div role="alert" className="ventris-form-error">
                The following validation errors must be resolved before you can complete this test:
                <br /><br />
                {errors.map((error: any) => 
                  <div>{error}</div>
                )}
              </div> : null }
              <br />
              <Button onClick={() => completeTest()}>Compute Scores</Button>
              <br /><br />
            </Card> : null }
            {test.status === "Complete" && subtestEntryMode ?
            <Card className="content-card" key={cardKey}>
              <div className="flex flex-row">
                <h5 className="flex-grow">Student: {studentName} (Birthdate: {studentBirthdate})</h5>
              </div>
              <br />
              This test has been completed! Completion Date: {test.completed_timestamp?.split(' ')[0]}
              <br /><br />
              <Table bordered>
                <thead>
                  <tr>
                    <th>Subtest</th>
                    <th>Raw Score</th>
                  </tr>
                </thead>
                <tbody>
                  {categories.map((category: any) => 
                    <>
                      {category.name == 'Syntax Domain' || category.name == 'Pragmatics Domain' || category.name == 'Semantics Domain' || category.name == 'Phonology Domain' ?
                      <tr>
                        <td>{category.name}</td>
                        <td>{scoreForSubtest(category.name)}</td>
                      </tr> : null}
                    </>
                  )}
                </tbody>
              </Table>
              <br />
              <h5>Subtest Report</h5>
              <br />
              <Table bordered>
                <thead>
                  <tr>
                    <th>Subtest</th>
                    <th>Raw Score</th>
                    <th>Scaled Score</th>
                    <th>Scaled Score +/-</th>
                    <th>Confidence Interval 95% Level</th>
                    <th>Percentile Rank</th>
                    <th>Percentile Rank Confidence Interval</th>
                  </tr>
                </thead>
                <tbody>
                  {categories.map((category: any) => 
                    <>
                      {domains[category.name] && domains[category.name].scaledScore != '' ?
                      <tr>
                        <td>{category.name}</td>
                        <td>{domains[category.name] ? domains[category.name].score : 0}</td>
                        <td>{domains[category.name] ? domains[category.name].scaledScore : 0}</td>
                        <td>{domains[category.name] ? domains[category.name].scaledScorePointsPlusMinus : 0}</td>
                        {domains[category.name].scaledScore == 'N/A' ?
                        <td>N/A</td> :
                        <td>{domains[category.name] ? (domains[category.name].confidenceIntervalLow + " to " + domains[category.name].confidenceIntervalHigh) : 0}</td>}
                        <td>{domains[category.name] ? domains[category.name].percentileRank : 0}</td>
                        {domains[category.name].scaledScore == 'N/A' ?
                        <td>N/A</td> :
                        <td>{domains[category.name] ? (domains[category.name].percentileRankConfidenceIntervalLow + " to " + domains[category.name].percentileRankConfidenceIntervalHigh) : 0}</td>}
                      </tr> : null}
                    </>
                  )}
                </tbody>
              </Table>
              <br />
              <h5>Composite Score</h5>
              <br />
              <Table bordered>
                <thead>
                  <tr>
                    <th>Composite Standard Score</th>
                    <th>Confidence Interval 95% Level</th>
                    <th>Percentile Rank</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{compositeScore.composite_standard_score ? compositeScore.composite_standard_score : 'N/A'}</td>
                    <td>{compositeScore.confidence_interval_95 ? compositeScore.confidence_interval_95.replace('–', ' to ') : 'N/A'}</td>
                    <td>{compositeScore.percentile_rank ? compositeScore.percentile_rank : 'N/A'}</td>
                  </tr>
                </tbody>
              </Table>
            </Card> : null}
            {test.status === "Complete" && !subtestEntryMode ?
            <Card className="content-card" key={cardKey}>
              <div className="flex flex-row">
                <h5 className="flex-grow">Student: {studentName} (Birthdate: {studentBirthdate})</h5>
              </div>
              <br />
              This test has been completed! Completion Date: {test.completed_timestamp?.split(' ')[0]}
              <br /><br />
              <Table bordered>
                <thead>
                  <tr>
                    <th className="td-center">Correct Answers</th>
                    <th className="td-center">Incorrect Answers</th>
                    <th className="td-center">Blank Answers</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="td-center">{correctAnswers}</td>
                    <td className="td-center">{incorrectAnswers}</td>
                    <td className="td-center">{blankAnswers}</td>
                  </tr>
                </tbody>
              </Table>
              <br />
              <Table bordered>
                <thead>
                  <tr>
                    <th className="td-center">Subtest</th>
                    <th className="td-center">Theta Score</th>
                    <th className="td-center"></th>
                  </tr>
                </thead>
                <tbody>
                  {test?.max_likelihood?.map((domain: any) => 
                    <tr>
                      <td className="td-center">{domain.domain}</td>
                      <td className="td-center">{domain.theta.toFixed(2)}</td>
                      <td className="td-center"><Button variant="link" onClick={() => setShowCalculations(domain.domain)}>Show Calculations</Button></td>
                    </tr>
                  )}
                </tbody>
              </Table>
              {showCalculations != "" ?
              <>
                <br />
                <h4>Calculations: {showCalculations}</h4>
                <div className="calculations-wrapper">
                  <Table size="sm" bordered>
                    <thead>
                      <tr>
                        <th></th>
                        {test?.sorted_answers?.map((answer: any) =>
                          <>
                            {answer.question?.category == showCalculations ? <th>{answer.question?.order_num}</th> : null}
                          </>
                        )}
                        <th>Likelihood</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Discrimination</td>
                        {test?.sorted_answers?.map((answer: any) =>
                          <>
                            {answer.question?.category == showCalculations ? <td>{answer.question?.discrimination}</td> : null}
                          </>
                        )}
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>Difficulty</td>
                        {test?.sorted_answers?.map((answer: any) =>
                          <>
                            {answer.question?.category == showCalculations ? <td>{answer.question?.difficulty}</td> : null}
                          </>
                        )}
                        <td></td>
                      </tr>
                      <tr>
                        <td>Pseudo-Guessing</td>
                        {test?.sorted_answers?.map((answer: any) =>
                          <>
                            {answer.question?.category == showCalculations ? <td>0</td> : null}
                          </>
                        )}
                        <td></td>
                      </tr>
                      <tr>
                        <td>Reponses</td>
                        {test?.sorted_answers?.map((answer: any) =>
                          <>
                            {answer.question?.category == showCalculations ? <td>{answer.answer?.correct}</td> : null}
                          </>
                        )}
                        <td></td>
                      </tr>
                      <tr>
                        <td>IRT</td>
                        {test?.sorted_answers?.map((answer: any) =>
                          <>
                            {answer.question?.category == showCalculations ? <td>{answer.irt}</td> : null}
                          </>
                        )}
                        <td></td>
                      </tr>
                      {test?.sorted_answers[0].theta?.map((theta: any) => 
                        <tr>
                          <td>Theta: {theta.theta?.toFixed(2)}</td>
                          {test?.sorted_answers?.map((answer: any) =>
                            <>
                              {answer.question?.category == showCalculations ? <td>{thetaValueForAnswer(answer, theta.theta)}</td> : null}
                            </>
                          )}
                          <td>{likelihoodValueForTheta(theta.theta)}</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  <br />
                  <Table size="sm" bordered>
                    <thead>
                      <tr>
                        <th>Theta</th>
                        <th>Maximum Likelihood</th>
                        <th>Maximum Likelihood Theta Value</th>
                        <th>TIF</th>
                        <th>SE</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>0.58</td>
                        <td>
                          {test?.max_likelihood?.map((likelihood: any) =>
                            <>
                              {likelihood.domain == showCalculations ? likelihood.likelihood : null}
                            </>
                          )}
                        </td>
                        <td>
                          {test?.max_likelihood?.map((likelihood: any) =>
                            <>
                              {likelihood.domain == showCalculations ? likelihood.theta?.toFixed(2) : null}
                            </>
                          )}
                        </td>
                        <td>
                          {test?.max_likelihood?.map((likelihood: any) =>
                            <>
                              {likelihood.domain == showCalculations ? likelihood.tif : null}
                            </>
                          )}
                        </td>
                        <td>
                          {test?.max_likelihood?.map((likelihood: any) =>
                            <>
                              {likelihood.domain == showCalculations ? likelihood.se : null}
                            </>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </> : null }
            </Card> : null }
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default TestDELV;
